var Sg = Object.defineProperty, Eg = Object.defineProperties;
var Cg = Object.getOwnPropertyDescriptors;
var $c = Object.getOwnPropertySymbols;
var Ag = Object.prototype.hasOwnProperty, Tg = Object.prototype.propertyIsEnumerable;
var Yc = (r, o, n) => o in r ? Sg(r, o, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[o] = n, kt = (r, o) => {
  for (var n in o || (o = {}))
    Ag.call(o, n) && Yc(r, n, o[n]);
  if ($c)
    for (var n of $c(o))
      Tg.call(o, n) && Yc(r, n, o[n]);
  return r;
}, ce = (r, o) => Eg(r, Cg(o));
var Nt = (r, o, n) => new Promise((s, c) => {
  var f = (_) => {
    try {
      y(n.next(_));
    } catch (p) {
      c(p);
    }
  }, g = (_) => {
    try {
      y(n.throw(_));
    } catch (p) {
      c(p);
    }
  }, y = (_) => _.done ? s(_.value) : Promise.resolve(_.value).then(f, g);
  y((n = n.apply(r, o)).next());
});
var xg = Object.defineProperty, Og = (r, o, n) => o in r ? xg(r, o, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[o] = n, xt = (r, o, n) => (Og(r, typeof o != "symbol" ? o + "" : o, n), n), pr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ng(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var pu = { exports: {} }, du = { exports: {} };
(function() {
  var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", o = {
    // Bit-wise rotation left
    rotl: function(n, s) {
      return n << s | n >>> 32 - s;
    },
    // Bit-wise rotation right
    rotr: function(n, s) {
      return n << 32 - s | n >>> s;
    },
    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      if (n.constructor == Number)
        return o.rotl(n, 8) & 16711935 | o.rotl(n, 24) & 4278255360;
      for (var s = 0; s < n.length; s++)
        n[s] = o.endian(n[s]);
      return n;
    },
    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var s = []; n > 0; n--)
        s.push(Math.floor(Math.random() * 256));
      return s;
    },
    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(n) {
      for (var s = [], c = 0, f = 0; c < n.length; c++, f += 8)
        s[f >>> 5] |= n[c] << 24 - f % 32;
      return s;
    },
    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(n) {
      for (var s = [], c = 0; c < n.length * 32; c += 8)
        s.push(n[c >>> 5] >>> 24 - c % 32 & 255);
      return s;
    },
    // Convert a byte array to a hex string
    bytesToHex: function(n) {
      for (var s = [], c = 0; c < n.length; c++)
        s.push((n[c] >>> 4).toString(16)), s.push((n[c] & 15).toString(16));
      return s.join("");
    },
    // Convert a hex string to a byte array
    hexToBytes: function(n) {
      for (var s = [], c = 0; c < n.length; c += 2)
        s.push(parseInt(n.substr(c, 2), 16));
      return s;
    },
    // Convert a byte array to a base-64 string
    bytesToBase64: function(n) {
      for (var s = [], c = 0; c < n.length; c += 3)
        for (var f = n[c] << 16 | n[c + 1] << 8 | n[c + 2], g = 0; g < 4; g++)
          c * 8 + g * 6 <= n.length * 8 ? s.push(r.charAt(f >>> 6 * (3 - g) & 63)) : s.push("=");
      return s.join("");
    },
    // Convert a base-64 string to a byte array
    base64ToBytes: function(n) {
      n = n.replace(/[^A-Z0-9+\/]/ig, "");
      for (var s = [], c = 0, f = 0; c < n.length; f = ++c % 4)
        f != 0 && s.push((r.indexOf(n.charAt(c - 1)) & Math.pow(2, -2 * f + 8) - 1) << f * 2 | r.indexOf(n.charAt(c)) >>> 6 - f * 2);
      return s;
    }
  };
  du.exports = o;
})();
var Bg = du.exports, Zi = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(r) {
      return Zi.bin.stringToBytes(unescape(encodeURIComponent(r)));
    },
    // Convert a byte array to a string
    bytesToString: function(r) {
      return decodeURIComponent(escape(Zi.bin.bytesToString(r)));
    }
  },
  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(r) {
      for (var o = [], n = 0; n < r.length; n++)
        o.push(r.charCodeAt(n) & 255);
      return o;
    },
    // Convert a byte array to a string
    bytesToString: function(r) {
      for (var o = [], n = 0; n < r.length; n++)
        o.push(String.fromCharCode(r[n]));
      return o.join("");
    }
  }
}, Qc = Zi;
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var Rg = function(r) {
  return r != null && (yu(r) || Ig(r) || !!r._isBuffer);
};
function yu(r) {
  return !!r.constructor && typeof r.constructor.isBuffer == "function" && r.constructor.isBuffer(r);
}
function Ig(r) {
  return typeof r.readFloatLE == "function" && typeof r.slice == "function" && yu(r.slice(0, 0));
}
(function() {
  var r = Bg, o = Qc.utf8, n = Rg, s = Qc.bin, c = function(f, g) {
    f.constructor == String ? g && g.encoding === "binary" ? f = s.stringToBytes(f) : f = o.stringToBytes(f) : n(f) ? f = Array.prototype.slice.call(f, 0) : !Array.isArray(f) && f.constructor !== Uint8Array && (f = f.toString());
    for (var y = r.bytesToWords(f), _ = f.length * 8, p = 1732584193, m = -271733879, d = -1732584194, l = 271733878, u = 0; u < y.length; u++)
      y[u] = (y[u] << 8 | y[u] >>> 24) & 16711935 | (y[u] << 24 | y[u] >>> 8) & 4278255360;
    y[_ >>> 5] |= 128 << _ % 32, y[(_ + 64 >>> 9 << 4) + 14] = _;
    for (var k = c._ff, C = c._gg, S = c._hh, L = c._ii, u = 0; u < y.length; u += 16) {
      var Y = p, H = m, R = d, U = l;
      p = k(p, m, d, l, y[u + 0], 7, -680876936), l = k(l, p, m, d, y[u + 1], 12, -389564586), d = k(d, l, p, m, y[u + 2], 17, 606105819), m = k(m, d, l, p, y[u + 3], 22, -1044525330), p = k(p, m, d, l, y[u + 4], 7, -176418897), l = k(l, p, m, d, y[u + 5], 12, 1200080426), d = k(d, l, p, m, y[u + 6], 17, -1473231341), m = k(m, d, l, p, y[u + 7], 22, -45705983), p = k(p, m, d, l, y[u + 8], 7, 1770035416), l = k(l, p, m, d, y[u + 9], 12, -1958414417), d = k(d, l, p, m, y[u + 10], 17, -42063), m = k(m, d, l, p, y[u + 11], 22, -1990404162), p = k(p, m, d, l, y[u + 12], 7, 1804603682), l = k(l, p, m, d, y[u + 13], 12, -40341101), d = k(d, l, p, m, y[u + 14], 17, -1502002290), m = k(m, d, l, p, y[u + 15], 22, 1236535329), p = C(p, m, d, l, y[u + 1], 5, -165796510), l = C(l, p, m, d, y[u + 6], 9, -1069501632), d = C(d, l, p, m, y[u + 11], 14, 643717713), m = C(m, d, l, p, y[u + 0], 20, -373897302), p = C(p, m, d, l, y[u + 5], 5, -701558691), l = C(l, p, m, d, y[u + 10], 9, 38016083), d = C(d, l, p, m, y[u + 15], 14, -660478335), m = C(m, d, l, p, y[u + 4], 20, -405537848), p = C(p, m, d, l, y[u + 9], 5, 568446438), l = C(l, p, m, d, y[u + 14], 9, -1019803690), d = C(d, l, p, m, y[u + 3], 14, -187363961), m = C(m, d, l, p, y[u + 8], 20, 1163531501), p = C(p, m, d, l, y[u + 13], 5, -1444681467), l = C(l, p, m, d, y[u + 2], 9, -51403784), d = C(d, l, p, m, y[u + 7], 14, 1735328473), m = C(m, d, l, p, y[u + 12], 20, -1926607734), p = S(p, m, d, l, y[u + 5], 4, -378558), l = S(l, p, m, d, y[u + 8], 11, -2022574463), d = S(d, l, p, m, y[u + 11], 16, 1839030562), m = S(m, d, l, p, y[u + 14], 23, -35309556), p = S(p, m, d, l, y[u + 1], 4, -1530992060), l = S(l, p, m, d, y[u + 4], 11, 1272893353), d = S(d, l, p, m, y[u + 7], 16, -155497632), m = S(m, d, l, p, y[u + 10], 23, -1094730640), p = S(p, m, d, l, y[u + 13], 4, 681279174), l = S(l, p, m, d, y[u + 0], 11, -358537222), d = S(d, l, p, m, y[u + 3], 16, -722521979), m = S(m, d, l, p, y[u + 6], 23, 76029189), p = S(p, m, d, l, y[u + 9], 4, -640364487), l = S(l, p, m, d, y[u + 12], 11, -421815835), d = S(d, l, p, m, y[u + 15], 16, 530742520), m = S(m, d, l, p, y[u + 2], 23, -995338651), p = L(p, m, d, l, y[u + 0], 6, -198630844), l = L(l, p, m, d, y[u + 7], 10, 1126891415), d = L(d, l, p, m, y[u + 14], 15, -1416354905), m = L(m, d, l, p, y[u + 5], 21, -57434055), p = L(p, m, d, l, y[u + 12], 6, 1700485571), l = L(l, p, m, d, y[u + 3], 10, -1894986606), d = L(d, l, p, m, y[u + 10], 15, -1051523), m = L(m, d, l, p, y[u + 1], 21, -2054922799), p = L(p, m, d, l, y[u + 8], 6, 1873313359), l = L(l, p, m, d, y[u + 15], 10, -30611744), d = L(d, l, p, m, y[u + 6], 15, -1560198380), m = L(m, d, l, p, y[u + 13], 21, 1309151649), p = L(p, m, d, l, y[u + 4], 6, -145523070), l = L(l, p, m, d, y[u + 11], 10, -1120210379), d = L(d, l, p, m, y[u + 2], 15, 718787259), m = L(m, d, l, p, y[u + 9], 21, -343485551), p = p + Y >>> 0, m = m + H >>> 0, d = d + R >>> 0, l = l + U >>> 0;
    }
    return r.endian([p, m, d, l]);
  };
  c._ff = function(f, g, y, _, p, m, d) {
    var l = f + (g & y | ~g & _) + (p >>> 0) + d;
    return (l << m | l >>> 32 - m) + g;
  }, c._gg = function(f, g, y, _, p, m, d) {
    var l = f + (g & _ | y & ~_) + (p >>> 0) + d;
    return (l << m | l >>> 32 - m) + g;
  }, c._hh = function(f, g, y, _, p, m, d) {
    var l = f + (g ^ y ^ _) + (p >>> 0) + d;
    return (l << m | l >>> 32 - m) + g;
  }, c._ii = function(f, g, y, _, p, m, d) {
    var l = f + (y ^ (g | ~_)) + (p >>> 0) + d;
    return (l << m | l >>> 32 - m) + g;
  }, c._blocksize = 16, c._digestsize = 16, pu.exports = function(f, g) {
    if (f == null)
      throw new Error("Illegal argument " + f);
    var y = r.wordsToBytes(c(f, g));
    return g && g.asBytes ? y : g && g.asString ? s.bytesToString(y) : r.bytesToHex(y);
  };
})();
var Lg = pu.exports;
const Ug = /* @__PURE__ */ Ng(Lg);
var wn = /* @__PURE__ */ ((r) => (r.MAIN = "main", r.NEXT = "next", r))(wn || {}), Ye = /* @__PURE__ */ ((r) => (r.USER = "User", r.TOKEN = "Token", r))(Ye || {});
class yr {
  static getSessionStorageDataByKey(o, n = !0) {
    return Nt(this, null, function* () {
      if (typeof chrome < "u" && typeof chrome.storage < "u") {
        const s = yield chrome.storage.session.get(o);
        if (s[o])
          return n ? JSON.parse(s[o]) : s[o];
      }
      if (typeof window < "u") {
        const s = window.sessionStorage.getItem(o);
        if (s)
          return n ? JSON.parse(s) : s;
      }
    });
  }
  static updateSessionStorageKey(o, n) {
    return Nt(this, null, function* () {
      typeof chrome < "u" && typeof chrome.storage < "u" && (yield chrome.storage.session.set({
        [o]: JSON.stringify(n)
      })), typeof window < "u" && window.sessionStorage.setItem(o, JSON.stringify(n));
    });
  }
  static clearSessionStorage() {
    typeof chrome < "u" && typeof chrome.storage < "u" && chrome.storage.session.clear(), typeof window < "u" && window.sessionStorage.clear();
  }
}
class jg {
  constructor(o) {
    xt(this, "delay", 1e3), xt(this, "lastLoginTimestamp"), xt(this, "token"), xt(this, "storageKey"), this.eventsSdkClass = o, this.eventsSdkClass = o, this.storageKey = "";
  }
  login(o) {
    return Nt(this, null, function* () {
      const n = {
        token: o.token,
        email: o.email,
        password: o.password
      };
      this.storageKey = Ug(JSON.stringify(ce(kt({}, o), {
        loggerSocketConnection: null
      }))), !(this.lastLoginTimestamp && this.lastLoginTimestamp + this.delay > (/* @__PURE__ */ new Date()).getTime()) && (this.updateLastLoginTimestamp(), (yield this.checkLoginStatus(this.storageKey)) || (yr.clearSessionStorage(), yield this.userLoginFunction(n, this.storageKey, o.loginType)));
    });
  }
  updateLastLoginTimestamp() {
    this.lastLoginTimestamp = (/* @__PURE__ */ new Date()).getTime();
  }
  checkLoginStatus(o) {
    return Nt(this, null, function* () {
      const n = yield yr.getSessionStorageDataByKey(o);
      return n ? (this.onLoginResponse(n), !0) : !1;
    });
  }
  userLoginFunction(o, n, s) {
    return Nt(this, null, function* () {
      let c, f, g;
      this.eventsSdkClass.options.isNewStack ? (c = yield this.externalLogin(
        this.eventsSdkClass.options.loginUrl,
        o,
        s
      ), f = yield this.getSettings(c.Data.AccessToken), g = kt(kt({}, c.Data), f)) : (c = yield this.externalLogin(
        this.eventsSdkClass.options.loginUrl,
        o,
        s
      ), g = kt({}, c.Data.Socket)), this.onLoginResponse(g), yield yr.updateSessionStorageKey(n, g);
    });
  }
  onLoginResponse(o) {
    if (!this.eventsSdkClass.options.isNewStack && this.eventsSdkClass.options.servers && (this.eventsSdkClass.servers = [...this.eventsSdkClass.options.servers], this.eventsSdkClass.server = this.eventsSdkClass.servers.reduce(
      (n, s) => n.Priority > s.Priority ? n : s
    )), this.eventsSdkClass.options.isNewStack && this.eventsSdkClass.options.servers && (this.eventsSdkClass.servers = [...this.eventsSdkClass.options.servers], this.eventsSdkClass.server = this.eventsSdkClass.servers.reduce(
      (n, s) => n.Priority > s.Priority ? n : s
    )), o.MonitorList && o.MonitorList.length && (this.eventsSdkClass.servers = [...o.MonitorList], this.eventsSdkClass.server = this.eventsSdkClass.servers.reduce(
      (n, s) => n.Priority > s.Priority ? n : s
    )), !this.eventsSdkClass.options.isNewStack && !this.eventsSdkClass.servers.length && o.URLList && (this.eventsSdkClass.URLList = o.URLList), !this.eventsSdkClass.options.isNewStack && !this.eventsSdkClass.URLList.length && !this.eventsSdkClass.servers.length)
      throw new Error("Socket servers not defined");
    if (this.eventsSdkClass.options.isNewStack && !this.eventsSdkClass.servers.length)
      throw new Error("Socket servers not defined");
    this.eventsSdkClass.server && this.eventsSdkClass.socketIoClass.getSocketIoFunction(`v=${this.eventsSdkClass.server.Version}`), !this.eventsSdkClass.server && this.eventsSdkClass.URLList.length && this.eventsSdkClass.socketIoClass.getSocketIoFunction(`v=${o.Client}`), o.IdentityCode && (this.token = o.IdentityCode, this.eventsSdkClass.connect(wn.MAIN)), o.Token && (this.token = o.Token, this.eventsSdkClass.connect(wn.MAIN)), o.RefreshToken && o.IdentityCodeExpiry && this.eventsSdkClass.options.loginType === Ye.USER && (this.eventsSdkClass.options.refreshToken = o.RefreshToken, this.eventsSdkClass.options.tokenExpiry = o.IdentityCodeExpiry, this.handleTokenExpiry()), o.RefreshToken && o.TokenExpiry && this.eventsSdkClass.options.loginType === Ye.USER && (this.eventsSdkClass.options.refreshToken = o.RefreshToken, this.eventsSdkClass.options.tokenExpiry = o.TokenExpiry, this.handleTokenExpiry());
  }
  handleTokenExpiry() {
    if (!this.eventsSdkClass.options.refreshTokenUrl)
      throw new Error("refreshTokenUrl not provided");
    let o;
    if (this.eventsSdkClass.options.tokenExpiry)
      o = new Date(this.eventsSdkClass.options.tokenExpiry);
    else
      return;
    const n = o.getTime() - (/* @__PURE__ */ new Date()).getTime() - 5e3, s = Math.min(n, 2147483647);
    setTimeout(
      () => Nt(this, null, function* () {
        if (this.eventsSdkClass.options.refreshToken) {
          this.eventsSdkClass.socketIoClass.closeAllConnections();
          let c, f;
          if (this.eventsSdkClass.options.isNewStack) {
            const g = yield this.refreshToken(
              this.eventsSdkClass.options.refreshTokenUrl,
              this.eventsSdkClass.options.refreshToken
            );
            c = yield this.getSettings(g.Data.AccessToken), f = kt(kt({}, g.Data), c);
          } else
            f = kt({}, (yield this.refreshToken(
              this.eventsSdkClass.options.refreshTokenUrl,
              this.eventsSdkClass.options.refreshToken
            )).Data.Socket);
          this.onLoginResponse(f), yield yr.updateSessionStorageKey(this.storageKey, f);
        }
      }),
      s
    );
  }
  externalLogin(g, y, _) {
    return Nt(this, arguments, function* (o, { password: n, token: s, email: c }, f) {
      if (!o)
        throw new Error("loginUrl not provided");
      let p;
      this.eventsSdkClass.options.isNewStack ? f === Ye.TOKEN ? p = JSON.stringify({
        identityType: Ye.TOKEN,
        token: s
      }) : p = JSON.stringify({
        identityType: Ye.USER,
        username: c,
        password: n
      }) : this.eventsSdkClass.options.loginType === Ye.TOKEN ? (p = JSON.stringify({ token: s }), o = `${o}/${Ye.TOKEN}`) : (p = JSON.stringify({
        email: c,
        pin: n
      }), o = `${o}/${Ye.USER}`);
      try {
        const m = yield fetch(o, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: p
        });
        if (!m.ok && m.status === 400)
          throw new Error("Bad body request. Login type or isNewStack values not correct or not provided");
        if (!m.ok && m.status === 401)
          throw new Error("Unauthorized. Invalid token provided");
        if (!m.ok && m.status === 403)
          throw new Error("Forbidden. Identity token not provided or not valid");
        const d = yield m.json();
        if (d.error)
          throw new Error(d.error);
        return d;
      } catch (m) {
        throw m;
      }
    });
  }
  getSettings(o) {
    return Nt(this, null, function* () {
      try {
        if (!this.eventsSdkClass.options.getSettingsUrl)
          throw new Error("getSettingsUrl not provided");
        const n = yield fetch(this.eventsSdkClass.options.getSettingsUrl, {
          headers: {
            Authorization: `Bearer ${o}`
          }
        });
        if (!n.ok && n.status === 401)
          throw new Error("Unauthorized. Access token not provided or not valid");
        return n.json();
      } catch (n) {
        throw n;
      }
    });
  }
  refreshToken(o, n) {
    return Nt(this, null, function* () {
      try {
        return (yield fetch(o, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${n}`
          }
        })).json();
      } catch (s) {
        throw s;
      }
    });
  }
}
var go = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
go.exports;
(function(r, o) {
  (function() {
    var n, s = "4.17.21", c = 200, f = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", g = "Expected a function", y = "Invalid `variable` option passed into `_.template`", _ = "__lodash_hash_undefined__", p = 500, m = "__lodash_placeholder__", d = 1, l = 2, u = 4, k = 1, C = 2, S = 1, L = 2, Y = 4, H = 8, R = 16, U = 32, x = 64, B = 128, D = 256, O = 512, I = 30, W = "...", z = 800, X = 16, P = 1, pt = 2, ct = 3, At = 1 / 0, ut = 9007199254740991, Ht = 17976931348623157e292, Ie = NaN, fe = 4294967295, kr = fe - 1, K = fe >>> 1, Z = [
      ["ary", B],
      ["bind", S],
      ["bindKey", L],
      ["curry", H],
      ["curryRight", R],
      ["flip", O],
      ["partial", U],
      ["partialRight", x],
      ["rearg", D]
    ], J = "[object Arguments]", rt = "[object Array]", V = "[object AsyncFunction]", et = "[object Boolean]", nt = "[object Date]", G = "[object DOMException]", at = "[object Error]", Et = "[object Function]", $t = "[object GeneratorFunction]", It = "[object Map]", Te = "[object Number]", Hn = "[object Null]", he = "[object Object]", En = "[object Promise]", $n = "[object Proxy]", Zt = "[object RegExp]", te = "[object Set]", Le = "[object String]", Ue = "[object Symbol]", Yn = "[object Undefined]", qe = "[object WeakMap]", Qn = "[object WeakSet]", Ge = "[object ArrayBuffer]", Cn = "[object DataView]", Ao = "[object Float32Array]", To = "[object Float64Array]", xo = "[object Int8Array]", Oo = "[object Int16Array]", No = "[object Int32Array]", Bo = "[object Uint8Array]", Ro = "[object Uint8ClampedArray]", Io = "[object Uint16Array]", Lo = "[object Uint32Array]", zu = /\b__p \+= '';/g, Vu = /\b(__p \+=) '' \+/g, Ju = /(__e\(.*?\)|\b__t\)) \+\n'';/g, _s = /&(?:amp|lt|gt|quot|#39);/g, ks = /[&<>"']/g, Xu = RegExp(_s.source), Ku = RegExp(ks.source), Hu = /<%-([\s\S]+?)%>/g, $u = /<%([\s\S]+?)%>/g, ws = /<%=([\s\S]+?)%>/g, Yu = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Qu = /^\w*$/, Gu = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Uo = /[\\^$.*+?()[\]{}|]/g, Zu = RegExp(Uo.source), jo = /^\s+/, tf = /\s/, ef = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, nf = /\{\n\/\* \[wrapped with (.+)\] \*/, rf = /,? & /, of = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, sf = /[()=,{}\[\]\/\s]/, af = /\\(\\)?/g, cf = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ss = /\w*$/, uf = /^[-+]0x[0-9a-f]+$/i, ff = /^0b[01]+$/i, hf = /^\[object .+?Constructor\]$/, lf = /^0o[0-7]+$/i, pf = /^(?:0|[1-9]\d*)$/, df = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, wr = /($^)/, yf = /['\n\r\u2028\u2029\\]/g, Sr = "\\ud800-\\udfff", vf = "\\u0300-\\u036f", gf = "\\ufe20-\\ufe2f", mf = "\\u20d0-\\u20ff", Es = vf + gf + mf, Cs = "\\u2700-\\u27bf", As = "a-z\\xdf-\\xf6\\xf8-\\xff", bf = "\\xac\\xb1\\xd7\\xf7", _f = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", kf = "\\u2000-\\u206f", wf = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Ts = "A-Z\\xc0-\\xd6\\xd8-\\xde", xs = "\\ufe0e\\ufe0f", Os = bf + _f + kf + wf, Do = "['’]", Sf = "[" + Sr + "]", Ns = "[" + Os + "]", Er = "[" + Es + "]", Bs = "\\d+", Ef = "[" + Cs + "]", Rs = "[" + As + "]", Is = "[^" + Sr + Os + Bs + Cs + As + Ts + "]", Po = "\\ud83c[\\udffb-\\udfff]", Cf = "(?:" + Er + "|" + Po + ")", Ls = "[^" + Sr + "]", Mo = "(?:\\ud83c[\\udde6-\\uddff]){2}", qo = "[\\ud800-\\udbff][\\udc00-\\udfff]", An = "[" + Ts + "]", Us = "\\u200d", js = "(?:" + Rs + "|" + Is + ")", Af = "(?:" + An + "|" + Is + ")", Ds = "(?:" + Do + "(?:d|ll|m|re|s|t|ve))?", Ps = "(?:" + Do + "(?:D|LL|M|RE|S|T|VE))?", Ms = Cf + "?", qs = "[" + xs + "]?", Tf = "(?:" + Us + "(?:" + [Ls, Mo, qo].join("|") + ")" + qs + Ms + ")*", xf = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Of = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Fs = qs + Ms + Tf, Nf = "(?:" + [Ef, Mo, qo].join("|") + ")" + Fs, Bf = "(?:" + [Ls + Er + "?", Er, Mo, qo, Sf].join("|") + ")", Rf = RegExp(Do, "g"), If = RegExp(Er, "g"), Fo = RegExp(Po + "(?=" + Po + ")|" + Bf + Fs, "g"), Lf = RegExp([
      An + "?" + Rs + "+" + Ds + "(?=" + [Ns, An, "$"].join("|") + ")",
      Af + "+" + Ps + "(?=" + [Ns, An + js, "$"].join("|") + ")",
      An + "?" + js + "+" + Ds,
      An + "+" + Ps,
      Of,
      xf,
      Bs,
      Nf
    ].join("|"), "g"), Uf = RegExp("[" + Us + Sr + Es + xs + "]"), jf = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Df = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Pf = -1, Rt = {};
    Rt[Ao] = Rt[To] = Rt[xo] = Rt[Oo] = Rt[No] = Rt[Bo] = Rt[Ro] = Rt[Io] = Rt[Lo] = !0, Rt[J] = Rt[rt] = Rt[Ge] = Rt[et] = Rt[Cn] = Rt[nt] = Rt[at] = Rt[Et] = Rt[It] = Rt[Te] = Rt[he] = Rt[Zt] = Rt[te] = Rt[Le] = Rt[qe] = !1;
    var Bt = {};
    Bt[J] = Bt[rt] = Bt[Ge] = Bt[Cn] = Bt[et] = Bt[nt] = Bt[Ao] = Bt[To] = Bt[xo] = Bt[Oo] = Bt[No] = Bt[It] = Bt[Te] = Bt[he] = Bt[Zt] = Bt[te] = Bt[Le] = Bt[Ue] = Bt[Bo] = Bt[Ro] = Bt[Io] = Bt[Lo] = !0, Bt[at] = Bt[Et] = Bt[qe] = !1;
    var Mf = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, qf = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Ff = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Wf = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, zf = parseFloat, Vf = parseInt, Ws = typeof pr == "object" && pr && pr.Object === Object && pr, Jf = typeof self == "object" && self && self.Object === Object && self, Jt = Ws || Jf || Function("return this")(), Wo = o && !o.nodeType && o, pn = Wo && !0 && r && !r.nodeType && r, zs = pn && pn.exports === Wo, zo = zs && Ws.process, me = function() {
      try {
        var A = pn && pn.require && pn.require("util").types;
        return A || zo && zo.binding && zo.binding("util");
      } catch (j) {
      }
    }(), Vs = me && me.isArrayBuffer, Js = me && me.isDate, Xs = me && me.isMap, Ks = me && me.isRegExp, Hs = me && me.isSet, $s = me && me.isTypedArray;
    function le(A, j, N) {
      switch (N.length) {
        case 0:
          return A.call(j);
        case 1:
          return A.call(j, N[0]);
        case 2:
          return A.call(j, N[0], N[1]);
        case 3:
          return A.call(j, N[0], N[1], N[2]);
      }
      return A.apply(j, N);
    }
    function Xf(A, j, N, Q) {
      for (var ft = -1, St = A == null ? 0 : A.length; ++ft < St; ) {
        var Ft = A[ft];
        j(Q, Ft, N(Ft), A);
      }
      return Q;
    }
    function be(A, j) {
      for (var N = -1, Q = A == null ? 0 : A.length; ++N < Q && j(A[N], N, A) !== !1; )
        ;
      return A;
    }
    function Kf(A, j) {
      for (var N = A == null ? 0 : A.length; N-- && j(A[N], N, A) !== !1; )
        ;
      return A;
    }
    function Ys(A, j) {
      for (var N = -1, Q = A == null ? 0 : A.length; ++N < Q; )
        if (!j(A[N], N, A))
          return !1;
      return !0;
    }
    function Ze(A, j) {
      for (var N = -1, Q = A == null ? 0 : A.length, ft = 0, St = []; ++N < Q; ) {
        var Ft = A[N];
        j(Ft, N, A) && (St[ft++] = Ft);
      }
      return St;
    }
    function Cr(A, j) {
      var N = A == null ? 0 : A.length;
      return !!N && Tn(A, j, 0) > -1;
    }
    function Vo(A, j, N) {
      for (var Q = -1, ft = A == null ? 0 : A.length; ++Q < ft; )
        if (N(j, A[Q]))
          return !0;
      return !1;
    }
    function Lt(A, j) {
      for (var N = -1, Q = A == null ? 0 : A.length, ft = Array(Q); ++N < Q; )
        ft[N] = j(A[N], N, A);
      return ft;
    }
    function tn(A, j) {
      for (var N = -1, Q = j.length, ft = A.length; ++N < Q; )
        A[ft + N] = j[N];
      return A;
    }
    function Jo(A, j, N, Q) {
      var ft = -1, St = A == null ? 0 : A.length;
      for (Q && St && (N = A[++ft]); ++ft < St; )
        N = j(N, A[ft], ft, A);
      return N;
    }
    function Hf(A, j, N, Q) {
      var ft = A == null ? 0 : A.length;
      for (Q && ft && (N = A[--ft]); ft--; )
        N = j(N, A[ft], ft, A);
      return N;
    }
    function Xo(A, j) {
      for (var N = -1, Q = A == null ? 0 : A.length; ++N < Q; )
        if (j(A[N], N, A))
          return !0;
      return !1;
    }
    var $f = Ko("length");
    function Yf(A) {
      return A.split("");
    }
    function Qf(A) {
      return A.match(of) || [];
    }
    function Qs(A, j, N) {
      var Q;
      return N(A, function(ft, St, Ft) {
        if (j(ft, St, Ft))
          return Q = St, !1;
      }), Q;
    }
    function Ar(A, j, N, Q) {
      for (var ft = A.length, St = N + (Q ? 1 : -1); Q ? St-- : ++St < ft; )
        if (j(A[St], St, A))
          return St;
      return -1;
    }
    function Tn(A, j, N) {
      return j === j ? uh(A, j, N) : Ar(A, Gs, N);
    }
    function Gf(A, j, N, Q) {
      for (var ft = N - 1, St = A.length; ++ft < St; )
        if (Q(A[ft], j))
          return ft;
      return -1;
    }
    function Gs(A) {
      return A !== A;
    }
    function Zs(A, j) {
      var N = A == null ? 0 : A.length;
      return N ? $o(A, j) / N : Ie;
    }
    function Ko(A) {
      return function(j) {
        return j == null ? n : j[A];
      };
    }
    function Ho(A) {
      return function(j) {
        return A == null ? n : A[j];
      };
    }
    function ta(A, j, N, Q, ft) {
      return ft(A, function(St, Ft, Ot) {
        N = Q ? (Q = !1, St) : j(N, St, Ft, Ot);
      }), N;
    }
    function Zf(A, j) {
      var N = A.length;
      for (A.sort(j); N--; )
        A[N] = A[N].value;
      return A;
    }
    function $o(A, j) {
      for (var N, Q = -1, ft = A.length; ++Q < ft; ) {
        var St = j(A[Q]);
        St !== n && (N = N === n ? St : N + St);
      }
      return N;
    }
    function Yo(A, j) {
      for (var N = -1, Q = Array(A); ++N < A; )
        Q[N] = j(N);
      return Q;
    }
    function th(A, j) {
      return Lt(j, function(N) {
        return [N, A[N]];
      });
    }
    function ea(A) {
      return A && A.slice(0, ia(A) + 1).replace(jo, "");
    }
    function pe(A) {
      return function(j) {
        return A(j);
      };
    }
    function Qo(A, j) {
      return Lt(j, function(N) {
        return A[N];
      });
    }
    function Gn(A, j) {
      return A.has(j);
    }
    function na(A, j) {
      for (var N = -1, Q = A.length; ++N < Q && Tn(j, A[N], 0) > -1; )
        ;
      return N;
    }
    function ra(A, j) {
      for (var N = A.length; N-- && Tn(j, A[N], 0) > -1; )
        ;
      return N;
    }
    function eh(A, j) {
      for (var N = A.length, Q = 0; N--; )
        A[N] === j && ++Q;
      return Q;
    }
    var nh = Ho(Mf), rh = Ho(qf);
    function oh(A) {
      return "\\" + Wf[A];
    }
    function ih(A, j) {
      return A == null ? n : A[j];
    }
    function xn(A) {
      return Uf.test(A);
    }
    function sh(A) {
      return jf.test(A);
    }
    function ah(A) {
      for (var j, N = []; !(j = A.next()).done; )
        N.push(j.value);
      return N;
    }
    function Go(A) {
      var j = -1, N = Array(A.size);
      return A.forEach(function(Q, ft) {
        N[++j] = [ft, Q];
      }), N;
    }
    function oa(A, j) {
      return function(N) {
        return A(j(N));
      };
    }
    function en(A, j) {
      for (var N = -1, Q = A.length, ft = 0, St = []; ++N < Q; ) {
        var Ft = A[N];
        (Ft === j || Ft === m) && (A[N] = m, St[ft++] = N);
      }
      return St;
    }
    function Tr(A) {
      var j = -1, N = Array(A.size);
      return A.forEach(function(Q) {
        N[++j] = Q;
      }), N;
    }
    function ch(A) {
      var j = -1, N = Array(A.size);
      return A.forEach(function(Q) {
        N[++j] = [Q, Q];
      }), N;
    }
    function uh(A, j, N) {
      for (var Q = N - 1, ft = A.length; ++Q < ft; )
        if (A[Q] === j)
          return Q;
      return -1;
    }
    function fh(A, j, N) {
      for (var Q = N + 1; Q--; )
        if (A[Q] === j)
          return Q;
      return Q;
    }
    function On(A) {
      return xn(A) ? lh(A) : $f(A);
    }
    function xe(A) {
      return xn(A) ? ph(A) : Yf(A);
    }
    function ia(A) {
      for (var j = A.length; j-- && tf.test(A.charAt(j)); )
        ;
      return j;
    }
    var hh = Ho(Ff);
    function lh(A) {
      for (var j = Fo.lastIndex = 0; Fo.test(A); )
        ++j;
      return j;
    }
    function ph(A) {
      return A.match(Fo) || [];
    }
    function dh(A) {
      return A.match(Lf) || [];
    }
    var yh = function A(j) {
      j = j == null ? Jt : Nn.defaults(Jt.Object(), j, Nn.pick(Jt, Df));
      var N = j.Array, Q = j.Date, ft = j.Error, St = j.Function, Ft = j.Math, Ot = j.Object, Zo = j.RegExp, vh = j.String, _e = j.TypeError, xr = N.prototype, gh = St.prototype, Bn = Ot.prototype, Or = j["__core-js_shared__"], Nr = gh.toString, Tt = Bn.hasOwnProperty, mh = 0, sa = function() {
        var t = /[^.]+$/.exec(Or && Or.keys && Or.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }(), Br = Bn.toString, bh = Nr.call(Ot), _h = Jt._, kh = Zo(
        "^" + Nr.call(Tt).replace(Uo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Rr = zs ? j.Buffer : n, nn = j.Symbol, Ir = j.Uint8Array, aa = Rr ? Rr.allocUnsafe : n, Lr = oa(Ot.getPrototypeOf, Ot), ca = Ot.create, ua = Bn.propertyIsEnumerable, Ur = xr.splice, fa = nn ? nn.isConcatSpreadable : n, Zn = nn ? nn.iterator : n, dn = nn ? nn.toStringTag : n, jr = function() {
        try {
          var t = bn(Ot, "defineProperty");
          return t({}, "", {}), t;
        } catch (e) {
        }
      }(), wh = j.clearTimeout !== Jt.clearTimeout && j.clearTimeout, Sh = Q && Q.now !== Jt.Date.now && Q.now, Eh = j.setTimeout !== Jt.setTimeout && j.setTimeout, Dr = Ft.ceil, Pr = Ft.floor, ti = Ot.getOwnPropertySymbols, Ch = Rr ? Rr.isBuffer : n, ha = j.isFinite, Ah = xr.join, Th = oa(Ot.keys, Ot), Wt = Ft.max, Yt = Ft.min, xh = Q.now, Oh = j.parseInt, la = Ft.random, Nh = xr.reverse, ei = bn(j, "DataView"), tr = bn(j, "Map"), ni = bn(j, "Promise"), Rn = bn(j, "Set"), er = bn(j, "WeakMap"), nr = bn(Ot, "create"), Mr = er && new er(), In = {}, Bh = _n(ei), Rh = _n(tr), Ih = _n(ni), Lh = _n(Rn), Uh = _n(er), qr = nn ? nn.prototype : n, rr = qr ? qr.valueOf : n, pa = qr ? qr.toString : n;
      function v(t) {
        if (jt(t) && !ht(t) && !(t instanceof mt)) {
          if (t instanceof ke)
            return t;
          if (Tt.call(t, "__wrapped__"))
            return dc(t);
        }
        return new ke(t);
      }
      var Ln = /* @__PURE__ */ function() {
        function t() {
        }
        return function(e) {
          if (!Ut(e))
            return {};
          if (ca)
            return ca(e);
          t.prototype = e;
          var i = new t();
          return t.prototype = n, i;
        };
      }();
      function Fr() {
      }
      function ke(t, e) {
        this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = n;
      }
      v.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Hu,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: $u,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: ws,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: v
        }
      }, v.prototype = Fr.prototype, v.prototype.constructor = v, ke.prototype = Ln(Fr.prototype), ke.prototype.constructor = ke;
      function mt(t) {
        this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = fe, this.__views__ = [];
      }
      function jh() {
        var t = new mt(this.__wrapped__);
        return t.__actions__ = oe(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = oe(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = oe(this.__views__), t;
      }
      function Dh() {
        if (this.__filtered__) {
          var t = new mt(this);
          t.__dir__ = -1, t.__filtered__ = !0;
        } else
          t = this.clone(), t.__dir__ *= -1;
        return t;
      }
      function Ph() {
        var t = this.__wrapped__.value(), e = this.__dir__, i = ht(t), a = e < 0, h = i ? t.length : 0, b = Yl(0, h, this.__views__), w = b.start, E = b.end, T = E - w, M = a ? E : w - 1, q = this.__iteratees__, F = q.length, $ = 0, tt = Yt(T, this.__takeCount__);
        if (!i || !a && h == T && tt == T)
          return Da(t, this.__actions__);
        var it = [];
        t:
          for (; T-- && $ < tt; ) {
            M += e;
            for (var yt = -1, st = t[M]; ++yt < F; ) {
              var gt = q[yt], bt = gt.iteratee, ve = gt.type, re = bt(st);
              if (ve == pt)
                st = re;
              else if (!re) {
                if (ve == P)
                  continue t;
                break t;
              }
            }
            it[$++] = st;
          }
        return it;
      }
      mt.prototype = Ln(Fr.prototype), mt.prototype.constructor = mt;
      function yn(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++e < i; ) {
          var a = t[e];
          this.set(a[0], a[1]);
        }
      }
      function Mh() {
        this.__data__ = nr ? nr(null) : {}, this.size = 0;
      }
      function qh(t) {
        var e = this.has(t) && delete this.__data__[t];
        return this.size -= e ? 1 : 0, e;
      }
      function Fh(t) {
        var e = this.__data__;
        if (nr) {
          var i = e[t];
          return i === _ ? n : i;
        }
        return Tt.call(e, t) ? e[t] : n;
      }
      function Wh(t) {
        var e = this.__data__;
        return nr ? e[t] !== n : Tt.call(e, t);
      }
      function zh(t, e) {
        var i = this.__data__;
        return this.size += this.has(t) ? 0 : 1, i[t] = nr && e === n ? _ : e, this;
      }
      yn.prototype.clear = Mh, yn.prototype.delete = qh, yn.prototype.get = Fh, yn.prototype.has = Wh, yn.prototype.set = zh;
      function Fe(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++e < i; ) {
          var a = t[e];
          this.set(a[0], a[1]);
        }
      }
      function Vh() {
        this.__data__ = [], this.size = 0;
      }
      function Jh(t) {
        var e = this.__data__, i = Wr(e, t);
        if (i < 0)
          return !1;
        var a = e.length - 1;
        return i == a ? e.pop() : Ur.call(e, i, 1), --this.size, !0;
      }
      function Xh(t) {
        var e = this.__data__, i = Wr(e, t);
        return i < 0 ? n : e[i][1];
      }
      function Kh(t) {
        return Wr(this.__data__, t) > -1;
      }
      function Hh(t, e) {
        var i = this.__data__, a = Wr(i, t);
        return a < 0 ? (++this.size, i.push([t, e])) : i[a][1] = e, this;
      }
      Fe.prototype.clear = Vh, Fe.prototype.delete = Jh, Fe.prototype.get = Xh, Fe.prototype.has = Kh, Fe.prototype.set = Hh;
      function We(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.clear(); ++e < i; ) {
          var a = t[e];
          this.set(a[0], a[1]);
        }
      }
      function $h() {
        this.size = 0, this.__data__ = {
          hash: new yn(),
          map: new (tr || Fe)(),
          string: new yn()
        };
      }
      function Yh(t) {
        var e = to(this, t).delete(t);
        return this.size -= e ? 1 : 0, e;
      }
      function Qh(t) {
        return to(this, t).get(t);
      }
      function Gh(t) {
        return to(this, t).has(t);
      }
      function Zh(t, e) {
        var i = to(this, t), a = i.size;
        return i.set(t, e), this.size += i.size == a ? 0 : 1, this;
      }
      We.prototype.clear = $h, We.prototype.delete = Yh, We.prototype.get = Qh, We.prototype.has = Gh, We.prototype.set = Zh;
      function vn(t) {
        var e = -1, i = t == null ? 0 : t.length;
        for (this.__data__ = new We(); ++e < i; )
          this.add(t[e]);
      }
      function tl(t) {
        return this.__data__.set(t, _), this;
      }
      function el(t) {
        return this.__data__.has(t);
      }
      vn.prototype.add = vn.prototype.push = tl, vn.prototype.has = el;
      function Oe(t) {
        var e = this.__data__ = new Fe(t);
        this.size = e.size;
      }
      function nl() {
        this.__data__ = new Fe(), this.size = 0;
      }
      function rl(t) {
        var e = this.__data__, i = e.delete(t);
        return this.size = e.size, i;
      }
      function ol(t) {
        return this.__data__.get(t);
      }
      function il(t) {
        return this.__data__.has(t);
      }
      function sl(t, e) {
        var i = this.__data__;
        if (i instanceof Fe) {
          var a = i.__data__;
          if (!tr || a.length < c - 1)
            return a.push([t, e]), this.size = ++i.size, this;
          i = this.__data__ = new We(a);
        }
        return i.set(t, e), this.size = i.size, this;
      }
      Oe.prototype.clear = nl, Oe.prototype.delete = rl, Oe.prototype.get = ol, Oe.prototype.has = il, Oe.prototype.set = sl;
      function da(t, e) {
        var i = ht(t), a = !i && kn(t), h = !i && !a && cn(t), b = !i && !a && !h && Pn(t), w = i || a || h || b, E = w ? Yo(t.length, vh) : [], T = E.length;
        for (var M in t)
          (e || Tt.call(t, M)) && !(w && // Safari 9 has enumerable `arguments.length` in strict mode.
          (M == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          h && (M == "offset" || M == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          b && (M == "buffer" || M == "byteLength" || M == "byteOffset") || // Skip index properties.
          Xe(M, T))) && E.push(M);
        return E;
      }
      function ya(t) {
        var e = t.length;
        return e ? t[pi(0, e - 1)] : n;
      }
      function al(t, e) {
        return eo(oe(t), gn(e, 0, t.length));
      }
      function cl(t) {
        return eo(oe(t));
      }
      function ri(t, e, i) {
        (i !== n && !Ne(t[e], i) || i === n && !(e in t)) && ze(t, e, i);
      }
      function or(t, e, i) {
        var a = t[e];
        (!(Tt.call(t, e) && Ne(a, i)) || i === n && !(e in t)) && ze(t, e, i);
      }
      function Wr(t, e) {
        for (var i = t.length; i--; )
          if (Ne(t[i][0], e))
            return i;
        return -1;
      }
      function ul(t, e, i, a) {
        return rn(t, function(h, b, w) {
          e(a, h, i(h), w);
        }), a;
      }
      function va(t, e) {
        return t && De(e, Vt(e), t);
      }
      function fl(t, e) {
        return t && De(e, se(e), t);
      }
      function ze(t, e, i) {
        e == "__proto__" && jr ? jr(t, e, {
          configurable: !0,
          enumerable: !0,
          value: i,
          writable: !0
        }) : t[e] = i;
      }
      function oi(t, e) {
        for (var i = -1, a = e.length, h = N(a), b = t == null; ++i < a; )
          h[i] = b ? n : Pi(t, e[i]);
        return h;
      }
      function gn(t, e, i) {
        return t === t && (i !== n && (t = t <= i ? t : i), e !== n && (t = t >= e ? t : e)), t;
      }
      function we(t, e, i, a, h, b) {
        var w, E = e & d, T = e & l, M = e & u;
        if (i && (w = h ? i(t, a, h, b) : i(t)), w !== n)
          return w;
        if (!Ut(t))
          return t;
        var q = ht(t);
        if (q) {
          if (w = Gl(t), !E)
            return oe(t, w);
        } else {
          var F = Qt(t), $ = F == Et || F == $t;
          if (cn(t))
            return qa(t, E);
          if (F == he || F == J || $ && !h) {
            if (w = T || $ ? {} : ic(t), !E)
              return T ? Fl(t, fl(w, t)) : ql(t, va(w, t));
          } else {
            if (!Bt[F])
              return h ? t : {};
            w = Zl(t, F, E);
          }
        }
        b || (b = new Oe());
        var tt = b.get(t);
        if (tt)
          return tt;
        b.set(t, w), Lc(t) ? t.forEach(function(st) {
          w.add(we(st, e, i, st, t, b));
        }) : Rc(t) && t.forEach(function(st, gt) {
          w.set(gt, we(st, e, i, gt, t, b));
        });
        var it = M ? T ? Ei : Si : T ? se : Vt, yt = q ? n : it(t);
        return be(yt || t, function(st, gt) {
          yt && (gt = st, st = t[gt]), or(w, gt, we(st, e, i, gt, t, b));
        }), w;
      }
      function hl(t) {
        var e = Vt(t);
        return function(i) {
          return ga(i, t, e);
        };
      }
      function ga(t, e, i) {
        var a = i.length;
        if (t == null)
          return !a;
        for (t = Ot(t); a--; ) {
          var h = i[a], b = e[h], w = t[h];
          if (w === n && !(h in t) || !b(w))
            return !1;
        }
        return !0;
      }
      function ma(t, e, i) {
        if (typeof t != "function")
          throw new _e(g);
        return hr(function() {
          t.apply(n, i);
        }, e);
      }
      function ir(t, e, i, a) {
        var h = -1, b = Cr, w = !0, E = t.length, T = [], M = e.length;
        if (!E)
          return T;
        i && (e = Lt(e, pe(i))), a ? (b = Vo, w = !1) : e.length >= c && (b = Gn, w = !1, e = new vn(e));
        t:
          for (; ++h < E; ) {
            var q = t[h], F = i == null ? q : i(q);
            if (q = a || q !== 0 ? q : 0, w && F === F) {
              for (var $ = M; $--; )
                if (e[$] === F)
                  continue t;
              T.push(q);
            } else
              b(e, F, a) || T.push(q);
          }
        return T;
      }
      var rn = Ja(je), ba = Ja(si, !0);
      function ll(t, e) {
        var i = !0;
        return rn(t, function(a, h, b) {
          return i = !!e(a, h, b), i;
        }), i;
      }
      function zr(t, e, i) {
        for (var a = -1, h = t.length; ++a < h; ) {
          var b = t[a], w = e(b);
          if (w != null && (E === n ? w === w && !ye(w) : i(w, E)))
            var E = w, T = b;
        }
        return T;
      }
      function pl(t, e, i, a) {
        var h = t.length;
        for (i = dt(i), i < 0 && (i = -i > h ? 0 : h + i), a = a === n || a > h ? h : dt(a), a < 0 && (a += h), a = i > a ? 0 : jc(a); i < a; )
          t[i++] = e;
        return t;
      }
      function _a(t, e) {
        var i = [];
        return rn(t, function(a, h, b) {
          e(a, h, b) && i.push(a);
        }), i;
      }
      function Xt(t, e, i, a, h) {
        var b = -1, w = t.length;
        for (i || (i = ep), h || (h = []); ++b < w; ) {
          var E = t[b];
          e > 0 && i(E) ? e > 1 ? Xt(E, e - 1, i, a, h) : tn(h, E) : a || (h[h.length] = E);
        }
        return h;
      }
      var ii = Xa(), ka = Xa(!0);
      function je(t, e) {
        return t && ii(t, e, Vt);
      }
      function si(t, e) {
        return t && ka(t, e, Vt);
      }
      function Vr(t, e) {
        return Ze(e, function(i) {
          return Ke(t[i]);
        });
      }
      function mn(t, e) {
        e = sn(e, t);
        for (var i = 0, a = e.length; t != null && i < a; )
          t = t[Pe(e[i++])];
        return i && i == a ? t : n;
      }
      function wa(t, e, i) {
        var a = e(t);
        return ht(t) ? a : tn(a, i(t));
      }
      function ee(t) {
        return t == null ? t === n ? Yn : Hn : dn && dn in Ot(t) ? $l(t) : cp(t);
      }
      function ai(t, e) {
        return t > e;
      }
      function dl(t, e) {
        return t != null && Tt.call(t, e);
      }
      function yl(t, e) {
        return t != null && e in Ot(t);
      }
      function vl(t, e, i) {
        return t >= Yt(e, i) && t < Wt(e, i);
      }
      function ci(t, e, i) {
        for (var a = i ? Vo : Cr, h = t[0].length, b = t.length, w = b, E = N(b), T = 1 / 0, M = []; w--; ) {
          var q = t[w];
          w && e && (q = Lt(q, pe(e))), T = Yt(q.length, T), E[w] = !i && (e || h >= 120 && q.length >= 120) ? new vn(w && q) : n;
        }
        q = t[0];
        var F = -1, $ = E[0];
        t:
          for (; ++F < h && M.length < T; ) {
            var tt = q[F], it = e ? e(tt) : tt;
            if (tt = i || tt !== 0 ? tt : 0, !($ ? Gn($, it) : a(M, it, i))) {
              for (w = b; --w; ) {
                var yt = E[w];
                if (!(yt ? Gn(yt, it) : a(t[w], it, i)))
                  continue t;
              }
              $ && $.push(it), M.push(tt);
            }
          }
        return M;
      }
      function gl(t, e, i, a) {
        return je(t, function(h, b, w) {
          e(a, i(h), b, w);
        }), a;
      }
      function sr(t, e, i) {
        e = sn(e, t), t = uc(t, e);
        var a = t == null ? t : t[Pe(Ee(e))];
        return a == null ? n : le(a, t, i);
      }
      function Sa(t) {
        return jt(t) && ee(t) == J;
      }
      function ml(t) {
        return jt(t) && ee(t) == Ge;
      }
      function bl(t) {
        return jt(t) && ee(t) == nt;
      }
      function ar(t, e, i, a, h) {
        return t === e ? !0 : t == null || e == null || !jt(t) && !jt(e) ? t !== t && e !== e : _l(t, e, i, a, ar, h);
      }
      function _l(t, e, i, a, h, b) {
        var w = ht(t), E = ht(e), T = w ? rt : Qt(t), M = E ? rt : Qt(e);
        T = T == J ? he : T, M = M == J ? he : M;
        var q = T == he, F = M == he, $ = T == M;
        if ($ && cn(t)) {
          if (!cn(e))
            return !1;
          w = !0, q = !1;
        }
        if ($ && !q)
          return b || (b = new Oe()), w || Pn(t) ? nc(t, e, i, a, h, b) : Kl(t, e, T, i, a, h, b);
        if (!(i & k)) {
          var tt = q && Tt.call(t, "__wrapped__"), it = F && Tt.call(e, "__wrapped__");
          if (tt || it) {
            var yt = tt ? t.value() : t, st = it ? e.value() : e;
            return b || (b = new Oe()), h(yt, st, i, a, b);
          }
        }
        return $ ? (b || (b = new Oe()), Hl(t, e, i, a, h, b)) : !1;
      }
      function kl(t) {
        return jt(t) && Qt(t) == It;
      }
      function ui(t, e, i, a) {
        var h = i.length, b = h, w = !a;
        if (t == null)
          return !b;
        for (t = Ot(t); h--; ) {
          var E = i[h];
          if (w && E[2] ? E[1] !== t[E[0]] : !(E[0] in t))
            return !1;
        }
        for (; ++h < b; ) {
          E = i[h];
          var T = E[0], M = t[T], q = E[1];
          if (w && E[2]) {
            if (M === n && !(T in t))
              return !1;
          } else {
            var F = new Oe();
            if (a)
              var $ = a(M, q, T, t, e, F);
            if (!($ === n ? ar(q, M, k | C, a, F) : $))
              return !1;
          }
        }
        return !0;
      }
      function Ea(t) {
        if (!Ut(t) || rp(t))
          return !1;
        var e = Ke(t) ? kh : hf;
        return e.test(_n(t));
      }
      function wl(t) {
        return jt(t) && ee(t) == Zt;
      }
      function Sl(t) {
        return jt(t) && Qt(t) == te;
      }
      function El(t) {
        return jt(t) && ao(t.length) && !!Rt[ee(t)];
      }
      function Ca(t) {
        return typeof t == "function" ? t : t == null ? ae : typeof t == "object" ? ht(t) ? xa(t[0], t[1]) : Ta(t) : Kc(t);
      }
      function fi(t) {
        if (!fr(t))
          return Th(t);
        var e = [];
        for (var i in Ot(t))
          Tt.call(t, i) && i != "constructor" && e.push(i);
        return e;
      }
      function Cl(t) {
        if (!Ut(t))
          return ap(t);
        var e = fr(t), i = [];
        for (var a in t)
          a == "constructor" && (e || !Tt.call(t, a)) || i.push(a);
        return i;
      }
      function hi(t, e) {
        return t < e;
      }
      function Aa(t, e) {
        var i = -1, a = ie(t) ? N(t.length) : [];
        return rn(t, function(h, b, w) {
          a[++i] = e(h, b, w);
        }), a;
      }
      function Ta(t) {
        var e = Ai(t);
        return e.length == 1 && e[0][2] ? ac(e[0][0], e[0][1]) : function(i) {
          return i === t || ui(i, t, e);
        };
      }
      function xa(t, e) {
        return xi(t) && sc(e) ? ac(Pe(t), e) : function(i) {
          var a = Pi(i, t);
          return a === n && a === e ? Mi(i, t) : ar(e, a, k | C);
        };
      }
      function Jr(t, e, i, a, h) {
        t !== e && ii(e, function(b, w) {
          if (h || (h = new Oe()), Ut(b))
            Al(t, e, w, i, Jr, a, h);
          else {
            var E = a ? a(Ni(t, w), b, w + "", t, e, h) : n;
            E === n && (E = b), ri(t, w, E);
          }
        }, se);
      }
      function Al(t, e, i, a, h, b, w) {
        var E = Ni(t, i), T = Ni(e, i), M = w.get(T);
        if (M) {
          ri(t, i, M);
          return;
        }
        var q = b ? b(E, T, i + "", t, e, w) : n, F = q === n;
        if (F) {
          var $ = ht(T), tt = !$ && cn(T), it = !$ && !tt && Pn(T);
          q = T, $ || tt || it ? ht(E) ? q = E : Dt(E) ? q = oe(E) : tt ? (F = !1, q = qa(T, !0)) : it ? (F = !1, q = Fa(T, !0)) : q = [] : lr(T) || kn(T) ? (q = E, kn(E) ? q = Dc(E) : (!Ut(E) || Ke(E)) && (q = ic(T))) : F = !1;
        }
        F && (w.set(T, q), h(q, T, a, b, w), w.delete(T)), ri(t, i, q);
      }
      function Oa(t, e) {
        var i = t.length;
        if (i)
          return e += e < 0 ? i : 0, Xe(e, i) ? t[e] : n;
      }
      function Na(t, e, i) {
        e.length ? e = Lt(e, function(b) {
          return ht(b) ? function(w) {
            return mn(w, b.length === 1 ? b[0] : b);
          } : b;
        }) : e = [ae];
        var a = -1;
        e = Lt(e, pe(ot()));
        var h = Aa(t, function(b, w, E) {
          var T = Lt(e, function(M) {
            return M(b);
          });
          return { criteria: T, index: ++a, value: b };
        });
        return Zf(h, function(b, w) {
          return Ml(b, w, i);
        });
      }
      function Tl(t, e) {
        return Ba(t, e, function(i, a) {
          return Mi(t, a);
        });
      }
      function Ba(t, e, i) {
        for (var a = -1, h = e.length, b = {}; ++a < h; ) {
          var w = e[a], E = mn(t, w);
          i(E, w) && cr(b, sn(w, t), E);
        }
        return b;
      }
      function xl(t) {
        return function(e) {
          return mn(e, t);
        };
      }
      function li(t, e, i, a) {
        var h = a ? Gf : Tn, b = -1, w = e.length, E = t;
        for (t === e && (e = oe(e)), i && (E = Lt(t, pe(i))); ++b < w; )
          for (var T = 0, M = e[b], q = i ? i(M) : M; (T = h(E, q, T, a)) > -1; )
            E !== t && Ur.call(E, T, 1), Ur.call(t, T, 1);
        return t;
      }
      function Ra(t, e) {
        for (var i = t ? e.length : 0, a = i - 1; i--; ) {
          var h = e[i];
          if (i == a || h !== b) {
            var b = h;
            Xe(h) ? Ur.call(t, h, 1) : vi(t, h);
          }
        }
        return t;
      }
      function pi(t, e) {
        return t + Pr(la() * (e - t + 1));
      }
      function Ol(t, e, i, a) {
        for (var h = -1, b = Wt(Dr((e - t) / (i || 1)), 0), w = N(b); b--; )
          w[a ? b : ++h] = t, t += i;
        return w;
      }
      function di(t, e) {
        var i = "";
        if (!t || e < 1 || e > ut)
          return i;
        do
          e % 2 && (i += t), e = Pr(e / 2), e && (t += t);
        while (e);
        return i;
      }
      function vt(t, e) {
        return Bi(cc(t, e, ae), t + "");
      }
      function Nl(t) {
        return ya(Mn(t));
      }
      function Bl(t, e) {
        var i = Mn(t);
        return eo(i, gn(e, 0, i.length));
      }
      function cr(t, e, i, a) {
        if (!Ut(t))
          return t;
        e = sn(e, t);
        for (var h = -1, b = e.length, w = b - 1, E = t; E != null && ++h < b; ) {
          var T = Pe(e[h]), M = i;
          if (T === "__proto__" || T === "constructor" || T === "prototype")
            return t;
          if (h != w) {
            var q = E[T];
            M = a ? a(q, T, E) : n, M === n && (M = Ut(q) ? q : Xe(e[h + 1]) ? [] : {});
          }
          or(E, T, M), E = E[T];
        }
        return t;
      }
      var Ia = Mr ? function(t, e) {
        return Mr.set(t, e), t;
      } : ae, Rl = jr ? function(t, e) {
        return jr(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Fi(e),
          writable: !0
        });
      } : ae;
      function Il(t) {
        return eo(Mn(t));
      }
      function Se(t, e, i) {
        var a = -1, h = t.length;
        e < 0 && (e = -e > h ? 0 : h + e), i = i > h ? h : i, i < 0 && (i += h), h = e > i ? 0 : i - e >>> 0, e >>>= 0;
        for (var b = N(h); ++a < h; )
          b[a] = t[a + e];
        return b;
      }
      function Ll(t, e) {
        var i;
        return rn(t, function(a, h, b) {
          return i = e(a, h, b), !i;
        }), !!i;
      }
      function Xr(t, e, i) {
        var a = 0, h = t == null ? a : t.length;
        if (typeof e == "number" && e === e && h <= K) {
          for (; a < h; ) {
            var b = a + h >>> 1, w = t[b];
            w !== null && !ye(w) && (i ? w <= e : w < e) ? a = b + 1 : h = b;
          }
          return h;
        }
        return yi(t, e, ae, i);
      }
      function yi(t, e, i, a) {
        var h = 0, b = t == null ? 0 : t.length;
        if (b === 0)
          return 0;
        e = i(e);
        for (var w = e !== e, E = e === null, T = ye(e), M = e === n; h < b; ) {
          var q = Pr((h + b) / 2), F = i(t[q]), $ = F !== n, tt = F === null, it = F === F, yt = ye(F);
          if (w)
            var st = a || it;
          else
            M ? st = it && (a || $) : E ? st = it && $ && (a || !tt) : T ? st = it && $ && !tt && (a || !yt) : tt || yt ? st = !1 : st = a ? F <= e : F < e;
          st ? h = q + 1 : b = q;
        }
        return Yt(b, kr);
      }
      function La(t, e) {
        for (var i = -1, a = t.length, h = 0, b = []; ++i < a; ) {
          var w = t[i], E = e ? e(w) : w;
          if (!i || !Ne(E, T)) {
            var T = E;
            b[h++] = w === 0 ? 0 : w;
          }
        }
        return b;
      }
      function Ua(t) {
        return typeof t == "number" ? t : ye(t) ? Ie : +t;
      }
      function de(t) {
        if (typeof t == "string")
          return t;
        if (ht(t))
          return Lt(t, de) + "";
        if (ye(t))
          return pa ? pa.call(t) : "";
        var e = t + "";
        return e == "0" && 1 / t == -At ? "-0" : e;
      }
      function on(t, e, i) {
        var a = -1, h = Cr, b = t.length, w = !0, E = [], T = E;
        if (i)
          w = !1, h = Vo;
        else if (b >= c) {
          var M = e ? null : Jl(t);
          if (M)
            return Tr(M);
          w = !1, h = Gn, T = new vn();
        } else
          T = e ? [] : E;
        t:
          for (; ++a < b; ) {
            var q = t[a], F = e ? e(q) : q;
            if (q = i || q !== 0 ? q : 0, w && F === F) {
              for (var $ = T.length; $--; )
                if (T[$] === F)
                  continue t;
              e && T.push(F), E.push(q);
            } else
              h(T, F, i) || (T !== E && T.push(F), E.push(q));
          }
        return E;
      }
      function vi(t, e) {
        return e = sn(e, t), t = uc(t, e), t == null || delete t[Pe(Ee(e))];
      }
      function ja(t, e, i, a) {
        return cr(t, e, i(mn(t, e)), a);
      }
      function Kr(t, e, i, a) {
        for (var h = t.length, b = a ? h : -1; (a ? b-- : ++b < h) && e(t[b], b, t); )
          ;
        return i ? Se(t, a ? 0 : b, a ? b + 1 : h) : Se(t, a ? b + 1 : 0, a ? h : b);
      }
      function Da(t, e) {
        var i = t;
        return i instanceof mt && (i = i.value()), Jo(e, function(a, h) {
          return h.func.apply(h.thisArg, tn([a], h.args));
        }, i);
      }
      function gi(t, e, i) {
        var a = t.length;
        if (a < 2)
          return a ? on(t[0]) : [];
        for (var h = -1, b = N(a); ++h < a; )
          for (var w = t[h], E = -1; ++E < a; )
            E != h && (b[h] = ir(b[h] || w, t[E], e, i));
        return on(Xt(b, 1), e, i);
      }
      function Pa(t, e, i) {
        for (var a = -1, h = t.length, b = e.length, w = {}; ++a < h; ) {
          var E = a < b ? e[a] : n;
          i(w, t[a], E);
        }
        return w;
      }
      function mi(t) {
        return Dt(t) ? t : [];
      }
      function bi(t) {
        return typeof t == "function" ? t : ae;
      }
      function sn(t, e) {
        return ht(t) ? t : xi(t, e) ? [t] : pc(Ct(t));
      }
      var Ul = vt;
      function an(t, e, i) {
        var a = t.length;
        return i = i === n ? a : i, !e && i >= a ? t : Se(t, e, i);
      }
      var Ma = wh || function(t) {
        return Jt.clearTimeout(t);
      };
      function qa(t, e) {
        if (e)
          return t.slice();
        var i = t.length, a = aa ? aa(i) : new t.constructor(i);
        return t.copy(a), a;
      }
      function _i(t) {
        var e = new t.constructor(t.byteLength);
        return new Ir(e).set(new Ir(t)), e;
      }
      function jl(t, e) {
        var i = e ? _i(t.buffer) : t.buffer;
        return new t.constructor(i, t.byteOffset, t.byteLength);
      }
      function Dl(t) {
        var e = new t.constructor(t.source, Ss.exec(t));
        return e.lastIndex = t.lastIndex, e;
      }
      function Pl(t) {
        return rr ? Ot(rr.call(t)) : {};
      }
      function Fa(t, e) {
        var i = e ? _i(t.buffer) : t.buffer;
        return new t.constructor(i, t.byteOffset, t.length);
      }
      function Wa(t, e) {
        if (t !== e) {
          var i = t !== n, a = t === null, h = t === t, b = ye(t), w = e !== n, E = e === null, T = e === e, M = ye(e);
          if (!E && !M && !b && t > e || b && w && T && !E && !M || a && w && T || !i && T || !h)
            return 1;
          if (!a && !b && !M && t < e || M && i && h && !a && !b || E && i && h || !w && h || !T)
            return -1;
        }
        return 0;
      }
      function Ml(t, e, i) {
        for (var a = -1, h = t.criteria, b = e.criteria, w = h.length, E = i.length; ++a < w; ) {
          var T = Wa(h[a], b[a]);
          if (T) {
            if (a >= E)
              return T;
            var M = i[a];
            return T * (M == "desc" ? -1 : 1);
          }
        }
        return t.index - e.index;
      }
      function za(t, e, i, a) {
        for (var h = -1, b = t.length, w = i.length, E = -1, T = e.length, M = Wt(b - w, 0), q = N(T + M), F = !a; ++E < T; )
          q[E] = e[E];
        for (; ++h < w; )
          (F || h < b) && (q[i[h]] = t[h]);
        for (; M--; )
          q[E++] = t[h++];
        return q;
      }
      function Va(t, e, i, a) {
        for (var h = -1, b = t.length, w = -1, E = i.length, T = -1, M = e.length, q = Wt(b - E, 0), F = N(q + M), $ = !a; ++h < q; )
          F[h] = t[h];
        for (var tt = h; ++T < M; )
          F[tt + T] = e[T];
        for (; ++w < E; )
          ($ || h < b) && (F[tt + i[w]] = t[h++]);
        return F;
      }
      function oe(t, e) {
        var i = -1, a = t.length;
        for (e || (e = N(a)); ++i < a; )
          e[i] = t[i];
        return e;
      }
      function De(t, e, i, a) {
        var h = !i;
        i || (i = {});
        for (var b = -1, w = e.length; ++b < w; ) {
          var E = e[b], T = a ? a(i[E], t[E], E, i, t) : n;
          T === n && (T = t[E]), h ? ze(i, E, T) : or(i, E, T);
        }
        return i;
      }
      function ql(t, e) {
        return De(t, Ti(t), e);
      }
      function Fl(t, e) {
        return De(t, rc(t), e);
      }
      function Hr(t, e) {
        return function(i, a) {
          var h = ht(i) ? Xf : ul, b = e ? e() : {};
          return h(i, t, ot(a, 2), b);
        };
      }
      function Un(t) {
        return vt(function(e, i) {
          var a = -1, h = i.length, b = h > 1 ? i[h - 1] : n, w = h > 2 ? i[2] : n;
          for (b = t.length > 3 && typeof b == "function" ? (h--, b) : n, w && ne(i[0], i[1], w) && (b = h < 3 ? n : b, h = 1), e = Ot(e); ++a < h; ) {
            var E = i[a];
            E && t(e, E, a, b);
          }
          return e;
        });
      }
      function Ja(t, e) {
        return function(i, a) {
          if (i == null)
            return i;
          if (!ie(i))
            return t(i, a);
          for (var h = i.length, b = e ? h : -1, w = Ot(i); (e ? b-- : ++b < h) && a(w[b], b, w) !== !1; )
            ;
          return i;
        };
      }
      function Xa(t) {
        return function(e, i, a) {
          for (var h = -1, b = Ot(e), w = a(e), E = w.length; E--; ) {
            var T = w[t ? E : ++h];
            if (i(b[T], T, b) === !1)
              break;
          }
          return e;
        };
      }
      function Wl(t, e, i) {
        var a = e & S, h = ur(t);
        function b() {
          var w = this && this !== Jt && this instanceof b ? h : t;
          return w.apply(a ? i : this, arguments);
        }
        return b;
      }
      function Ka(t) {
        return function(e) {
          e = Ct(e);
          var i = xn(e) ? xe(e) : n, a = i ? i[0] : e.charAt(0), h = i ? an(i, 1).join("") : e.slice(1);
          return a[t]() + h;
        };
      }
      function jn(t) {
        return function(e) {
          return Jo(Jc(Vc(e).replace(Rf, "")), t, "");
        };
      }
      function ur(t) {
        return function() {
          var e = arguments;
          switch (e.length) {
            case 0:
              return new t();
            case 1:
              return new t(e[0]);
            case 2:
              return new t(e[0], e[1]);
            case 3:
              return new t(e[0], e[1], e[2]);
            case 4:
              return new t(e[0], e[1], e[2], e[3]);
            case 5:
              return new t(e[0], e[1], e[2], e[3], e[4]);
            case 6:
              return new t(e[0], e[1], e[2], e[3], e[4], e[5]);
            case 7:
              return new t(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
          }
          var i = Ln(t.prototype), a = t.apply(i, e);
          return Ut(a) ? a : i;
        };
      }
      function zl(t, e, i) {
        var a = ur(t);
        function h() {
          for (var b = arguments.length, w = N(b), E = b, T = Dn(h); E--; )
            w[E] = arguments[E];
          var M = b < 3 && w[0] !== T && w[b - 1] !== T ? [] : en(w, T);
          if (b -= M.length, b < i)
            return Ga(
              t,
              e,
              $r,
              h.placeholder,
              n,
              w,
              M,
              n,
              n,
              i - b
            );
          var q = this && this !== Jt && this instanceof h ? a : t;
          return le(q, this, w);
        }
        return h;
      }
      function Ha(t) {
        return function(e, i, a) {
          var h = Ot(e);
          if (!ie(e)) {
            var b = ot(i, 3);
            e = Vt(e), i = function(E) {
              return b(h[E], E, h);
            };
          }
          var w = t(e, i, a);
          return w > -1 ? h[b ? e[w] : w] : n;
        };
      }
      function $a(t) {
        return Je(function(e) {
          var i = e.length, a = i, h = ke.prototype.thru;
          for (t && e.reverse(); a--; ) {
            var b = e[a];
            if (typeof b != "function")
              throw new _e(g);
            if (h && !w && Zr(b) == "wrapper")
              var w = new ke([], !0);
          }
          for (a = w ? a : i; ++a < i; ) {
            b = e[a];
            var E = Zr(b), T = E == "wrapper" ? Ci(b) : n;
            T && Oi(T[0]) && T[1] == (B | H | U | D) && !T[4].length && T[9] == 1 ? w = w[Zr(T[0])].apply(w, T[3]) : w = b.length == 1 && Oi(b) ? w[E]() : w.thru(b);
          }
          return function() {
            var M = arguments, q = M[0];
            if (w && M.length == 1 && ht(q))
              return w.plant(q).value();
            for (var F = 0, $ = i ? e[F].apply(this, M) : q; ++F < i; )
              $ = e[F].call(this, $);
            return $;
          };
        });
      }
      function $r(t, e, i, a, h, b, w, E, T, M) {
        var q = e & B, F = e & S, $ = e & L, tt = e & (H | R), it = e & O, yt = $ ? n : ur(t);
        function st() {
          for (var gt = arguments.length, bt = N(gt), ve = gt; ve--; )
            bt[ve] = arguments[ve];
          if (tt)
            var re = Dn(st), ge = eh(bt, re);
          if (a && (bt = za(bt, a, h, tt)), b && (bt = Va(bt, b, w, tt)), gt -= ge, tt && gt < M) {
            var Pt = en(bt, re);
            return Ga(
              t,
              e,
              $r,
              st.placeholder,
              i,
              bt,
              Pt,
              E,
              T,
              M - gt
            );
          }
          var Be = F ? i : this, $e = $ ? Be[t] : t;
          return gt = bt.length, E ? bt = up(bt, E) : it && gt > 1 && bt.reverse(), q && T < gt && (bt.length = T), this && this !== Jt && this instanceof st && ($e = yt || ur($e)), $e.apply(Be, bt);
        }
        return st;
      }
      function Ya(t, e) {
        return function(i, a) {
          return gl(i, t, e(a), {});
        };
      }
      function Yr(t, e) {
        return function(i, a) {
          var h;
          if (i === n && a === n)
            return e;
          if (i !== n && (h = i), a !== n) {
            if (h === n)
              return a;
            typeof i == "string" || typeof a == "string" ? (i = de(i), a = de(a)) : (i = Ua(i), a = Ua(a)), h = t(i, a);
          }
          return h;
        };
      }
      function ki(t) {
        return Je(function(e) {
          return e = Lt(e, pe(ot())), vt(function(i) {
            var a = this;
            return t(e, function(h) {
              return le(h, a, i);
            });
          });
        });
      }
      function Qr(t, e) {
        e = e === n ? " " : de(e);
        var i = e.length;
        if (i < 2)
          return i ? di(e, t) : e;
        var a = di(e, Dr(t / On(e)));
        return xn(e) ? an(xe(a), 0, t).join("") : a.slice(0, t);
      }
      function Vl(t, e, i, a) {
        var h = e & S, b = ur(t);
        function w() {
          for (var E = -1, T = arguments.length, M = -1, q = a.length, F = N(q + T), $ = this && this !== Jt && this instanceof w ? b : t; ++M < q; )
            F[M] = a[M];
          for (; T--; )
            F[M++] = arguments[++E];
          return le($, h ? i : this, F);
        }
        return w;
      }
      function Qa(t) {
        return function(e, i, a) {
          return a && typeof a != "number" && ne(e, i, a) && (i = a = n), e = He(e), i === n ? (i = e, e = 0) : i = He(i), a = a === n ? e < i ? 1 : -1 : He(a), Ol(e, i, a, t);
        };
      }
      function Gr(t) {
        return function(e, i) {
          return typeof e == "string" && typeof i == "string" || (e = Ce(e), i = Ce(i)), t(e, i);
        };
      }
      function Ga(t, e, i, a, h, b, w, E, T, M) {
        var q = e & H, F = q ? w : n, $ = q ? n : w, tt = q ? b : n, it = q ? n : b;
        e |= q ? U : x, e &= ~(q ? x : U), e & Y || (e &= ~(S | L));
        var yt = [
          t,
          e,
          h,
          tt,
          F,
          it,
          $,
          E,
          T,
          M
        ], st = i.apply(n, yt);
        return Oi(t) && fc(st, yt), st.placeholder = a, hc(st, t, e);
      }
      function wi(t) {
        var e = Ft[t];
        return function(i, a) {
          if (i = Ce(i), a = a == null ? 0 : Yt(dt(a), 292), a && ha(i)) {
            var h = (Ct(i) + "e").split("e"), b = e(h[0] + "e" + (+h[1] + a));
            return h = (Ct(b) + "e").split("e"), +(h[0] + "e" + (+h[1] - a));
          }
          return e(i);
        };
      }
      var Jl = Rn && 1 / Tr(new Rn([, -0]))[1] == At ? function(t) {
        return new Rn(t);
      } : Vi;
      function Za(t) {
        return function(e) {
          var i = Qt(e);
          return i == It ? Go(e) : i == te ? ch(e) : th(e, t(e));
        };
      }
      function Ve(t, e, i, a, h, b, w, E) {
        var T = e & L;
        if (!T && typeof t != "function")
          throw new _e(g);
        var M = a ? a.length : 0;
        if (M || (e &= ~(U | x), a = h = n), w = w === n ? w : Wt(dt(w), 0), E = E === n ? E : dt(E), M -= h ? h.length : 0, e & x) {
          var q = a, F = h;
          a = h = n;
        }
        var $ = T ? n : Ci(t), tt = [
          t,
          e,
          i,
          a,
          h,
          q,
          F,
          b,
          w,
          E
        ];
        if ($ && sp(tt, $), t = tt[0], e = tt[1], i = tt[2], a = tt[3], h = tt[4], E = tt[9] = tt[9] === n ? T ? 0 : t.length : Wt(tt[9] - M, 0), !E && e & (H | R) && (e &= ~(H | R)), !e || e == S)
          var it = Wl(t, e, i);
        else
          e == H || e == R ? it = zl(t, e, E) : (e == U || e == (S | U)) && !h.length ? it = Vl(t, e, i, a) : it = $r.apply(n, tt);
        var yt = $ ? Ia : fc;
        return hc(yt(it, tt), t, e);
      }
      function tc(t, e, i, a) {
        return t === n || Ne(t, Bn[i]) && !Tt.call(a, i) ? e : t;
      }
      function ec(t, e, i, a, h, b) {
        return Ut(t) && Ut(e) && (b.set(e, t), Jr(t, e, n, ec, b), b.delete(e)), t;
      }
      function Xl(t) {
        return lr(t) ? n : t;
      }
      function nc(t, e, i, a, h, b) {
        var w = i & k, E = t.length, T = e.length;
        if (E != T && !(w && T > E))
          return !1;
        var M = b.get(t), q = b.get(e);
        if (M && q)
          return M == e && q == t;
        var F = -1, $ = !0, tt = i & C ? new vn() : n;
        for (b.set(t, e), b.set(e, t); ++F < E; ) {
          var it = t[F], yt = e[F];
          if (a)
            var st = w ? a(yt, it, F, e, t, b) : a(it, yt, F, t, e, b);
          if (st !== n) {
            if (st)
              continue;
            $ = !1;
            break;
          }
          if (tt) {
            if (!Xo(e, function(gt, bt) {
              if (!Gn(tt, bt) && (it === gt || h(it, gt, i, a, b)))
                return tt.push(bt);
            })) {
              $ = !1;
              break;
            }
          } else if (!(it === yt || h(it, yt, i, a, b))) {
            $ = !1;
            break;
          }
        }
        return b.delete(t), b.delete(e), $;
      }
      function Kl(t, e, i, a, h, b, w) {
        switch (i) {
          case Cn:
            if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
              return !1;
            t = t.buffer, e = e.buffer;
          case Ge:
            return !(t.byteLength != e.byteLength || !b(new Ir(t), new Ir(e)));
          case et:
          case nt:
          case Te:
            return Ne(+t, +e);
          case at:
            return t.name == e.name && t.message == e.message;
          case Zt:
          case Le:
            return t == e + "";
          case It:
            var E = Go;
          case te:
            var T = a & k;
            if (E || (E = Tr), t.size != e.size && !T)
              return !1;
            var M = w.get(t);
            if (M)
              return M == e;
            a |= C, w.set(t, e);
            var q = nc(E(t), E(e), a, h, b, w);
            return w.delete(t), q;
          case Ue:
            if (rr)
              return rr.call(t) == rr.call(e);
        }
        return !1;
      }
      function Hl(t, e, i, a, h, b) {
        var w = i & k, E = Si(t), T = E.length, M = Si(e), q = M.length;
        if (T != q && !w)
          return !1;
        for (var F = T; F--; ) {
          var $ = E[F];
          if (!(w ? $ in e : Tt.call(e, $)))
            return !1;
        }
        var tt = b.get(t), it = b.get(e);
        if (tt && it)
          return tt == e && it == t;
        var yt = !0;
        b.set(t, e), b.set(e, t);
        for (var st = w; ++F < T; ) {
          $ = E[F];
          var gt = t[$], bt = e[$];
          if (a)
            var ve = w ? a(bt, gt, $, e, t, b) : a(gt, bt, $, t, e, b);
          if (!(ve === n ? gt === bt || h(gt, bt, i, a, b) : ve)) {
            yt = !1;
            break;
          }
          st || (st = $ == "constructor");
        }
        if (yt && !st) {
          var re = t.constructor, ge = e.constructor;
          re != ge && "constructor" in t && "constructor" in e && !(typeof re == "function" && re instanceof re && typeof ge == "function" && ge instanceof ge) && (yt = !1);
        }
        return b.delete(t), b.delete(e), yt;
      }
      function Je(t) {
        return Bi(cc(t, n, gc), t + "");
      }
      function Si(t) {
        return wa(t, Vt, Ti);
      }
      function Ei(t) {
        return wa(t, se, rc);
      }
      var Ci = Mr ? function(t) {
        return Mr.get(t);
      } : Vi;
      function Zr(t) {
        for (var e = t.name + "", i = In[e], a = Tt.call(In, e) ? i.length : 0; a--; ) {
          var h = i[a], b = h.func;
          if (b == null || b == t)
            return h.name;
        }
        return e;
      }
      function Dn(t) {
        var e = Tt.call(v, "placeholder") ? v : t;
        return e.placeholder;
      }
      function ot() {
        var t = v.iteratee || Wi;
        return t = t === Wi ? Ca : t, arguments.length ? t(arguments[0], arguments[1]) : t;
      }
      function to(t, e) {
        var i = t.__data__;
        return np(e) ? i[typeof e == "string" ? "string" : "hash"] : i.map;
      }
      function Ai(t) {
        for (var e = Vt(t), i = e.length; i--; ) {
          var a = e[i], h = t[a];
          e[i] = [a, h, sc(h)];
        }
        return e;
      }
      function bn(t, e) {
        var i = ih(t, e);
        return Ea(i) ? i : n;
      }
      function $l(t) {
        var e = Tt.call(t, dn), i = t[dn];
        try {
          t[dn] = n;
          var a = !0;
        } catch (b) {
        }
        var h = Br.call(t);
        return a && (e ? t[dn] = i : delete t[dn]), h;
      }
      var Ti = ti ? function(t) {
        return t == null ? [] : (t = Ot(t), Ze(ti(t), function(e) {
          return ua.call(t, e);
        }));
      } : Ji, rc = ti ? function(t) {
        for (var e = []; t; )
          tn(e, Ti(t)), t = Lr(t);
        return e;
      } : Ji, Qt = ee;
      (ei && Qt(new ei(new ArrayBuffer(1))) != Cn || tr && Qt(new tr()) != It || ni && Qt(ni.resolve()) != En || Rn && Qt(new Rn()) != te || er && Qt(new er()) != qe) && (Qt = function(t) {
        var e = ee(t), i = e == he ? t.constructor : n, a = i ? _n(i) : "";
        if (a)
          switch (a) {
            case Bh:
              return Cn;
            case Rh:
              return It;
            case Ih:
              return En;
            case Lh:
              return te;
            case Uh:
              return qe;
          }
        return e;
      });
      function Yl(t, e, i) {
        for (var a = -1, h = i.length; ++a < h; ) {
          var b = i[a], w = b.size;
          switch (b.type) {
            case "drop":
              t += w;
              break;
            case "dropRight":
              e -= w;
              break;
            case "take":
              e = Yt(e, t + w);
              break;
            case "takeRight":
              t = Wt(t, e - w);
              break;
          }
        }
        return { start: t, end: e };
      }
      function Ql(t) {
        var e = t.match(nf);
        return e ? e[1].split(rf) : [];
      }
      function oc(t, e, i) {
        e = sn(e, t);
        for (var a = -1, h = e.length, b = !1; ++a < h; ) {
          var w = Pe(e[a]);
          if (!(b = t != null && i(t, w)))
            break;
          t = t[w];
        }
        return b || ++a != h ? b : (h = t == null ? 0 : t.length, !!h && ao(h) && Xe(w, h) && (ht(t) || kn(t)));
      }
      function Gl(t) {
        var e = t.length, i = new t.constructor(e);
        return e && typeof t[0] == "string" && Tt.call(t, "index") && (i.index = t.index, i.input = t.input), i;
      }
      function ic(t) {
        return typeof t.constructor == "function" && !fr(t) ? Ln(Lr(t)) : {};
      }
      function Zl(t, e, i) {
        var a = t.constructor;
        switch (e) {
          case Ge:
            return _i(t);
          case et:
          case nt:
            return new a(+t);
          case Cn:
            return jl(t, i);
          case Ao:
          case To:
          case xo:
          case Oo:
          case No:
          case Bo:
          case Ro:
          case Io:
          case Lo:
            return Fa(t, i);
          case It:
            return new a();
          case Te:
          case Le:
            return new a(t);
          case Zt:
            return Dl(t);
          case te:
            return new a();
          case Ue:
            return Pl(t);
        }
      }
      function tp(t, e) {
        var i = e.length;
        if (!i)
          return t;
        var a = i - 1;
        return e[a] = (i > 1 ? "& " : "") + e[a], e = e.join(i > 2 ? ", " : " "), t.replace(ef, `{
/* [wrapped with ` + e + `] */
`);
      }
      function ep(t) {
        return ht(t) || kn(t) || !!(fa && t && t[fa]);
      }
      function Xe(t, e) {
        var i = typeof t;
        return e = e != null ? e : ut, !!e && (i == "number" || i != "symbol" && pf.test(t)) && t > -1 && t % 1 == 0 && t < e;
      }
      function ne(t, e, i) {
        if (!Ut(i))
          return !1;
        var a = typeof e;
        return (a == "number" ? ie(i) && Xe(e, i.length) : a == "string" && e in i) ? Ne(i[e], t) : !1;
      }
      function xi(t, e) {
        if (ht(t))
          return !1;
        var i = typeof t;
        return i == "number" || i == "symbol" || i == "boolean" || t == null || ye(t) ? !0 : Qu.test(t) || !Yu.test(t) || e != null && t in Ot(e);
      }
      function np(t) {
        var e = typeof t;
        return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
      }
      function Oi(t) {
        var e = Zr(t), i = v[e];
        if (typeof i != "function" || !(e in mt.prototype))
          return !1;
        if (t === i)
          return !0;
        var a = Ci(i);
        return !!a && t === a[0];
      }
      function rp(t) {
        return !!sa && sa in t;
      }
      var op = Or ? Ke : Xi;
      function fr(t) {
        var e = t && t.constructor, i = typeof e == "function" && e.prototype || Bn;
        return t === i;
      }
      function sc(t) {
        return t === t && !Ut(t);
      }
      function ac(t, e) {
        return function(i) {
          return i == null ? !1 : i[t] === e && (e !== n || t in Ot(i));
        };
      }
      function ip(t) {
        var e = io(t, function(a) {
          return i.size === p && i.clear(), a;
        }), i = e.cache;
        return e;
      }
      function sp(t, e) {
        var i = t[1], a = e[1], h = i | a, b = h < (S | L | B), w = a == B && i == H || a == B && i == D && t[7].length <= e[8] || a == (B | D) && e[7].length <= e[8] && i == H;
        if (!(b || w))
          return t;
        a & S && (t[2] = e[2], h |= i & S ? 0 : Y);
        var E = e[3];
        if (E) {
          var T = t[3];
          t[3] = T ? za(T, E, e[4]) : E, t[4] = T ? en(t[3], m) : e[4];
        }
        return E = e[5], E && (T = t[5], t[5] = T ? Va(T, E, e[6]) : E, t[6] = T ? en(t[5], m) : e[6]), E = e[7], E && (t[7] = E), a & B && (t[8] = t[8] == null ? e[8] : Yt(t[8], e[8])), t[9] == null && (t[9] = e[9]), t[0] = e[0], t[1] = h, t;
      }
      function ap(t) {
        var e = [];
        if (t != null)
          for (var i in Ot(t))
            e.push(i);
        return e;
      }
      function cp(t) {
        return Br.call(t);
      }
      function cc(t, e, i) {
        return e = Wt(e === n ? t.length - 1 : e, 0), function() {
          for (var a = arguments, h = -1, b = Wt(a.length - e, 0), w = N(b); ++h < b; )
            w[h] = a[e + h];
          h = -1;
          for (var E = N(e + 1); ++h < e; )
            E[h] = a[h];
          return E[e] = i(w), le(t, this, E);
        };
      }
      function uc(t, e) {
        return e.length < 2 ? t : mn(t, Se(e, 0, -1));
      }
      function up(t, e) {
        for (var i = t.length, a = Yt(e.length, i), h = oe(t); a--; ) {
          var b = e[a];
          t[a] = Xe(b, i) ? h[b] : n;
        }
        return t;
      }
      function Ni(t, e) {
        if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
          return t[e];
      }
      var fc = lc(Ia), hr = Eh || function(t, e) {
        return Jt.setTimeout(t, e);
      }, Bi = lc(Rl);
      function hc(t, e, i) {
        var a = e + "";
        return Bi(t, tp(a, fp(Ql(a), i)));
      }
      function lc(t) {
        var e = 0, i = 0;
        return function() {
          var a = xh(), h = X - (a - i);
          if (i = a, h > 0) {
            if (++e >= z)
              return arguments[0];
          } else
            e = 0;
          return t.apply(n, arguments);
        };
      }
      function eo(t, e) {
        var i = -1, a = t.length, h = a - 1;
        for (e = e === n ? a : e; ++i < e; ) {
          var b = pi(i, h), w = t[b];
          t[b] = t[i], t[i] = w;
        }
        return t.length = e, t;
      }
      var pc = ip(function(t) {
        var e = [];
        return t.charCodeAt(0) === 46 && e.push(""), t.replace(Gu, function(i, a, h, b) {
          e.push(h ? b.replace(af, "$1") : a || i);
        }), e;
      });
      function Pe(t) {
        if (typeof t == "string" || ye(t))
          return t;
        var e = t + "";
        return e == "0" && 1 / t == -At ? "-0" : e;
      }
      function _n(t) {
        if (t != null) {
          try {
            return Nr.call(t);
          } catch (e) {
          }
          try {
            return t + "";
          } catch (e) {
          }
        }
        return "";
      }
      function fp(t, e) {
        return be(Z, function(i) {
          var a = "_." + i[0];
          e & i[1] && !Cr(t, a) && t.push(a);
        }), t.sort();
      }
      function dc(t) {
        if (t instanceof mt)
          return t.clone();
        var e = new ke(t.__wrapped__, t.__chain__);
        return e.__actions__ = oe(t.__actions__), e.__index__ = t.__index__, e.__values__ = t.__values__, e;
      }
      function hp(t, e, i) {
        (i ? ne(t, e, i) : e === n) ? e = 1 : e = Wt(dt(e), 0);
        var a = t == null ? 0 : t.length;
        if (!a || e < 1)
          return [];
        for (var h = 0, b = 0, w = N(Dr(a / e)); h < a; )
          w[b++] = Se(t, h, h += e);
        return w;
      }
      function lp(t) {
        for (var e = -1, i = t == null ? 0 : t.length, a = 0, h = []; ++e < i; ) {
          var b = t[e];
          b && (h[a++] = b);
        }
        return h;
      }
      function pp() {
        var t = arguments.length;
        if (!t)
          return [];
        for (var e = N(t - 1), i = arguments[0], a = t; a--; )
          e[a - 1] = arguments[a];
        return tn(ht(i) ? oe(i) : [i], Xt(e, 1));
      }
      var dp = vt(function(t, e) {
        return Dt(t) ? ir(t, Xt(e, 1, Dt, !0)) : [];
      }), yp = vt(function(t, e) {
        var i = Ee(e);
        return Dt(i) && (i = n), Dt(t) ? ir(t, Xt(e, 1, Dt, !0), ot(i, 2)) : [];
      }), vp = vt(function(t, e) {
        var i = Ee(e);
        return Dt(i) && (i = n), Dt(t) ? ir(t, Xt(e, 1, Dt, !0), n, i) : [];
      });
      function gp(t, e, i) {
        var a = t == null ? 0 : t.length;
        return a ? (e = i || e === n ? 1 : dt(e), Se(t, e < 0 ? 0 : e, a)) : [];
      }
      function mp(t, e, i) {
        var a = t == null ? 0 : t.length;
        return a ? (e = i || e === n ? 1 : dt(e), e = a - e, Se(t, 0, e < 0 ? 0 : e)) : [];
      }
      function bp(t, e) {
        return t && t.length ? Kr(t, ot(e, 3), !0, !0) : [];
      }
      function _p(t, e) {
        return t && t.length ? Kr(t, ot(e, 3), !0) : [];
      }
      function kp(t, e, i, a) {
        var h = t == null ? 0 : t.length;
        return h ? (i && typeof i != "number" && ne(t, e, i) && (i = 0, a = h), pl(t, e, i, a)) : [];
      }
      function yc(t, e, i) {
        var a = t == null ? 0 : t.length;
        if (!a)
          return -1;
        var h = i == null ? 0 : dt(i);
        return h < 0 && (h = Wt(a + h, 0)), Ar(t, ot(e, 3), h);
      }
      function vc(t, e, i) {
        var a = t == null ? 0 : t.length;
        if (!a)
          return -1;
        var h = a - 1;
        return i !== n && (h = dt(i), h = i < 0 ? Wt(a + h, 0) : Yt(h, a - 1)), Ar(t, ot(e, 3), h, !0);
      }
      function gc(t) {
        var e = t == null ? 0 : t.length;
        return e ? Xt(t, 1) : [];
      }
      function wp(t) {
        var e = t == null ? 0 : t.length;
        return e ? Xt(t, At) : [];
      }
      function Sp(t, e) {
        var i = t == null ? 0 : t.length;
        return i ? (e = e === n ? 1 : dt(e), Xt(t, e)) : [];
      }
      function Ep(t) {
        for (var e = -1, i = t == null ? 0 : t.length, a = {}; ++e < i; ) {
          var h = t[e];
          a[h[0]] = h[1];
        }
        return a;
      }
      function mc(t) {
        return t && t.length ? t[0] : n;
      }
      function Cp(t, e, i) {
        var a = t == null ? 0 : t.length;
        if (!a)
          return -1;
        var h = i == null ? 0 : dt(i);
        return h < 0 && (h = Wt(a + h, 0)), Tn(t, e, h);
      }
      function Ap(t) {
        var e = t == null ? 0 : t.length;
        return e ? Se(t, 0, -1) : [];
      }
      var Tp = vt(function(t) {
        var e = Lt(t, mi);
        return e.length && e[0] === t[0] ? ci(e) : [];
      }), xp = vt(function(t) {
        var e = Ee(t), i = Lt(t, mi);
        return e === Ee(i) ? e = n : i.pop(), i.length && i[0] === t[0] ? ci(i, ot(e, 2)) : [];
      }), Op = vt(function(t) {
        var e = Ee(t), i = Lt(t, mi);
        return e = typeof e == "function" ? e : n, e && i.pop(), i.length && i[0] === t[0] ? ci(i, n, e) : [];
      });
      function Np(t, e) {
        return t == null ? "" : Ah.call(t, e);
      }
      function Ee(t) {
        var e = t == null ? 0 : t.length;
        return e ? t[e - 1] : n;
      }
      function Bp(t, e, i) {
        var a = t == null ? 0 : t.length;
        if (!a)
          return -1;
        var h = a;
        return i !== n && (h = dt(i), h = h < 0 ? Wt(a + h, 0) : Yt(h, a - 1)), e === e ? fh(t, e, h) : Ar(t, Gs, h, !0);
      }
      function Rp(t, e) {
        return t && t.length ? Oa(t, dt(e)) : n;
      }
      var Ip = vt(bc);
      function bc(t, e) {
        return t && t.length && e && e.length ? li(t, e) : t;
      }
      function Lp(t, e, i) {
        return t && t.length && e && e.length ? li(t, e, ot(i, 2)) : t;
      }
      function Up(t, e, i) {
        return t && t.length && e && e.length ? li(t, e, n, i) : t;
      }
      var jp = Je(function(t, e) {
        var i = t == null ? 0 : t.length, a = oi(t, e);
        return Ra(t, Lt(e, function(h) {
          return Xe(h, i) ? +h : h;
        }).sort(Wa)), a;
      });
      function Dp(t, e) {
        var i = [];
        if (!(t && t.length))
          return i;
        var a = -1, h = [], b = t.length;
        for (e = ot(e, 3); ++a < b; ) {
          var w = t[a];
          e(w, a, t) && (i.push(w), h.push(a));
        }
        return Ra(t, h), i;
      }
      function Ri(t) {
        return t == null ? t : Nh.call(t);
      }
      function Pp(t, e, i) {
        var a = t == null ? 0 : t.length;
        return a ? (i && typeof i != "number" && ne(t, e, i) ? (e = 0, i = a) : (e = e == null ? 0 : dt(e), i = i === n ? a : dt(i)), Se(t, e, i)) : [];
      }
      function Mp(t, e) {
        return Xr(t, e);
      }
      function qp(t, e, i) {
        return yi(t, e, ot(i, 2));
      }
      function Fp(t, e) {
        var i = t == null ? 0 : t.length;
        if (i) {
          var a = Xr(t, e);
          if (a < i && Ne(t[a], e))
            return a;
        }
        return -1;
      }
      function Wp(t, e) {
        return Xr(t, e, !0);
      }
      function zp(t, e, i) {
        return yi(t, e, ot(i, 2), !0);
      }
      function Vp(t, e) {
        var i = t == null ? 0 : t.length;
        if (i) {
          var a = Xr(t, e, !0) - 1;
          if (Ne(t[a], e))
            return a;
        }
        return -1;
      }
      function Jp(t) {
        return t && t.length ? La(t) : [];
      }
      function Xp(t, e) {
        return t && t.length ? La(t, ot(e, 2)) : [];
      }
      function Kp(t) {
        var e = t == null ? 0 : t.length;
        return e ? Se(t, 1, e) : [];
      }
      function Hp(t, e, i) {
        return t && t.length ? (e = i || e === n ? 1 : dt(e), Se(t, 0, e < 0 ? 0 : e)) : [];
      }
      function $p(t, e, i) {
        var a = t == null ? 0 : t.length;
        return a ? (e = i || e === n ? 1 : dt(e), e = a - e, Se(t, e < 0 ? 0 : e, a)) : [];
      }
      function Yp(t, e) {
        return t && t.length ? Kr(t, ot(e, 3), !1, !0) : [];
      }
      function Qp(t, e) {
        return t && t.length ? Kr(t, ot(e, 3)) : [];
      }
      var Gp = vt(function(t) {
        return on(Xt(t, 1, Dt, !0));
      }), Zp = vt(function(t) {
        var e = Ee(t);
        return Dt(e) && (e = n), on(Xt(t, 1, Dt, !0), ot(e, 2));
      }), td = vt(function(t) {
        var e = Ee(t);
        return e = typeof e == "function" ? e : n, on(Xt(t, 1, Dt, !0), n, e);
      });
      function ed(t) {
        return t && t.length ? on(t) : [];
      }
      function nd(t, e) {
        return t && t.length ? on(t, ot(e, 2)) : [];
      }
      function rd(t, e) {
        return e = typeof e == "function" ? e : n, t && t.length ? on(t, n, e) : [];
      }
      function Ii(t) {
        if (!(t && t.length))
          return [];
        var e = 0;
        return t = Ze(t, function(i) {
          if (Dt(i))
            return e = Wt(i.length, e), !0;
        }), Yo(e, function(i) {
          return Lt(t, Ko(i));
        });
      }
      function _c(t, e) {
        if (!(t && t.length))
          return [];
        var i = Ii(t);
        return e == null ? i : Lt(i, function(a) {
          return le(e, n, a);
        });
      }
      var od = vt(function(t, e) {
        return Dt(t) ? ir(t, e) : [];
      }), id = vt(function(t) {
        return gi(Ze(t, Dt));
      }), sd = vt(function(t) {
        var e = Ee(t);
        return Dt(e) && (e = n), gi(Ze(t, Dt), ot(e, 2));
      }), ad = vt(function(t) {
        var e = Ee(t);
        return e = typeof e == "function" ? e : n, gi(Ze(t, Dt), n, e);
      }), cd = vt(Ii);
      function ud(t, e) {
        return Pa(t || [], e || [], or);
      }
      function fd(t, e) {
        return Pa(t || [], e || [], cr);
      }
      var hd = vt(function(t) {
        var e = t.length, i = e > 1 ? t[e - 1] : n;
        return i = typeof i == "function" ? (t.pop(), i) : n, _c(t, i);
      });
      function kc(t) {
        var e = v(t);
        return e.__chain__ = !0, e;
      }
      function ld(t, e) {
        return e(t), t;
      }
      function no(t, e) {
        return e(t);
      }
      var pd = Je(function(t) {
        var e = t.length, i = e ? t[0] : 0, a = this.__wrapped__, h = function(b) {
          return oi(b, t);
        };
        return e > 1 || this.__actions__.length || !(a instanceof mt) || !Xe(i) ? this.thru(h) : (a = a.slice(i, +i + (e ? 1 : 0)), a.__actions__.push({
          func: no,
          args: [h],
          thisArg: n
        }), new ke(a, this.__chain__).thru(function(b) {
          return e && !b.length && b.push(n), b;
        }));
      });
      function dd() {
        return kc(this);
      }
      function yd() {
        return new ke(this.value(), this.__chain__);
      }
      function vd() {
        this.__values__ === n && (this.__values__ = Uc(this.value()));
        var t = this.__index__ >= this.__values__.length, e = t ? n : this.__values__[this.__index__++];
        return { done: t, value: e };
      }
      function gd() {
        return this;
      }
      function md(t) {
        for (var e, i = this; i instanceof Fr; ) {
          var a = dc(i);
          a.__index__ = 0, a.__values__ = n, e ? h.__wrapped__ = a : e = a;
          var h = a;
          i = i.__wrapped__;
        }
        return h.__wrapped__ = t, e;
      }
      function bd() {
        var t = this.__wrapped__;
        if (t instanceof mt) {
          var e = t;
          return this.__actions__.length && (e = new mt(this)), e = e.reverse(), e.__actions__.push({
            func: no,
            args: [Ri],
            thisArg: n
          }), new ke(e, this.__chain__);
        }
        return this.thru(Ri);
      }
      function _d() {
        return Da(this.__wrapped__, this.__actions__);
      }
      var kd = Hr(function(t, e, i) {
        Tt.call(t, i) ? ++t[i] : ze(t, i, 1);
      });
      function wd(t, e, i) {
        var a = ht(t) ? Ys : ll;
        return i && ne(t, e, i) && (e = n), a(t, ot(e, 3));
      }
      function Sd(t, e) {
        var i = ht(t) ? Ze : _a;
        return i(t, ot(e, 3));
      }
      var Ed = Ha(yc), Cd = Ha(vc);
      function Ad(t, e) {
        return Xt(ro(t, e), 1);
      }
      function Td(t, e) {
        return Xt(ro(t, e), At);
      }
      function xd(t, e, i) {
        return i = i === n ? 1 : dt(i), Xt(ro(t, e), i);
      }
      function wc(t, e) {
        var i = ht(t) ? be : rn;
        return i(t, ot(e, 3));
      }
      function Sc(t, e) {
        var i = ht(t) ? Kf : ba;
        return i(t, ot(e, 3));
      }
      var Od = Hr(function(t, e, i) {
        Tt.call(t, i) ? t[i].push(e) : ze(t, i, [e]);
      });
      function Nd(t, e, i, a) {
        t = ie(t) ? t : Mn(t), i = i && !a ? dt(i) : 0;
        var h = t.length;
        return i < 0 && (i = Wt(h + i, 0)), co(t) ? i <= h && t.indexOf(e, i) > -1 : !!h && Tn(t, e, i) > -1;
      }
      var Bd = vt(function(t, e, i) {
        var a = -1, h = typeof e == "function", b = ie(t) ? N(t.length) : [];
        return rn(t, function(w) {
          b[++a] = h ? le(e, w, i) : sr(w, e, i);
        }), b;
      }), Rd = Hr(function(t, e, i) {
        ze(t, i, e);
      });
      function ro(t, e) {
        var i = ht(t) ? Lt : Aa;
        return i(t, ot(e, 3));
      }
      function Id(t, e, i, a) {
        return t == null ? [] : (ht(e) || (e = e == null ? [] : [e]), i = a ? n : i, ht(i) || (i = i == null ? [] : [i]), Na(t, e, i));
      }
      var Ld = Hr(function(t, e, i) {
        t[i ? 0 : 1].push(e);
      }, function() {
        return [[], []];
      });
      function Ud(t, e, i) {
        var a = ht(t) ? Jo : ta, h = arguments.length < 3;
        return a(t, ot(e, 4), i, h, rn);
      }
      function jd(t, e, i) {
        var a = ht(t) ? Hf : ta, h = arguments.length < 3;
        return a(t, ot(e, 4), i, h, ba);
      }
      function Dd(t, e) {
        var i = ht(t) ? Ze : _a;
        return i(t, so(ot(e, 3)));
      }
      function Pd(t) {
        var e = ht(t) ? ya : Nl;
        return e(t);
      }
      function Md(t, e, i) {
        (i ? ne(t, e, i) : e === n) ? e = 1 : e = dt(e);
        var a = ht(t) ? al : Bl;
        return a(t, e);
      }
      function qd(t) {
        var e = ht(t) ? cl : Il;
        return e(t);
      }
      function Fd(t) {
        if (t == null)
          return 0;
        if (ie(t))
          return co(t) ? On(t) : t.length;
        var e = Qt(t);
        return e == It || e == te ? t.size : fi(t).length;
      }
      function Wd(t, e, i) {
        var a = ht(t) ? Xo : Ll;
        return i && ne(t, e, i) && (e = n), a(t, ot(e, 3));
      }
      var zd = vt(function(t, e) {
        if (t == null)
          return [];
        var i = e.length;
        return i > 1 && ne(t, e[0], e[1]) ? e = [] : i > 2 && ne(e[0], e[1], e[2]) && (e = [e[0]]), Na(t, Xt(e, 1), []);
      }), oo = Sh || function() {
        return Jt.Date.now();
      };
      function Vd(t, e) {
        if (typeof e != "function")
          throw new _e(g);
        return t = dt(t), function() {
          if (--t < 1)
            return e.apply(this, arguments);
        };
      }
      function Ec(t, e, i) {
        return e = i ? n : e, e = t && e == null ? t.length : e, Ve(t, B, n, n, n, n, e);
      }
      function Cc(t, e) {
        var i;
        if (typeof e != "function")
          throw new _e(g);
        return t = dt(t), function() {
          return --t > 0 && (i = e.apply(this, arguments)), t <= 1 && (e = n), i;
        };
      }
      var Li = vt(function(t, e, i) {
        var a = S;
        if (i.length) {
          var h = en(i, Dn(Li));
          a |= U;
        }
        return Ve(t, a, e, i, h);
      }), Ac = vt(function(t, e, i) {
        var a = S | L;
        if (i.length) {
          var h = en(i, Dn(Ac));
          a |= U;
        }
        return Ve(e, a, t, i, h);
      });
      function Tc(t, e, i) {
        e = i ? n : e;
        var a = Ve(t, H, n, n, n, n, n, e);
        return a.placeholder = Tc.placeholder, a;
      }
      function xc(t, e, i) {
        e = i ? n : e;
        var a = Ve(t, R, n, n, n, n, n, e);
        return a.placeholder = xc.placeholder, a;
      }
      function Oc(t, e, i) {
        var a, h, b, w, E, T, M = 0, q = !1, F = !1, $ = !0;
        if (typeof t != "function")
          throw new _e(g);
        e = Ce(e) || 0, Ut(i) && (q = !!i.leading, F = "maxWait" in i, b = F ? Wt(Ce(i.maxWait) || 0, e) : b, $ = "trailing" in i ? !!i.trailing : $);
        function tt(Pt) {
          var Be = a, $e = h;
          return a = h = n, M = Pt, w = t.apply($e, Be), w;
        }
        function it(Pt) {
          return M = Pt, E = hr(gt, e), q ? tt(Pt) : w;
        }
        function yt(Pt) {
          var Be = Pt - T, $e = Pt - M, Hc = e - Be;
          return F ? Yt(Hc, b - $e) : Hc;
        }
        function st(Pt) {
          var Be = Pt - T, $e = Pt - M;
          return T === n || Be >= e || Be < 0 || F && $e >= b;
        }
        function gt() {
          var Pt = oo();
          if (st(Pt))
            return bt(Pt);
          E = hr(gt, yt(Pt));
        }
        function bt(Pt) {
          return E = n, $ && a ? tt(Pt) : (a = h = n, w);
        }
        function ve() {
          E !== n && Ma(E), M = 0, a = T = h = E = n;
        }
        function re() {
          return E === n ? w : bt(oo());
        }
        function ge() {
          var Pt = oo(), Be = st(Pt);
          if (a = arguments, h = this, T = Pt, Be) {
            if (E === n)
              return it(T);
            if (F)
              return Ma(E), E = hr(gt, e), tt(T);
          }
          return E === n && (E = hr(gt, e)), w;
        }
        return ge.cancel = ve, ge.flush = re, ge;
      }
      var Jd = vt(function(t, e) {
        return ma(t, 1, e);
      }), Xd = vt(function(t, e, i) {
        return ma(t, Ce(e) || 0, i);
      });
      function Kd(t) {
        return Ve(t, O);
      }
      function io(t, e) {
        if (typeof t != "function" || e != null && typeof e != "function")
          throw new _e(g);
        var i = function() {
          var a = arguments, h = e ? e.apply(this, a) : a[0], b = i.cache;
          if (b.has(h))
            return b.get(h);
          var w = t.apply(this, a);
          return i.cache = b.set(h, w) || b, w;
        };
        return i.cache = new (io.Cache || We)(), i;
      }
      io.Cache = We;
      function so(t) {
        if (typeof t != "function")
          throw new _e(g);
        return function() {
          var e = arguments;
          switch (e.length) {
            case 0:
              return !t.call(this);
            case 1:
              return !t.call(this, e[0]);
            case 2:
              return !t.call(this, e[0], e[1]);
            case 3:
              return !t.call(this, e[0], e[1], e[2]);
          }
          return !t.apply(this, e);
        };
      }
      function Hd(t) {
        return Cc(2, t);
      }
      var $d = Ul(function(t, e) {
        e = e.length == 1 && ht(e[0]) ? Lt(e[0], pe(ot())) : Lt(Xt(e, 1), pe(ot()));
        var i = e.length;
        return vt(function(a) {
          for (var h = -1, b = Yt(a.length, i); ++h < b; )
            a[h] = e[h].call(this, a[h]);
          return le(t, this, a);
        });
      }), Ui = vt(function(t, e) {
        var i = en(e, Dn(Ui));
        return Ve(t, U, n, e, i);
      }), Nc = vt(function(t, e) {
        var i = en(e, Dn(Nc));
        return Ve(t, x, n, e, i);
      }), Yd = Je(function(t, e) {
        return Ve(t, D, n, n, n, e);
      });
      function Qd(t, e) {
        if (typeof t != "function")
          throw new _e(g);
        return e = e === n ? e : dt(e), vt(t, e);
      }
      function Gd(t, e) {
        if (typeof t != "function")
          throw new _e(g);
        return e = e == null ? 0 : Wt(dt(e), 0), vt(function(i) {
          var a = i[e], h = an(i, 0, e);
          return a && tn(h, a), le(t, this, h);
        });
      }
      function Zd(t, e, i) {
        var a = !0, h = !0;
        if (typeof t != "function")
          throw new _e(g);
        return Ut(i) && (a = "leading" in i ? !!i.leading : a, h = "trailing" in i ? !!i.trailing : h), Oc(t, e, {
          leading: a,
          maxWait: e,
          trailing: h
        });
      }
      function ty(t) {
        return Ec(t, 1);
      }
      function ey(t, e) {
        return Ui(bi(e), t);
      }
      function ny() {
        if (!arguments.length)
          return [];
        var t = arguments[0];
        return ht(t) ? t : [t];
      }
      function ry(t) {
        return we(t, u);
      }
      function oy(t, e) {
        return e = typeof e == "function" ? e : n, we(t, u, e);
      }
      function iy(t) {
        return we(t, d | u);
      }
      function sy(t, e) {
        return e = typeof e == "function" ? e : n, we(t, d | u, e);
      }
      function ay(t, e) {
        return e == null || ga(t, e, Vt(e));
      }
      function Ne(t, e) {
        return t === e || t !== t && e !== e;
      }
      var cy = Gr(ai), uy = Gr(function(t, e) {
        return t >= e;
      }), kn = Sa(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Sa : function(t) {
        return jt(t) && Tt.call(t, "callee") && !ua.call(t, "callee");
      }, ht = N.isArray, fy = Vs ? pe(Vs) : ml;
      function ie(t) {
        return t != null && ao(t.length) && !Ke(t);
      }
      function Dt(t) {
        return jt(t) && ie(t);
      }
      function hy(t) {
        return t === !0 || t === !1 || jt(t) && ee(t) == et;
      }
      var cn = Ch || Xi, ly = Js ? pe(Js) : bl;
      function py(t) {
        return jt(t) && t.nodeType === 1 && !lr(t);
      }
      function dy(t) {
        if (t == null)
          return !0;
        if (ie(t) && (ht(t) || typeof t == "string" || typeof t.splice == "function" || cn(t) || Pn(t) || kn(t)))
          return !t.length;
        var e = Qt(t);
        if (e == It || e == te)
          return !t.size;
        if (fr(t))
          return !fi(t).length;
        for (var i in t)
          if (Tt.call(t, i))
            return !1;
        return !0;
      }
      function yy(t, e) {
        return ar(t, e);
      }
      function vy(t, e, i) {
        i = typeof i == "function" ? i : n;
        var a = i ? i(t, e) : n;
        return a === n ? ar(t, e, n, i) : !!a;
      }
      function ji(t) {
        if (!jt(t))
          return !1;
        var e = ee(t);
        return e == at || e == G || typeof t.message == "string" && typeof t.name == "string" && !lr(t);
      }
      function gy(t) {
        return typeof t == "number" && ha(t);
      }
      function Ke(t) {
        if (!Ut(t))
          return !1;
        var e = ee(t);
        return e == Et || e == $t || e == V || e == $n;
      }
      function Bc(t) {
        return typeof t == "number" && t == dt(t);
      }
      function ao(t) {
        return typeof t == "number" && t > -1 && t % 1 == 0 && t <= ut;
      }
      function Ut(t) {
        var e = typeof t;
        return t != null && (e == "object" || e == "function");
      }
      function jt(t) {
        return t != null && typeof t == "object";
      }
      var Rc = Xs ? pe(Xs) : kl;
      function my(t, e) {
        return t === e || ui(t, e, Ai(e));
      }
      function by(t, e, i) {
        return i = typeof i == "function" ? i : n, ui(t, e, Ai(e), i);
      }
      function _y(t) {
        return Ic(t) && t != +t;
      }
      function ky(t) {
        if (op(t))
          throw new ft(f);
        return Ea(t);
      }
      function wy(t) {
        return t === null;
      }
      function Sy(t) {
        return t == null;
      }
      function Ic(t) {
        return typeof t == "number" || jt(t) && ee(t) == Te;
      }
      function lr(t) {
        if (!jt(t) || ee(t) != he)
          return !1;
        var e = Lr(t);
        if (e === null)
          return !0;
        var i = Tt.call(e, "constructor") && e.constructor;
        return typeof i == "function" && i instanceof i && Nr.call(i) == bh;
      }
      var Di = Ks ? pe(Ks) : wl;
      function Ey(t) {
        return Bc(t) && t >= -ut && t <= ut;
      }
      var Lc = Hs ? pe(Hs) : Sl;
      function co(t) {
        return typeof t == "string" || !ht(t) && jt(t) && ee(t) == Le;
      }
      function ye(t) {
        return typeof t == "symbol" || jt(t) && ee(t) == Ue;
      }
      var Pn = $s ? pe($s) : El;
      function Cy(t) {
        return t === n;
      }
      function Ay(t) {
        return jt(t) && Qt(t) == qe;
      }
      function Ty(t) {
        return jt(t) && ee(t) == Qn;
      }
      var xy = Gr(hi), Oy = Gr(function(t, e) {
        return t <= e;
      });
      function Uc(t) {
        if (!t)
          return [];
        if (ie(t))
          return co(t) ? xe(t) : oe(t);
        if (Zn && t[Zn])
          return ah(t[Zn]());
        var e = Qt(t), i = e == It ? Go : e == te ? Tr : Mn;
        return i(t);
      }
      function He(t) {
        if (!t)
          return t === 0 ? t : 0;
        if (t = Ce(t), t === At || t === -At) {
          var e = t < 0 ? -1 : 1;
          return e * Ht;
        }
        return t === t ? t : 0;
      }
      function dt(t) {
        var e = He(t), i = e % 1;
        return e === e ? i ? e - i : e : 0;
      }
      function jc(t) {
        return t ? gn(dt(t), 0, fe) : 0;
      }
      function Ce(t) {
        if (typeof t == "number")
          return t;
        if (ye(t))
          return Ie;
        if (Ut(t)) {
          var e = typeof t.valueOf == "function" ? t.valueOf() : t;
          t = Ut(e) ? e + "" : e;
        }
        if (typeof t != "string")
          return t === 0 ? t : +t;
        t = ea(t);
        var i = ff.test(t);
        return i || lf.test(t) ? Vf(t.slice(2), i ? 2 : 8) : uf.test(t) ? Ie : +t;
      }
      function Dc(t) {
        return De(t, se(t));
      }
      function Ny(t) {
        return t ? gn(dt(t), -ut, ut) : t === 0 ? t : 0;
      }
      function Ct(t) {
        return t == null ? "" : de(t);
      }
      var By = Un(function(t, e) {
        if (fr(e) || ie(e)) {
          De(e, Vt(e), t);
          return;
        }
        for (var i in e)
          Tt.call(e, i) && or(t, i, e[i]);
      }), Pc = Un(function(t, e) {
        De(e, se(e), t);
      }), uo = Un(function(t, e, i, a) {
        De(e, se(e), t, a);
      }), Ry = Un(function(t, e, i, a) {
        De(e, Vt(e), t, a);
      }), Iy = Je(oi);
      function Ly(t, e) {
        var i = Ln(t);
        return e == null ? i : va(i, e);
      }
      var Uy = vt(function(t, e) {
        t = Ot(t);
        var i = -1, a = e.length, h = a > 2 ? e[2] : n;
        for (h && ne(e[0], e[1], h) && (a = 1); ++i < a; )
          for (var b = e[i], w = se(b), E = -1, T = w.length; ++E < T; ) {
            var M = w[E], q = t[M];
            (q === n || Ne(q, Bn[M]) && !Tt.call(t, M)) && (t[M] = b[M]);
          }
        return t;
      }), jy = vt(function(t) {
        return t.push(n, ec), le(Mc, n, t);
      });
      function Dy(t, e) {
        return Qs(t, ot(e, 3), je);
      }
      function Py(t, e) {
        return Qs(t, ot(e, 3), si);
      }
      function My(t, e) {
        return t == null ? t : ii(t, ot(e, 3), se);
      }
      function qy(t, e) {
        return t == null ? t : ka(t, ot(e, 3), se);
      }
      function Fy(t, e) {
        return t && je(t, ot(e, 3));
      }
      function Wy(t, e) {
        return t && si(t, ot(e, 3));
      }
      function zy(t) {
        return t == null ? [] : Vr(t, Vt(t));
      }
      function Vy(t) {
        return t == null ? [] : Vr(t, se(t));
      }
      function Pi(t, e, i) {
        var a = t == null ? n : mn(t, e);
        return a === n ? i : a;
      }
      function Jy(t, e) {
        return t != null && oc(t, e, dl);
      }
      function Mi(t, e) {
        return t != null && oc(t, e, yl);
      }
      var Xy = Ya(function(t, e, i) {
        e != null && typeof e.toString != "function" && (e = Br.call(e)), t[e] = i;
      }, Fi(ae)), Ky = Ya(function(t, e, i) {
        e != null && typeof e.toString != "function" && (e = Br.call(e)), Tt.call(t, e) ? t[e].push(i) : t[e] = [i];
      }, ot), Hy = vt(sr);
      function Vt(t) {
        return ie(t) ? da(t) : fi(t);
      }
      function se(t) {
        return ie(t) ? da(t, !0) : Cl(t);
      }
      function $y(t, e) {
        var i = {};
        return e = ot(e, 3), je(t, function(a, h, b) {
          ze(i, e(a, h, b), a);
        }), i;
      }
      function Yy(t, e) {
        var i = {};
        return e = ot(e, 3), je(t, function(a, h, b) {
          ze(i, h, e(a, h, b));
        }), i;
      }
      var Qy = Un(function(t, e, i) {
        Jr(t, e, i);
      }), Mc = Un(function(t, e, i, a) {
        Jr(t, e, i, a);
      }), Gy = Je(function(t, e) {
        var i = {};
        if (t == null)
          return i;
        var a = !1;
        e = Lt(e, function(b) {
          return b = sn(b, t), a || (a = b.length > 1), b;
        }), De(t, Ei(t), i), a && (i = we(i, d | l | u, Xl));
        for (var h = e.length; h--; )
          vi(i, e[h]);
        return i;
      });
      function Zy(t, e) {
        return qc(t, so(ot(e)));
      }
      var tv = Je(function(t, e) {
        return t == null ? {} : Tl(t, e);
      });
      function qc(t, e) {
        if (t == null)
          return {};
        var i = Lt(Ei(t), function(a) {
          return [a];
        });
        return e = ot(e), Ba(t, i, function(a, h) {
          return e(a, h[0]);
        });
      }
      function ev(t, e, i) {
        e = sn(e, t);
        var a = -1, h = e.length;
        for (h || (h = 1, t = n); ++a < h; ) {
          var b = t == null ? n : t[Pe(e[a])];
          b === n && (a = h, b = i), t = Ke(b) ? b.call(t) : b;
        }
        return t;
      }
      function nv(t, e, i) {
        return t == null ? t : cr(t, e, i);
      }
      function rv(t, e, i, a) {
        return a = typeof a == "function" ? a : n, t == null ? t : cr(t, e, i, a);
      }
      var Fc = Za(Vt), Wc = Za(se);
      function ov(t, e, i) {
        var a = ht(t), h = a || cn(t) || Pn(t);
        if (e = ot(e, 4), i == null) {
          var b = t && t.constructor;
          h ? i = a ? new b() : [] : Ut(t) ? i = Ke(b) ? Ln(Lr(t)) : {} : i = {};
        }
        return (h ? be : je)(t, function(w, E, T) {
          return e(i, w, E, T);
        }), i;
      }
      function iv(t, e) {
        return t == null ? !0 : vi(t, e);
      }
      function sv(t, e, i) {
        return t == null ? t : ja(t, e, bi(i));
      }
      function av(t, e, i, a) {
        return a = typeof a == "function" ? a : n, t == null ? t : ja(t, e, bi(i), a);
      }
      function Mn(t) {
        return t == null ? [] : Qo(t, Vt(t));
      }
      function cv(t) {
        return t == null ? [] : Qo(t, se(t));
      }
      function uv(t, e, i) {
        return i === n && (i = e, e = n), i !== n && (i = Ce(i), i = i === i ? i : 0), e !== n && (e = Ce(e), e = e === e ? e : 0), gn(Ce(t), e, i);
      }
      function fv(t, e, i) {
        return e = He(e), i === n ? (i = e, e = 0) : i = He(i), t = Ce(t), vl(t, e, i);
      }
      function hv(t, e, i) {
        if (i && typeof i != "boolean" && ne(t, e, i) && (e = i = n), i === n && (typeof e == "boolean" ? (i = e, e = n) : typeof t == "boolean" && (i = t, t = n)), t === n && e === n ? (t = 0, e = 1) : (t = He(t), e === n ? (e = t, t = 0) : e = He(e)), t > e) {
          var a = t;
          t = e, e = a;
        }
        if (i || t % 1 || e % 1) {
          var h = la();
          return Yt(t + h * (e - t + zf("1e-" + ((h + "").length - 1))), e);
        }
        return pi(t, e);
      }
      var lv = jn(function(t, e, i) {
        return e = e.toLowerCase(), t + (i ? zc(e) : e);
      });
      function zc(t) {
        return qi(Ct(t).toLowerCase());
      }
      function Vc(t) {
        return t = Ct(t), t && t.replace(df, nh).replace(If, "");
      }
      function pv(t, e, i) {
        t = Ct(t), e = de(e);
        var a = t.length;
        i = i === n ? a : gn(dt(i), 0, a);
        var h = i;
        return i -= e.length, i >= 0 && t.slice(i, h) == e;
      }
      function dv(t) {
        return t = Ct(t), t && Ku.test(t) ? t.replace(ks, rh) : t;
      }
      function yv(t) {
        return t = Ct(t), t && Zu.test(t) ? t.replace(Uo, "\\$&") : t;
      }
      var vv = jn(function(t, e, i) {
        return t + (i ? "-" : "") + e.toLowerCase();
      }), gv = jn(function(t, e, i) {
        return t + (i ? " " : "") + e.toLowerCase();
      }), mv = Ka("toLowerCase");
      function bv(t, e, i) {
        t = Ct(t), e = dt(e);
        var a = e ? On(t) : 0;
        if (!e || a >= e)
          return t;
        var h = (e - a) / 2;
        return Qr(Pr(h), i) + t + Qr(Dr(h), i);
      }
      function _v(t, e, i) {
        t = Ct(t), e = dt(e);
        var a = e ? On(t) : 0;
        return e && a < e ? t + Qr(e - a, i) : t;
      }
      function kv(t, e, i) {
        t = Ct(t), e = dt(e);
        var a = e ? On(t) : 0;
        return e && a < e ? Qr(e - a, i) + t : t;
      }
      function wv(t, e, i) {
        return i || e == null ? e = 0 : e && (e = +e), Oh(Ct(t).replace(jo, ""), e || 0);
      }
      function Sv(t, e, i) {
        return (i ? ne(t, e, i) : e === n) ? e = 1 : e = dt(e), di(Ct(t), e);
      }
      function Ev() {
        var t = arguments, e = Ct(t[0]);
        return t.length < 3 ? e : e.replace(t[1], t[2]);
      }
      var Cv = jn(function(t, e, i) {
        return t + (i ? "_" : "") + e.toLowerCase();
      });
      function Av(t, e, i) {
        return i && typeof i != "number" && ne(t, e, i) && (e = i = n), i = i === n ? fe : i >>> 0, i ? (t = Ct(t), t && (typeof e == "string" || e != null && !Di(e)) && (e = de(e), !e && xn(t)) ? an(xe(t), 0, i) : t.split(e, i)) : [];
      }
      var Tv = jn(function(t, e, i) {
        return t + (i ? " " : "") + qi(e);
      });
      function xv(t, e, i) {
        return t = Ct(t), i = i == null ? 0 : gn(dt(i), 0, t.length), e = de(e), t.slice(i, i + e.length) == e;
      }
      function Ov(t, e, i) {
        var a = v.templateSettings;
        i && ne(t, e, i) && (e = n), t = Ct(t), e = uo({}, e, a, tc);
        var h = uo({}, e.imports, a.imports, tc), b = Vt(h), w = Qo(h, b), E, T, M = 0, q = e.interpolate || wr, F = "__p += '", $ = Zo(
          (e.escape || wr).source + "|" + q.source + "|" + (q === ws ? cf : wr).source + "|" + (e.evaluate || wr).source + "|$",
          "g"
        ), tt = "//# sourceURL=" + (Tt.call(e, "sourceURL") ? (e.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Pf + "]") + `
`;
        t.replace($, function(st, gt, bt, ve, re, ge) {
          return bt || (bt = ve), F += t.slice(M, ge).replace(yf, oh), gt && (E = !0, F += `' +
__e(` + gt + `) +
'`), re && (T = !0, F += `';
` + re + `;
__p += '`), bt && (F += `' +
((__t = (` + bt + `)) == null ? '' : __t) +
'`), M = ge + st.length, st;
        }), F += `';
`;
        var it = Tt.call(e, "variable") && e.variable;
        if (!it)
          F = `with (obj) {
` + F + `
}
`;
        else if (sf.test(it))
          throw new ft(y);
        F = (T ? F.replace(zu, "") : F).replace(Vu, "$1").replace(Ju, "$1;"), F = "function(" + (it || "obj") + `) {
` + (it ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (E ? ", __e = _.escape" : "") + (T ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + F + `return __p
}`;
        var yt = Xc(function() {
          return St(b, tt + "return " + F).apply(n, w);
        });
        if (yt.source = F, ji(yt))
          throw yt;
        return yt;
      }
      function Nv(t) {
        return Ct(t).toLowerCase();
      }
      function Bv(t) {
        return Ct(t).toUpperCase();
      }
      function Rv(t, e, i) {
        if (t = Ct(t), t && (i || e === n))
          return ea(t);
        if (!t || !(e = de(e)))
          return t;
        var a = xe(t), h = xe(e), b = na(a, h), w = ra(a, h) + 1;
        return an(a, b, w).join("");
      }
      function Iv(t, e, i) {
        if (t = Ct(t), t && (i || e === n))
          return t.slice(0, ia(t) + 1);
        if (!t || !(e = de(e)))
          return t;
        var a = xe(t), h = ra(a, xe(e)) + 1;
        return an(a, 0, h).join("");
      }
      function Lv(t, e, i) {
        if (t = Ct(t), t && (i || e === n))
          return t.replace(jo, "");
        if (!t || !(e = de(e)))
          return t;
        var a = xe(t), h = na(a, xe(e));
        return an(a, h).join("");
      }
      function Uv(t, e) {
        var i = I, a = W;
        if (Ut(e)) {
          var h = "separator" in e ? e.separator : h;
          i = "length" in e ? dt(e.length) : i, a = "omission" in e ? de(e.omission) : a;
        }
        t = Ct(t);
        var b = t.length;
        if (xn(t)) {
          var w = xe(t);
          b = w.length;
        }
        if (i >= b)
          return t;
        var E = i - On(a);
        if (E < 1)
          return a;
        var T = w ? an(w, 0, E).join("") : t.slice(0, E);
        if (h === n)
          return T + a;
        if (w && (E += T.length - E), Di(h)) {
          if (t.slice(E).search(h)) {
            var M, q = T;
            for (h.global || (h = Zo(h.source, Ct(Ss.exec(h)) + "g")), h.lastIndex = 0; M = h.exec(q); )
              var F = M.index;
            T = T.slice(0, F === n ? E : F);
          }
        } else if (t.indexOf(de(h), E) != E) {
          var $ = T.lastIndexOf(h);
          $ > -1 && (T = T.slice(0, $));
        }
        return T + a;
      }
      function jv(t) {
        return t = Ct(t), t && Xu.test(t) ? t.replace(_s, hh) : t;
      }
      var Dv = jn(function(t, e, i) {
        return t + (i ? " " : "") + e.toUpperCase();
      }), qi = Ka("toUpperCase");
      function Jc(t, e, i) {
        return t = Ct(t), e = i ? n : e, e === n ? sh(t) ? dh(t) : Qf(t) : t.match(e) || [];
      }
      var Xc = vt(function(t, e) {
        try {
          return le(t, n, e);
        } catch (i) {
          return ji(i) ? i : new ft(i);
        }
      }), Pv = Je(function(t, e) {
        return be(e, function(i) {
          i = Pe(i), ze(t, i, Li(t[i], t));
        }), t;
      });
      function Mv(t) {
        var e = t == null ? 0 : t.length, i = ot();
        return t = e ? Lt(t, function(a) {
          if (typeof a[1] != "function")
            throw new _e(g);
          return [i(a[0]), a[1]];
        }) : [], vt(function(a) {
          for (var h = -1; ++h < e; ) {
            var b = t[h];
            if (le(b[0], this, a))
              return le(b[1], this, a);
          }
        });
      }
      function qv(t) {
        return hl(we(t, d));
      }
      function Fi(t) {
        return function() {
          return t;
        };
      }
      function Fv(t, e) {
        return t == null || t !== t ? e : t;
      }
      var Wv = $a(), zv = $a(!0);
      function ae(t) {
        return t;
      }
      function Wi(t) {
        return Ca(typeof t == "function" ? t : we(t, d));
      }
      function Vv(t) {
        return Ta(we(t, d));
      }
      function Jv(t, e) {
        return xa(t, we(e, d));
      }
      var Xv = vt(function(t, e) {
        return function(i) {
          return sr(i, t, e);
        };
      }), Kv = vt(function(t, e) {
        return function(i) {
          return sr(t, i, e);
        };
      });
      function zi(t, e, i) {
        var a = Vt(e), h = Vr(e, a);
        i == null && !(Ut(e) && (h.length || !a.length)) && (i = e, e = t, t = this, h = Vr(e, Vt(e)));
        var b = !(Ut(i) && "chain" in i) || !!i.chain, w = Ke(t);
        return be(h, function(E) {
          var T = e[E];
          t[E] = T, w && (t.prototype[E] = function() {
            var M = this.__chain__;
            if (b || M) {
              var q = t(this.__wrapped__), F = q.__actions__ = oe(this.__actions__);
              return F.push({ func: T, args: arguments, thisArg: t }), q.__chain__ = M, q;
            }
            return T.apply(t, tn([this.value()], arguments));
          });
        }), t;
      }
      function Hv() {
        return Jt._ === this && (Jt._ = _h), this;
      }
      function Vi() {
      }
      function $v(t) {
        return t = dt(t), vt(function(e) {
          return Oa(e, t);
        });
      }
      var Yv = ki(Lt), Qv = ki(Ys), Gv = ki(Xo);
      function Kc(t) {
        return xi(t) ? Ko(Pe(t)) : xl(t);
      }
      function Zv(t) {
        return function(e) {
          return t == null ? n : mn(t, e);
        };
      }
      var tg = Qa(), eg = Qa(!0);
      function Ji() {
        return [];
      }
      function Xi() {
        return !1;
      }
      function ng() {
        return {};
      }
      function rg() {
        return "";
      }
      function og() {
        return !0;
      }
      function ig(t, e) {
        if (t = dt(t), t < 1 || t > ut)
          return [];
        var i = fe, a = Yt(t, fe);
        e = ot(e), t -= fe;
        for (var h = Yo(a, e); ++i < t; )
          e(i);
        return h;
      }
      function sg(t) {
        return ht(t) ? Lt(t, Pe) : ye(t) ? [t] : oe(pc(Ct(t)));
      }
      function ag(t) {
        var e = ++mh;
        return Ct(t) + e;
      }
      var cg = Yr(function(t, e) {
        return t + e;
      }, 0), ug = wi("ceil"), fg = Yr(function(t, e) {
        return t / e;
      }, 1), hg = wi("floor");
      function lg(t) {
        return t && t.length ? zr(t, ae, ai) : n;
      }
      function pg(t, e) {
        return t && t.length ? zr(t, ot(e, 2), ai) : n;
      }
      function dg(t) {
        return Zs(t, ae);
      }
      function yg(t, e) {
        return Zs(t, ot(e, 2));
      }
      function vg(t) {
        return t && t.length ? zr(t, ae, hi) : n;
      }
      function gg(t, e) {
        return t && t.length ? zr(t, ot(e, 2), hi) : n;
      }
      var mg = Yr(function(t, e) {
        return t * e;
      }, 1), bg = wi("round"), _g = Yr(function(t, e) {
        return t - e;
      }, 0);
      function kg(t) {
        return t && t.length ? $o(t, ae) : 0;
      }
      function wg(t, e) {
        return t && t.length ? $o(t, ot(e, 2)) : 0;
      }
      return v.after = Vd, v.ary = Ec, v.assign = By, v.assignIn = Pc, v.assignInWith = uo, v.assignWith = Ry, v.at = Iy, v.before = Cc, v.bind = Li, v.bindAll = Pv, v.bindKey = Ac, v.castArray = ny, v.chain = kc, v.chunk = hp, v.compact = lp, v.concat = pp, v.cond = Mv, v.conforms = qv, v.constant = Fi, v.countBy = kd, v.create = Ly, v.curry = Tc, v.curryRight = xc, v.debounce = Oc, v.defaults = Uy, v.defaultsDeep = jy, v.defer = Jd, v.delay = Xd, v.difference = dp, v.differenceBy = yp, v.differenceWith = vp, v.drop = gp, v.dropRight = mp, v.dropRightWhile = bp, v.dropWhile = _p, v.fill = kp, v.filter = Sd, v.flatMap = Ad, v.flatMapDeep = Td, v.flatMapDepth = xd, v.flatten = gc, v.flattenDeep = wp, v.flattenDepth = Sp, v.flip = Kd, v.flow = Wv, v.flowRight = zv, v.fromPairs = Ep, v.functions = zy, v.functionsIn = Vy, v.groupBy = Od, v.initial = Ap, v.intersection = Tp, v.intersectionBy = xp, v.intersectionWith = Op, v.invert = Xy, v.invertBy = Ky, v.invokeMap = Bd, v.iteratee = Wi, v.keyBy = Rd, v.keys = Vt, v.keysIn = se, v.map = ro, v.mapKeys = $y, v.mapValues = Yy, v.matches = Vv, v.matchesProperty = Jv, v.memoize = io, v.merge = Qy, v.mergeWith = Mc, v.method = Xv, v.methodOf = Kv, v.mixin = zi, v.negate = so, v.nthArg = $v, v.omit = Gy, v.omitBy = Zy, v.once = Hd, v.orderBy = Id, v.over = Yv, v.overArgs = $d, v.overEvery = Qv, v.overSome = Gv, v.partial = Ui, v.partialRight = Nc, v.partition = Ld, v.pick = tv, v.pickBy = qc, v.property = Kc, v.propertyOf = Zv, v.pull = Ip, v.pullAll = bc, v.pullAllBy = Lp, v.pullAllWith = Up, v.pullAt = jp, v.range = tg, v.rangeRight = eg, v.rearg = Yd, v.reject = Dd, v.remove = Dp, v.rest = Qd, v.reverse = Ri, v.sampleSize = Md, v.set = nv, v.setWith = rv, v.shuffle = qd, v.slice = Pp, v.sortBy = zd, v.sortedUniq = Jp, v.sortedUniqBy = Xp, v.split = Av, v.spread = Gd, v.tail = Kp, v.take = Hp, v.takeRight = $p, v.takeRightWhile = Yp, v.takeWhile = Qp, v.tap = ld, v.throttle = Zd, v.thru = no, v.toArray = Uc, v.toPairs = Fc, v.toPairsIn = Wc, v.toPath = sg, v.toPlainObject = Dc, v.transform = ov, v.unary = ty, v.union = Gp, v.unionBy = Zp, v.unionWith = td, v.uniq = ed, v.uniqBy = nd, v.uniqWith = rd, v.unset = iv, v.unzip = Ii, v.unzipWith = _c, v.update = sv, v.updateWith = av, v.values = Mn, v.valuesIn = cv, v.without = od, v.words = Jc, v.wrap = ey, v.xor = id, v.xorBy = sd, v.xorWith = ad, v.zip = cd, v.zipObject = ud, v.zipObjectDeep = fd, v.zipWith = hd, v.entries = Fc, v.entriesIn = Wc, v.extend = Pc, v.extendWith = uo, zi(v, v), v.add = cg, v.attempt = Xc, v.camelCase = lv, v.capitalize = zc, v.ceil = ug, v.clamp = uv, v.clone = ry, v.cloneDeep = iy, v.cloneDeepWith = sy, v.cloneWith = oy, v.conformsTo = ay, v.deburr = Vc, v.defaultTo = Fv, v.divide = fg, v.endsWith = pv, v.eq = Ne, v.escape = dv, v.escapeRegExp = yv, v.every = wd, v.find = Ed, v.findIndex = yc, v.findKey = Dy, v.findLast = Cd, v.findLastIndex = vc, v.findLastKey = Py, v.floor = hg, v.forEach = wc, v.forEachRight = Sc, v.forIn = My, v.forInRight = qy, v.forOwn = Fy, v.forOwnRight = Wy, v.get = Pi, v.gt = cy, v.gte = uy, v.has = Jy, v.hasIn = Mi, v.head = mc, v.identity = ae, v.includes = Nd, v.indexOf = Cp, v.inRange = fv, v.invoke = Hy, v.isArguments = kn, v.isArray = ht, v.isArrayBuffer = fy, v.isArrayLike = ie, v.isArrayLikeObject = Dt, v.isBoolean = hy, v.isBuffer = cn, v.isDate = ly, v.isElement = py, v.isEmpty = dy, v.isEqual = yy, v.isEqualWith = vy, v.isError = ji, v.isFinite = gy, v.isFunction = Ke, v.isInteger = Bc, v.isLength = ao, v.isMap = Rc, v.isMatch = my, v.isMatchWith = by, v.isNaN = _y, v.isNative = ky, v.isNil = Sy, v.isNull = wy, v.isNumber = Ic, v.isObject = Ut, v.isObjectLike = jt, v.isPlainObject = lr, v.isRegExp = Di, v.isSafeInteger = Ey, v.isSet = Lc, v.isString = co, v.isSymbol = ye, v.isTypedArray = Pn, v.isUndefined = Cy, v.isWeakMap = Ay, v.isWeakSet = Ty, v.join = Np, v.kebabCase = vv, v.last = Ee, v.lastIndexOf = Bp, v.lowerCase = gv, v.lowerFirst = mv, v.lt = xy, v.lte = Oy, v.max = lg, v.maxBy = pg, v.mean = dg, v.meanBy = yg, v.min = vg, v.minBy = gg, v.stubArray = Ji, v.stubFalse = Xi, v.stubObject = ng, v.stubString = rg, v.stubTrue = og, v.multiply = mg, v.nth = Rp, v.noConflict = Hv, v.noop = Vi, v.now = oo, v.pad = bv, v.padEnd = _v, v.padStart = kv, v.parseInt = wv, v.random = hv, v.reduce = Ud, v.reduceRight = jd, v.repeat = Sv, v.replace = Ev, v.result = ev, v.round = bg, v.runInContext = A, v.sample = Pd, v.size = Fd, v.snakeCase = Cv, v.some = Wd, v.sortedIndex = Mp, v.sortedIndexBy = qp, v.sortedIndexOf = Fp, v.sortedLastIndex = Wp, v.sortedLastIndexBy = zp, v.sortedLastIndexOf = Vp, v.startCase = Tv, v.startsWith = xv, v.subtract = _g, v.sum = kg, v.sumBy = wg, v.template = Ov, v.times = ig, v.toFinite = He, v.toInteger = dt, v.toLength = jc, v.toLower = Nv, v.toNumber = Ce, v.toSafeInteger = Ny, v.toString = Ct, v.toUpper = Bv, v.trim = Rv, v.trimEnd = Iv, v.trimStart = Lv, v.truncate = Uv, v.unescape = jv, v.uniqueId = ag, v.upperCase = Dv, v.upperFirst = qi, v.each = wc, v.eachRight = Sc, v.first = mc, zi(v, function() {
        var t = {};
        return je(v, function(e, i) {
          Tt.call(v.prototype, i) || (t[i] = e);
        }), t;
      }(), { chain: !1 }), v.VERSION = s, be(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(t) {
        v[t].placeholder = v;
      }), be(["drop", "take"], function(t, e) {
        mt.prototype[t] = function(i) {
          i = i === n ? 1 : Wt(dt(i), 0);
          var a = this.__filtered__ && !e ? new mt(this) : this.clone();
          return a.__filtered__ ? a.__takeCount__ = Yt(i, a.__takeCount__) : a.__views__.push({
            size: Yt(i, fe),
            type: t + (a.__dir__ < 0 ? "Right" : "")
          }), a;
        }, mt.prototype[t + "Right"] = function(i) {
          return this.reverse()[t](i).reverse();
        };
      }), be(["filter", "map", "takeWhile"], function(t, e) {
        var i = e + 1, a = i == P || i == ct;
        mt.prototype[t] = function(h) {
          var b = this.clone();
          return b.__iteratees__.push({
            iteratee: ot(h, 3),
            type: i
          }), b.__filtered__ = b.__filtered__ || a, b;
        };
      }), be(["head", "last"], function(t, e) {
        var i = "take" + (e ? "Right" : "");
        mt.prototype[t] = function() {
          return this[i](1).value()[0];
        };
      }), be(["initial", "tail"], function(t, e) {
        var i = "drop" + (e ? "" : "Right");
        mt.prototype[t] = function() {
          return this.__filtered__ ? new mt(this) : this[i](1);
        };
      }), mt.prototype.compact = function() {
        return this.filter(ae);
      }, mt.prototype.find = function(t) {
        return this.filter(t).head();
      }, mt.prototype.findLast = function(t) {
        return this.reverse().find(t);
      }, mt.prototype.invokeMap = vt(function(t, e) {
        return typeof t == "function" ? new mt(this) : this.map(function(i) {
          return sr(i, t, e);
        });
      }), mt.prototype.reject = function(t) {
        return this.filter(so(ot(t)));
      }, mt.prototype.slice = function(t, e) {
        t = dt(t);
        var i = this;
        return i.__filtered__ && (t > 0 || e < 0) ? new mt(i) : (t < 0 ? i = i.takeRight(-t) : t && (i = i.drop(t)), e !== n && (e = dt(e), i = e < 0 ? i.dropRight(-e) : i.take(e - t)), i);
      }, mt.prototype.takeRightWhile = function(t) {
        return this.reverse().takeWhile(t).reverse();
      }, mt.prototype.toArray = function() {
        return this.take(fe);
      }, je(mt.prototype, function(t, e) {
        var i = /^(?:filter|find|map|reject)|While$/.test(e), a = /^(?:head|last)$/.test(e), h = v[a ? "take" + (e == "last" ? "Right" : "") : e], b = a || /^find/.test(e);
        h && (v.prototype[e] = function() {
          var w = this.__wrapped__, E = a ? [1] : arguments, T = w instanceof mt, M = E[0], q = T || ht(w), F = function(gt) {
            var bt = h.apply(v, tn([gt], E));
            return a && $ ? bt[0] : bt;
          };
          q && i && typeof M == "function" && M.length != 1 && (T = q = !1);
          var $ = this.__chain__, tt = !!this.__actions__.length, it = b && !$, yt = T && !tt;
          if (!b && q) {
            w = yt ? w : new mt(this);
            var st = t.apply(w, E);
            return st.__actions__.push({ func: no, args: [F], thisArg: n }), new ke(st, $);
          }
          return it && yt ? t.apply(this, E) : (st = this.thru(F), it ? a ? st.value()[0] : st.value() : st);
        });
      }), be(["pop", "push", "shift", "sort", "splice", "unshift"], function(t) {
        var e = xr[t], i = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru", a = /^(?:pop|shift)$/.test(t);
        v.prototype[t] = function() {
          var h = arguments;
          if (a && !this.__chain__) {
            var b = this.value();
            return e.apply(ht(b) ? b : [], h);
          }
          return this[i](function(w) {
            return e.apply(ht(w) ? w : [], h);
          });
        };
      }), je(mt.prototype, function(t, e) {
        var i = v[e];
        if (i) {
          var a = i.name + "";
          Tt.call(In, a) || (In[a] = []), In[a].push({ name: e, func: i });
        }
      }), In[$r(n, L).name] = [{
        name: "wrapper",
        func: n
      }], mt.prototype.clone = jh, mt.prototype.reverse = Dh, mt.prototype.value = Ph, v.prototype.at = pd, v.prototype.chain = dd, v.prototype.commit = yd, v.prototype.next = vd, v.prototype.plant = md, v.prototype.reverse = bd, v.prototype.toJSON = v.prototype.valueOf = v.prototype.value = _d, v.prototype.first = v.prototype.head, Zn && (v.prototype[Zn] = gd), v;
    }, Nn = yh();
    pn ? ((pn.exports = Nn)._ = Nn, Wo._ = Nn) : Jt._ = Nn;
  }).call(pr);
})(go, go.exports);
var Dg = go.exports;
const Pg = {
  isNewStack: !1,
  forceNew: !0,
  reconnectionDelay: 1e4,
  reconnectionDelayMax: 1e4,
  maxReconnectAttempts: 5,
  timeout: 1e4,
  keepAliveTimeout: 6e4,
  idleInterval: 6e4 * 5,
  protocol: "https",
  transports: ["websocket"],
  upgrade: !1,
  serverFetchStrategy: "static",
  serverType: 0,
  useLogger: !0,
  loggerServer: "http://socketlog.voicenter.co",
  loggerConfig: {
    logToConsole: !0,
    overloadGlobalConsole: !1,
    system: "events-sdk",
    socketEmitInterval: 1e4
  },
  loggerConnectOptions: {
    reconnection: !0,
    reconnectionDelay: 5e3,
    reconnectionAttempts: 10,
    perMessageDeflate: void 0,
    upgrade: !1,
    transports: ["websocket"],
    debug: !1
  }
};
function Mg() {
  return function r(o, n, s) {
    function c(y, _) {
      if (!n[y]) {
        if (!o[y]) {
          var p = typeof require == "function" && require;
          if (!_ && p)
            return p(y, !0);
          if (f)
            return f(y, !0);
          throw new Error("Cannot find module '" + y + "'");
        }
        var m = n[y] = { exports: {} };
        o[y][0].call(m.exports, function(d) {
          var l = o[y][1][d];
          return c(l || d);
        }, m, m.exports, r, o, n, s);
      }
      return n[y].exports;
    }
    for (var f = typeof require == "function" && require, g = 0; g < s.length; g++)
      c(s[g]);
    return c;
  }({
    1: [function(r, o) {
      o.exports = r("./lib/");
    }, { "./lib/": 2 }],
    2: [function(r, o, n) {
      function s(p, m) {
        typeof p == "object" && (m = p, p = void 0), m = m || {};
        var d, l = c(p), u = l.source, k = l.id;
        return m.forceNew || m["force new connection"] || m.multiplex === !1 ? (y("ignoring socket cache for %s", u), d = g(u, m)) : (_[k] || (y("new io instance for %s", u), _[k] = g(u, m)), d = _[k]), d.socket(l.path);
      }
      var c = r("./url"), f = r("socket.io-parser"), g = r("./manager"), y = r("debug")("socket.io-client");
      o.exports = n = s;
      var _ = n.managers = {};
      n.protocol = f.protocol, n.connect = s, n.Manager = r("./manager"), n.Socket = r("./socket");
    }, { "./manager": 3, "./socket": 5, "./url": 6, debug: 10, "socket.io-parser": 44 }],
    3: [function(r, o) {
      function n(l, u) {
        return this instanceof n ? (l && typeof l == "object" && (u = l, l = void 0), u = u || {}, u.path = u.path || "/socket.io", this.nsps = {}, this.subs = [], this.opts = u, this.reconnection(u.reconnection !== !1), this.reconnectionAttempts(u.reconnectionAttempts || 1 / 0), this.reconnectionDelay(u.reconnectionDelay || 1e3), this.reconnectionDelayMax(u.reconnectionDelayMax || 5e3), this.randomizationFactor(u.randomizationFactor || 0.5), this.backoff = new d({
          min: this.reconnectionDelay(),
          max: this.reconnectionDelayMax(),
          jitter: this.randomizationFactor()
        }), this.timeout(u.timeout == null ? 2e4 : u.timeout), this.readyState = "closed", this.uri = l, this.connected = [], this.encoding = !1, this.packetBuffer = [], this.encoder = new g.Encoder(), this.decoder = new g.Decoder(), this.autoConnect = u.autoConnect !== !1, void (this.autoConnect && this.open())) : new n(l, u);
      }
      var s = (r("./url"), r("engine.io-client")), c = r("./socket"), f = r("component-emitter"), g = r("socket.io-parser"), y = r("./on"), _ = r("component-bind"), p = (r("object-component"), r("debug")("socket.io-client:manager")), m = r("indexof"), d = r("backo2");
      o.exports = n, n.prototype.emitAll = function() {
        this.emit.apply(this, arguments);
        for (var l in this.nsps)
          this.nsps[l].emit.apply(this.nsps[l], arguments);
      }, n.prototype.updateSocketIds = function() {
        for (var l in this.nsps)
          this.nsps[l].id = this.engine.id;
      }, f(n.prototype), n.prototype.reconnection = function(l) {
        return arguments.length ? (this._reconnection = !!l, this) : this._reconnection;
      }, n.prototype.reconnectionAttempts = function(l) {
        return arguments.length ? (this._reconnectionAttempts = l, this) : this._reconnectionAttempts;
      }, n.prototype.reconnectionDelay = function(l) {
        return arguments.length ? (this._reconnectionDelay = l, this.backoff && this.backoff.setMin(l), this) : this._reconnectionDelay;
      }, n.prototype.randomizationFactor = function(l) {
        return arguments.length ? (this._randomizationFactor = l, this.backoff && this.backoff.setJitter(l), this) : this._randomizationFactor;
      }, n.prototype.reconnectionDelayMax = function(l) {
        return arguments.length ? (this._reconnectionDelayMax = l, this.backoff && this.backoff.setMax(l), this) : this._reconnectionDelayMax;
      }, n.prototype.timeout = function(l) {
        return arguments.length ? (this._timeout = l, this) : this._timeout;
      }, n.prototype.maybeReconnectOnOpen = function() {
        !this.reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
      }, n.prototype.open = n.prototype.connect = function(l) {
        if (p("readyState %s", this.readyState), ~this.readyState.indexOf("open"))
          return this;
        p("opening %s", this.uri), this.engine = s(this.uri, this.opts);
        var u = this.engine, k = this;
        this.readyState = "opening", this.skipReconnect = !1;
        var C = y(u, "open", function() {
          k.onopen(), l && l();
        }), S = y(u, "error", function(H) {
          if (p("connect_error"), k.cleanup(), k.readyState = "closed", k.emitAll("connect_error", H), l) {
            var R = new Error("Connection error");
            R.data = H, l(R);
          } else
            k.maybeReconnectOnOpen();
        });
        if (this._timeout !== !1) {
          var L = this._timeout;
          p("connect attempt will timeout after %d", L);
          var Y = setTimeout(function() {
            p("connect attempt timed out after %d", L), C.destroy(), u.close(), u.emit("error", "timeout"), k.emitAll("connect_timeout", L);
          }, L);
          this.subs.push({
            destroy: function() {
              clearTimeout(Y);
            }
          });
        }
        return this.subs.push(C), this.subs.push(S), this;
      }, n.prototype.onopen = function() {
        p("open"), this.cleanup(), this.readyState = "open", this.emit("open");
        var l = this.engine;
        this.subs.push(y(l, "data", _(this, "ondata"))), this.subs.push(y(this.decoder, "decoded", _(this, "ondecoded"))), this.subs.push(y(l, "error", _(this, "onerror"))), this.subs.push(y(l, "close", _(this, "onclose")));
      }, n.prototype.ondata = function(l) {
        this.decoder.add(l);
      }, n.prototype.ondecoded = function(l) {
        this.emit("packet", l);
      }, n.prototype.onerror = function(l) {
        p("error", l), this.emitAll("error", l);
      }, n.prototype.socket = function(l) {
        var u = this.nsps[l];
        if (!u) {
          u = new c(this, l), this.nsps[l] = u;
          var k = this;
          u.on("connect", function() {
            u.id = k.engine.id, ~m(k.connected, u) || k.connected.push(u);
          });
        }
        return u;
      }, n.prototype.destroy = function(l) {
        var u = m(this.connected, l);
        ~u && this.connected.splice(u, 1), this.connected.length || this.close();
      }, n.prototype.packet = function(l) {
        p("writing packet %j", l);
        var u = this;
        u.encoding ? u.packetBuffer.push(l) : (u.encoding = !0, this.encoder.encode(l, function(k) {
          for (var C = 0; C < k.length; C++)
            u.engine.write(k[C]);
          u.encoding = !1, u.processPacketQueue();
        }));
      }, n.prototype.processPacketQueue = function() {
        if (this.packetBuffer.length > 0 && !this.encoding) {
          var l = this.packetBuffer.shift();
          this.packet(l);
        }
      }, n.prototype.cleanup = function() {
        for (var l; l = this.subs.shift(); )
          l.destroy();
        this.packetBuffer = [], this.encoding = !1, this.decoder.destroy();
      }, n.prototype.close = n.prototype.disconnect = function() {
        this.skipReconnect = !0, this.backoff.reset(), this.readyState = "closed", this.engine && this.engine.close();
      }, n.prototype.onclose = function(l) {
        p("close"), this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.emit("close", l), this._reconnection && !this.skipReconnect && this.reconnect();
      }, n.prototype.reconnect = function() {
        if (this.reconnecting || this.skipReconnect)
          return this;
        var l = this;
        if (this.backoff.attempts >= this._reconnectionAttempts)
          p("reconnect failed"), this.backoff.reset(), this.emitAll("reconnect_failed"), this.reconnecting = !1;
        else {
          var u = this.backoff.duration();
          p("will wait %dms before reconnect attempt", u), this.reconnecting = !0;
          var k = setTimeout(function() {
            l.skipReconnect || (p("attempting reconnect"), l.emitAll("reconnect_attempt", l.backoff.attempts), l.emitAll("reconnecting", l.backoff.attempts), l.skipReconnect || l.open(function(C) {
              C ? (p("reconnect attempt error"), l.reconnecting = !1, l.reconnect(), l.emitAll("reconnect_error", C.data)) : (p("reconnect success"), l.onreconnect());
            }));
          }, u);
          this.subs.push({
            destroy: function() {
              clearTimeout(k);
            }
          });
        }
      }, n.prototype.onreconnect = function() {
        var l = this.backoff.attempts;
        this.reconnecting = !1, this.backoff.reset(), this.updateSocketIds(), this.emitAll("reconnect", l);
      };
    }, {
      "./on": 4,
      "./socket": 5,
      "./url": 6,
      backo2: 7,
      "component-bind": 8,
      "component-emitter": 9,
      debug: 10,
      "engine.io-client": 11,
      indexof: 40,
      "object-component": 41,
      "socket.io-parser": 44
    }],
    4: [function(r, o) {
      function n(s, c, f) {
        return s.on(c, f), {
          destroy: function() {
            s.removeListener(c, f);
          }
        };
      }
      o.exports = n;
    }, {}],
    5: [function(r, o, n) {
      function s(u, k) {
        this.io = u, this.nsp = k, this.json = this, this.ids = 0, this.acks = {}, this.io.autoConnect && this.open(), this.receiveBuffer = [], this.sendBuffer = [], this.connected = !1, this.disconnected = !0;
      }
      var c = r("socket.io-parser"), f = r("component-emitter"), g = r("to-array"), y = r("./on"), _ = r("component-bind"), p = r("debug")("socket.io-client:socket"), m = r("has-binary");
      o.exports = s;
      var d = {
        connect: 1,
        connect_error: 1,
        connect_timeout: 1,
        disconnect: 1,
        error: 1,
        reconnect: 1,
        reconnect_attempt: 1,
        reconnect_failed: 1,
        reconnect_error: 1,
        reconnecting: 1
      }, l = f.prototype.emit;
      f(s.prototype), s.prototype.subEvents = function() {
        if (!this.subs) {
          var u = this.io;
          this.subs = [y(u, "open", _(this, "onopen")), y(u, "packet", _(this, "onpacket")), y(u, "close", _(this, "onclose"))];
        }
      }, s.prototype.open = s.prototype.connect = function() {
        return this.connected ? this : (this.subEvents(), this.io.open(), this.io.readyState == "open" && this.onopen(), this);
      }, s.prototype.send = function() {
        var u = g(arguments);
        return u.unshift("message"), this.emit.apply(this, u), this;
      }, s.prototype.emit = function(u) {
        if (d.hasOwnProperty(u))
          return l.apply(this, arguments), this;
        var k = g(arguments), C = c.EVENT;
        m(k) && (C = c.BINARY_EVENT);
        var S = { type: C, data: k };
        return typeof k[k.length - 1] == "function" && (p("emitting packet with ack id %d", this.ids), this.acks[this.ids] = k.pop(), S.id = this.ids++), this.connected ? this.packet(S) : this.sendBuffer.push(S), this;
      }, s.prototype.packet = function(u) {
        u.nsp = this.nsp, this.io.packet(u);
      }, s.prototype.onopen = function() {
        p("transport is open - connecting"), this.nsp != "/" && this.packet({ type: c.CONNECT });
      }, s.prototype.onclose = function(u) {
        p("close (%s)", u), this.connected = !1, this.disconnected = !0, delete this.id, this.emit("disconnect", u);
      }, s.prototype.onpacket = function(u) {
        if (u.nsp == this.nsp)
          switch (u.type) {
            case c.CONNECT:
              this.onconnect();
              break;
            case c.EVENT:
              this.onevent(u);
              break;
            case c.BINARY_EVENT:
              this.onevent(u);
              break;
            case c.ACK:
              this.onack(u);
              break;
            case c.BINARY_ACK:
              this.onack(u);
              break;
            case c.DISCONNECT:
              this.ondisconnect();
              break;
            case c.ERROR:
              this.emit("error", u.data);
          }
      }, s.prototype.onevent = function(u) {
        var k = u.data || [];
        p("emitting event %j", k), u.id != null && (p("attaching ack callback to event"), k.push(this.ack(u.id))), this.connected ? l.apply(this, k) : this.receiveBuffer.push(k);
      }, s.prototype.ack = function(u) {
        var k = this, C = !1;
        return function() {
          if (!C) {
            C = !0;
            var S = g(arguments);
            p("sending ack %j", S);
            var L = m(S) ? c.BINARY_ACK : c.ACK;
            k.packet({ type: L, id: u, data: S });
          }
        };
      }, s.prototype.onack = function(u) {
        p("calling ack %s with %j", u.id, u.data);
        var k = this.acks[u.id];
        k.apply(this, u.data), delete this.acks[u.id];
      }, s.prototype.onconnect = function() {
        this.connected = !0, this.disconnected = !1, this.emit("connect"), this.emitBuffered();
      }, s.prototype.emitBuffered = function() {
        var u;
        for (u = 0; u < this.receiveBuffer.length; u++)
          l.apply(this, this.receiveBuffer[u]);
        for (this.receiveBuffer = [], u = 0; u < this.sendBuffer.length; u++)
          this.packet(this.sendBuffer[u]);
        this.sendBuffer = [];
      }, s.prototype.ondisconnect = function() {
        p("server disconnect (%s)", this.nsp), this.destroy(), this.onclose("io server disconnect");
      }, s.prototype.destroy = function() {
        if (this.subs) {
          for (var u = 0; u < this.subs.length; u++)
            this.subs[u].destroy();
          this.subs = null;
        }
        this.io.destroy(this);
      }, s.prototype.close = s.prototype.disconnect = function() {
        return this.connected && (p("performing disconnect (%s)", this.nsp), this.packet({ type: c.DISCONNECT })), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
      };
    }, {
      "./on": 4,
      "component-bind": 8,
      "component-emitter": 9,
      debug: 10,
      "has-binary": 36,
      "socket.io-parser": 44,
      "to-array": 48
    }],
    6: [function(r, o) {
      (function(n) {
        function s(g, p) {
          var _ = g, p = p || n.location;
          return g == null && (g = p.protocol + "//" + p.host), typeof g == "string" && (g.charAt(0) == "/" && (g = g.charAt(1) == "/" ? p.protocol + g : p.hostname + g), /^(https?|wss?):\/\//.test(g) || (f("protocol-less url %s", g), g = typeof p < "u" ? p.protocol + "//" + g : "https://" + g), f("parse %s", g), _ = c(g)), _.port || (/^(http|ws)$/.test(_.protocol) ? _.port = "80" : /^(http|ws)s$/.test(_.protocol) && (_.port = "443")), _.path = _.path || "/", _.id = _.protocol + "://" + _.host + ":" + _.port, _.href = _.protocol + "://" + _.host + (p && p.port == _.port ? "" : ":" + _.port), _;
        }
        var c = r("parseuri"), f = r("debug")("socket.io-client:url");
        o.exports = s;
      }).call(this, typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, { debug: 10, parseuri: 42 }],
    7: [function(r, o) {
      function n(s) {
        s = s || {}, this.ms = s.min || 100, this.max = s.max || 1e4, this.factor = s.factor || 2, this.jitter = s.jitter > 0 && s.jitter <= 1 ? s.jitter : 0, this.attempts = 0;
      }
      o.exports = n, n.prototype.duration = function() {
        var s = this.ms * Math.pow(this.factor, this.attempts++);
        if (this.jitter) {
          var c = Math.random(), f = Math.floor(c * this.jitter * s);
          s = 1 & Math.floor(10 * c) ? s + f : s - f;
        }
        return 0 | Math.min(s, this.max);
      }, n.prototype.reset = function() {
        this.attempts = 0;
      }, n.prototype.setMin = function(s) {
        this.ms = s;
      }, n.prototype.setMax = function(s) {
        this.max = s;
      }, n.prototype.setJitter = function(s) {
        this.jitter = s;
      };
    }, {}],
    8: [function(r, o) {
      var n = [].slice;
      o.exports = function(s, c) {
        if (typeof c == "string" && (c = s[c]), typeof c != "function")
          throw new Error("bind() requires a function");
        var f = n.call(arguments, 2);
        return function() {
          return c.apply(s, f.concat(n.call(arguments)));
        };
      };
    }, {}],
    9: [function(r, o) {
      function n(c) {
        return c ? s(c) : void 0;
      }
      function s(c) {
        for (var f in n.prototype)
          c[f] = n.prototype[f];
        return c;
      }
      o.exports = n, n.prototype.on = n.prototype.addEventListener = function(c, f) {
        return this._callbacks = this._callbacks || {}, (this._callbacks[c] = this._callbacks[c] || []).push(f), this;
      }, n.prototype.once = function(c, f) {
        function g() {
          y.off(c, g), f.apply(this, arguments);
        }
        var y = this;
        return this._callbacks = this._callbacks || {}, g.fn = f, this.on(c, g), this;
      }, n.prototype.off = n.prototype.removeListener = n.prototype.removeAllListeners = n.prototype.removeEventListener = function(c, f) {
        if (this._callbacks = this._callbacks || {}, arguments.length == 0)
          return this._callbacks = {}, this;
        var g = this._callbacks[c];
        if (!g)
          return this;
        if (arguments.length == 1)
          return delete this._callbacks[c], this;
        for (var y, _ = 0; _ < g.length; _++)
          if (y = g[_], y === f || y.fn === f) {
            g.splice(_, 1);
            break;
          }
        return this;
      }, n.prototype.emit = function(c) {
        this._callbacks = this._callbacks || {};
        var f = [].slice.call(arguments, 1), g = this._callbacks[c];
        if (g) {
          g = g.slice(0);
          for (var y = 0, _ = g.length; _ > y; ++y)
            g[y].apply(this, f);
        }
        return this;
      }, n.prototype.listeners = function(c) {
        return this._callbacks = this._callbacks || {}, this._callbacks[c] || [];
      }, n.prototype.hasListeners = function(c) {
        return !!this.listeners(c).length;
      };
    }, {}],
    10: [function(r, o) {
      function n(c) {
        return n.enabled(c) ? function(f) {
          f = s(f);
          var g = /* @__PURE__ */ new Date(), y = g - (n[c] || g);
          n[c] = g, f = c + " " + f + " +" + n.humanize(y), window.console && console.log && Function.prototype.apply.call(console.log, console, arguments);
        } : function() {
        };
      }
      function s(c) {
        return c instanceof Error ? c.stack || c.message : c;
      }
      o.exports = n, n.names = [], n.skips = [], n.enable = function(c) {
        try {
          localStorage.debug = c;
        } catch (_) {
        }
        for (var f = (c || "").split(/[\s,]+/), g = f.length, y = 0; g > y; y++)
          c = f[y].replace("*", ".*?"), c[0] === "-" ? n.skips.push(new RegExp("^" + c.substr(1) + "$")) : n.names.push(new RegExp("^" + c + "$"));
      }, n.disable = function() {
        n.enable("");
      }, n.humanize = function(c) {
        var f = 1e3, g = 6e4, y = 60 * g;
        return c >= y ? (c / y).toFixed(1) + "h" : c >= g ? (c / g).toFixed(1) + "m" : c >= f ? (c / f | 0) + "s" : c + "ms";
      }, n.enabled = function(c) {
        for (var f = 0, g = n.skips.length; g > f; f++)
          if (n.skips[f].test(c))
            return !1;
        for (var f = 0, g = n.names.length; g > f; f++)
          if (n.names[f].test(c))
            return !0;
        return !1;
      };
      try {
        window.localStorage && n.enable(localStorage.debug);
      } catch (c) {
      }
    }, {}],
    11: [function(r, o) {
      o.exports = r("./lib/");
    }, { "./lib/": 12 }],
    12: [function(r, o) {
      o.exports = r("./socket"), o.exports.parser = r("engine.io-parser");
    }, { "./socket": 13, "engine.io-parser": 25 }],
    13: [function(r, o) {
      (function(n) {
        function s(u, k) {
          if (!(this instanceof s))
            return new s(u, k);
          if (k = k || {}, u && typeof u == "object" && (k = u, u = null), u && (u = m(u), k.host = u.host, k.secure = u.protocol == "https" || u.protocol == "wss", k.port = u.port, u.query && (k.query = u.query)), this.secure = k.secure != null ? k.secure : n.location && location.protocol == "https:", k.host) {
            var C = k.host.split(":");
            k.hostname = C.shift(), C.length ? k.port = C.pop() : k.port || (k.port = this.secure ? "443" : "80");
          }
          this.agent = k.agent || !1, this.hostname = k.hostname || (n.location ? location.hostname : "localhost"), this.port = k.port || (n.location && location.port ? location.port : this.secure ? 443 : 80), this.query = k.query || {}, typeof this.query == "string" && (this.query = l.decode(this.query)), this.upgrade = k.upgrade !== !1, this.path = (k.path || "/engine.io").replace(/\/$/, "") + "/", this.forceJSONP = !!k.forceJSONP, this.jsonp = k.jsonp !== !1, this.forceBase64 = !!k.forceBase64, this.enablesXDR = !!k.enablesXDR, this.timestampParam = k.timestampParam || "t", this.timestampRequests = k.timestampRequests, this.transports = k.transports || ["polling", "websocket"], this.readyState = "", this.writeBuffer = [], this.callbackBuffer = [], this.policyPort = k.policyPort || 843, this.rememberUpgrade = k.rememberUpgrade || !1, this.binaryType = null, this.onlyBinaryUpgrades = k.onlyBinaryUpgrades, this.pfx = k.pfx || null, this.key = k.key || null, this.passphrase = k.passphrase || null, this.cert = k.cert || null, this.ca = k.ca || null, this.ciphers = k.ciphers || null, this.rejectUnauthorized = k.rejectUnauthorized || null, this.open();
        }
        function c(u) {
          var k = {};
          for (var C in u)
            u.hasOwnProperty(C) && (k[C] = u[C]);
          return k;
        }
        var f = r("./transports"), g = r("component-emitter"), y = r("debug")("engine.io-client:socket"), _ = r("indexof"), p = r("engine.io-parser"), m = r("parseuri"), d = r("parsejson"), l = r("parseqs");
        o.exports = s, s.priorWebsocketSuccess = !1, g(s.prototype), s.protocol = p.protocol, s.Socket = s, s.Transport = r("./transport"), s.transports = r("./transports"), s.parser = r("engine.io-parser"), s.prototype.createTransport = function(u) {
          y('creating transport "%s"', u);
          var k = c(this.query);
          k.EIO = p.protocol, k.transport = u, this.id && (k.sid = this.id);
          var C = new f[u]({
            agent: this.agent,
            hostname: this.hostname,
            port: this.port,
            secure: this.secure,
            path: this.path,
            query: k,
            forceJSONP: this.forceJSONP,
            jsonp: this.jsonp,
            forceBase64: this.forceBase64,
            enablesXDR: this.enablesXDR,
            timestampRequests: this.timestampRequests,
            timestampParam: this.timestampParam,
            policyPort: this.policyPort,
            socket: this,
            pfx: this.pfx,
            key: this.key,
            passphrase: this.passphrase,
            cert: this.cert,
            ca: this.ca,
            ciphers: this.ciphers,
            rejectUnauthorized: this.rejectUnauthorized
          });
          return C;
        }, s.prototype.open = function() {
          var k;
          if (this.rememberUpgrade && s.priorWebsocketSuccess && this.transports.indexOf("websocket") != -1)
            k = "websocket";
          else {
            if (this.transports.length == 0) {
              var u = this;
              return void setTimeout(function() {
                u.emit("error", "No transports available");
              }, 0);
            }
            k = this.transports[0];
          }
          this.readyState = "opening";
          var k;
          try {
            k = this.createTransport(k);
          } catch (C) {
            return this.transports.shift(), void this.open();
          }
          k.open(), this.setTransport(k);
        }, s.prototype.setTransport = function(u) {
          y("setting transport %s", u.name);
          var k = this;
          this.transport && (y("clearing existing transport %s", this.transport.name), this.transport.removeAllListeners()), this.transport = u, u.on("drain", function() {
            k.onDrain();
          }).on("packet", function(C) {
            k.onPacket(C);
          }).on("error", function(C) {
            k.onError(C);
          }).on("close", function() {
            k.onClose("transport close");
          });
        }, s.prototype.probe = function(u) {
          function k() {
            if (B.onlyBinaryUpgrades) {
              var D = !this.supportsBinary && B.transport.supportsBinary;
              x = x || D;
            }
            x || (y('probe transport "%s" opened', u), U.send([{
              type: "ping",
              data: "probe"
            }]), U.once("packet", function(O) {
              if (!x)
                if (O.type == "pong" && O.data == "probe") {
                  if (y('probe transport "%s" pong', u), B.upgrading = !0, B.emit("upgrading", U), !U)
                    return;
                  s.priorWebsocketSuccess = U.name == "websocket", y('pausing current transport "%s"', B.transport.name), B.transport.pause(function() {
                    x || B.readyState != "closed" && (y("changing transport and sending upgrade packet"), R(), B.setTransport(U), U.send([{ type: "upgrade" }]), B.emit("upgrade", U), U = null, B.upgrading = !1, B.flush());
                  });
                } else {
                  y('probe transport "%s" failed', u);
                  var I = new Error("probe error");
                  I.transport = U.name, B.emit("upgradeError", I);
                }
            }));
          }
          function C() {
            x || (x = !0, R(), U.close(), U = null);
          }
          function S(D) {
            var O = new Error("probe error: " + D);
            O.transport = U.name, C(), y('probe transport "%s" failed because of error: %s', u, D), B.emit("upgradeError", O);
          }
          function L() {
            S("transport closed");
          }
          function Y() {
            S("socket closed");
          }
          function H(D) {
            U && D.name != U.name && (y('"%s" works - aborting "%s"', D.name, U.name), C());
          }
          function R() {
            U.removeListener("open", k), U.removeListener("error", S), U.removeListener("close", L), B.removeListener("close", Y), B.removeListener("upgrading", H);
          }
          y('probing transport "%s"', u);
          var U = this.createTransport(u, { probe: 1 }), x = !1, B = this;
          s.priorWebsocketSuccess = !1, U.once("open", k), U.once("error", S), U.once("close", L), this.once("close", Y), this.once("upgrading", H), U.open();
        }, s.prototype.onOpen = function() {
          if (y("socket open"), this.readyState = "open", s.priorWebsocketSuccess = this.transport.name == "websocket", this.emit("open"), this.flush(), this.readyState == "open" && this.upgrade && this.transport.pause) {
            y("starting upgrade probes");
            for (var u = 0, k = this.upgrades.length; k > u; u++)
              this.probe(this.upgrades[u]);
          }
        }, s.prototype.onPacket = function(u) {
          if (this.readyState == "opening" || this.readyState == "open")
            switch (y('socket receive: type "%s", data "%s"', u.type, u.data), this.emit("packet", u), this.emit("heartbeat"), u.type) {
              case "open":
                this.onHandshake(d(u.data));
                break;
              case "pong":
                this.setPing();
                break;
              case "error":
                var k = new Error("server error");
                k.code = u.data, this.emit("error", k);
                break;
              case "message":
                this.emit("data", u.data), this.emit("message", u.data);
            }
          else
            y('packet received with socket readyState "%s"', this.readyState);
        }, s.prototype.onHandshake = function(u) {
          this.emit("handshake", u), this.id = u.sid, this.transport.query.sid = u.sid, this.upgrades = this.filterUpgrades(u.upgrades), this.pingInterval = u.pingInterval, this.pingTimeout = u.pingTimeout, this.onOpen(), this.readyState != "closed" && (this.setPing(), this.removeListener("heartbeat", this.onHeartbeat), this.on("heartbeat", this.onHeartbeat));
        }, s.prototype.onHeartbeat = function(u) {
          clearTimeout(this.pingTimeoutTimer);
          var k = this;
          k.pingTimeoutTimer = setTimeout(function() {
            k.readyState != "closed" && k.onClose("ping timeout");
          }, u || k.pingInterval + k.pingTimeout);
        }, s.prototype.setPing = function() {
          var u = this;
          clearTimeout(u.pingIntervalTimer), u.pingIntervalTimer = setTimeout(function() {
            y("writing ping packet - expecting pong within %sms", u.pingTimeout), u.ping(), u.onHeartbeat(u.pingTimeout);
          }, u.pingInterval);
        }, s.prototype.ping = function() {
          this.sendPacket("ping");
        }, s.prototype.onDrain = function() {
          for (var u = 0; u < this.prevBufferLen; u++)
            this.callbackBuffer[u] && this.callbackBuffer[u]();
          this.writeBuffer.splice(0, this.prevBufferLen), this.callbackBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length == 0 ? this.emit("drain") : this.flush();
        }, s.prototype.flush = function() {
          this.readyState != "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length && (y("flushing %d packets in socket", this.writeBuffer.length), this.transport.send(this.writeBuffer), this.prevBufferLen = this.writeBuffer.length, this.emit("flush"));
        }, s.prototype.write = s.prototype.send = function(u, k) {
          return this.sendPacket("message", u, k), this;
        }, s.prototype.sendPacket = function(u, k, C) {
          if (this.readyState != "closing" && this.readyState != "closed") {
            var S = { type: u, data: k };
            this.emit("packetCreate", S), this.writeBuffer.push(S), this.callbackBuffer.push(C), this.flush();
          }
        }, s.prototype.close = function() {
          function u() {
            S.onClose("forced close"), y("socket closing - telling transport to close"), S.transport.close();
          }
          function k() {
            S.removeListener("upgrade", k), S.removeListener("upgradeError", k), u();
          }
          function C() {
            S.once("upgrade", k), S.once("upgradeError", k);
          }
          if (this.readyState == "opening" || this.readyState == "open") {
            this.readyState = "closing";
            var S = this;
            this.writeBuffer.length ? this.once("drain", function() {
              this.upgrading ? C() : u();
            }) : this.upgrading ? C() : u();
          }
          return this;
        }, s.prototype.onError = function(u) {
          y("socket error %j", u), s.priorWebsocketSuccess = !1, this.emit("error", u), this.onClose("transport error", u);
        }, s.prototype.onClose = function(u, k) {
          if (this.readyState == "opening" || this.readyState == "open" || this.readyState == "closing") {
            y('socket close with reason: "%s"', u);
            var C = this;
            clearTimeout(this.pingIntervalTimer), clearTimeout(this.pingTimeoutTimer), setTimeout(function() {
              C.writeBuffer = [], C.callbackBuffer = [], C.prevBufferLen = 0;
            }, 0), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), this.readyState = "closed", this.id = null, this.emit("close", u, k);
          }
        }, s.prototype.filterUpgrades = function(u) {
          for (var k = [], C = 0, S = u.length; S > C; C++)
            ~_(this.transports, u[C]) && k.push(u[C]);
          return k;
        };
      }).call(this, typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {
      "./transport": 14,
      "./transports": 15,
      "component-emitter": 9,
      debug: 22,
      "engine.io-parser": 25,
      indexof: 40,
      parsejson: 32,
      parseqs: 33,
      parseuri: 34
    }],
    14: [function(r, o) {
      function n(f) {
        this.path = f.path, this.hostname = f.hostname, this.port = f.port, this.secure = f.secure, this.query = f.query, this.timestampParam = f.timestampParam, this.timestampRequests = f.timestampRequests, this.readyState = "", this.agent = f.agent || !1, this.socket = f.socket, this.enablesXDR = f.enablesXDR, this.pfx = f.pfx, this.key = f.key, this.passphrase = f.passphrase, this.cert = f.cert, this.ca = f.ca, this.ciphers = f.ciphers, this.rejectUnauthorized = f.rejectUnauthorized;
      }
      var s = r("engine.io-parser"), c = r("component-emitter");
      o.exports = n, c(n.prototype), n.timestamps = 0, n.prototype.onError = function(f, g) {
        var y = new Error(f);
        return y.type = "TransportError", y.description = g, this.emit("error", y), this;
      }, n.prototype.open = function() {
        return (this.readyState == "closed" || this.readyState == "") && (this.readyState = "opening", this.doOpen()), this;
      }, n.prototype.close = function() {
        return (this.readyState == "opening" || this.readyState == "open") && (this.doClose(), this.onClose()), this;
      }, n.prototype.send = function(f) {
        if (this.readyState != "open")
          throw new Error("Transport not open");
        this.write(f);
      }, n.prototype.onOpen = function() {
        this.readyState = "open", this.writable = !0, this.emit("open");
      }, n.prototype.onData = function(f) {
        var g = s.decodePacket(f, this.socket.binaryType);
        this.onPacket(g);
      }, n.prototype.onPacket = function(f) {
        this.emit("packet", f);
      }, n.prototype.onClose = function() {
        this.readyState = "closed", this.emit("close");
      };
    }, { "component-emitter": 9, "engine.io-parser": 25 }],
    15: [function(r, o, n) {
      (function(s) {
        function c(p) {
          var m, d = !1, l = !1, u = p.jsonp !== !1;
          if (s.location) {
            var k = location.protocol == "https:", C = location.port;
            C || (C = k ? 443 : 80), d = p.hostname != location.hostname || C != p.port, l = p.secure != k;
          }
          if (p.xdomain = d, p.xscheme = l, m = new f(p), "open" in m && !p.forceJSONP)
            return new g(p);
          if (!u)
            throw new Error("JSONP disabled");
          return new y(p);
        }
        var f = r("xmlhttprequest"), g = r("./polling-xhr"), y = r("./polling-jsonp"), _ = r("./websocket");
        n.polling = c, n.websocket = _;
      }).call(this, typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, { "./polling-jsonp": 16, "./polling-xhr": 17, "./websocket": 19, xmlhttprequest: 20 }],
    16: [function(r, o) {
      (function(n) {
        function s() {
        }
        function c(m) {
          f.call(this, m), this.query = this.query || {}, y || (n.___eio || (n.___eio = []), y = n.___eio), this.index = y.length;
          var d = this;
          y.push(function(l) {
            d.onData(l);
          }), this.query.j = this.index, n.document && n.addEventListener && n.addEventListener("beforeunload", function() {
            d.script && (d.script.onerror = s);
          }, !1);
        }
        var f = r("./polling"), g = r("component-inherit");
        o.exports = c;
        var y, _ = /\n/g, p = /\\n/g;
        g(c, f), c.prototype.supportsBinary = !1, c.prototype.doClose = function() {
          this.script && (this.script.parentNode.removeChild(this.script), this.script = null), this.form && (this.form.parentNode.removeChild(this.form), this.form = null, this.iframe = null), f.prototype.doClose.call(this);
        }, c.prototype.doPoll = function() {
          var m = this, d = document.createElement("script");
          this.script && (this.script.parentNode.removeChild(this.script), this.script = null), d.async = !0, d.src = this.uri(), d.onerror = function(k) {
            m.onError("jsonp poll error", k);
          };
          var l = document.getElementsByTagName("script")[0];
          l.parentNode.insertBefore(d, l), this.script = d;
          var u = typeof navigator < "u" && /gecko/i.test(navigator.userAgent);
          u && setTimeout(function() {
            var k = document.createElement("iframe");
            document.body.appendChild(k), document.body.removeChild(k);
          }, 100);
        }, c.prototype.doWrite = function(m, d) {
          function l() {
            u(), d();
          }
          function u() {
            if (k.iframe)
              try {
                k.form.removeChild(k.iframe);
              } catch (R) {
                k.onError("jsonp polling iframe removal error", R);
              }
            try {
              var H = '<iframe src="javascript:0" name="' + k.iframeId + '">';
              C = document.createElement(H);
            } catch (R) {
              C = document.createElement("iframe"), C.name = k.iframeId, C.src = "javascript:0";
            }
            C.id = k.iframeId, k.form.appendChild(C), k.iframe = C;
          }
          var k = this;
          if (!this.form) {
            var C, S = document.createElement("form"), L = document.createElement("textarea"), Y = this.iframeId = "eio_iframe_" + this.index;
            S.className = "socketio", S.style.position = "absolute", S.style.top = "-1000px", S.style.left = "-1000px", S.target = Y, S.method = "POST", S.setAttribute("accept-charset", "utf-8"), L.name = "d", S.appendChild(L), document.body.appendChild(S), this.form = S, this.area = L;
          }
          this.form.action = this.uri(), u(), m = m.replace(p, `\\
`), this.area.value = m.replace(_, "\\n");
          try {
            this.form.submit();
          } catch (H) {
          }
          this.iframe.attachEvent ? this.iframe.onreadystatechange = function() {
            k.iframe.readyState == "complete" && l();
          } : this.iframe.onload = l;
        };
      }).call(this, typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, { "./polling": 18, "component-inherit": 21 }],
    17: [function(r, o) {
      (function(n) {
        function s() {
        }
        function c(l) {
          if (_.call(this, l), n.location) {
            var u = location.protocol == "https:", k = location.port;
            k || (k = u ? 443 : 80), this.xd = l.hostname != n.location.hostname || k != l.port, this.xs = l.secure != u;
          }
        }
        function f(l) {
          this.method = l.method || "GET", this.uri = l.uri, this.xd = !!l.xd, this.xs = !!l.xs, this.async = l.async !== !1, this.data = l.data != null ? l.data : null, this.agent = l.agent, this.isBinary = l.isBinary, this.supportsBinary = l.supportsBinary, this.enablesXDR = l.enablesXDR, this.pfx = l.pfx, this.key = l.key, this.passphrase = l.passphrase, this.cert = l.cert, this.ca = l.ca, this.ciphers = l.ciphers, this.rejectUnauthorized = l.rejectUnauthorized, this.create();
        }
        function g() {
          for (var l in f.requests)
            f.requests.hasOwnProperty(l) && f.requests[l].abort();
        }
        var y = r("xmlhttprequest"), _ = r("./polling"), p = r("component-emitter"), m = r("component-inherit"), d = r("debug")("engine.io-client:polling-xhr");
        o.exports = c, o.exports.Request = f, m(c, _), c.prototype.supportsBinary = !0, c.prototype.request = function(l) {
          return l = l || {}, l.uri = this.uri(), l.xd = this.xd, l.xs = this.xs, l.agent = this.agent || !1, l.supportsBinary = this.supportsBinary, l.enablesXDR = this.enablesXDR, l.pfx = this.pfx, l.key = this.key, l.passphrase = this.passphrase, l.cert = this.cert, l.ca = this.ca, l.ciphers = this.ciphers, l.rejectUnauthorized = this.rejectUnauthorized, new f(l);
        }, c.prototype.doWrite = function(l, u) {
          var k = typeof l != "string" && l !== void 0, C = this.request({ method: "POST", data: l, isBinary: k }), S = this;
          C.on("success", u), C.on("error", function(L) {
            S.onError("xhr post error", L);
          }), this.sendXhr = C;
        }, c.prototype.doPoll = function() {
          d("xhr poll");
          var l = this.request(), u = this;
          l.on("data", function(k) {
            u.onData(k);
          }), l.on("error", function(k) {
            u.onError("xhr poll error", k);
          }), this.pollXhr = l;
        }, p(f.prototype), f.prototype.create = function() {
          var l = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
          l.pfx = this.pfx, l.key = this.key, l.passphrase = this.passphrase, l.cert = this.cert, l.ca = this.ca, l.ciphers = this.ciphers, l.rejectUnauthorized = this.rejectUnauthorized;
          var u = this.xhr = new y(l), k = this;
          try {
            if (d("xhr open %s: %s", this.method, this.uri), u.open(this.method, this.uri, this.async), this.supportsBinary && (u.responseType = "arraybuffer"), this.method == "POST")
              try {
                this.isBinary ? u.setRequestHeader("Content-type", "application/octet-stream") : u.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
              } catch (C) {
              }
            "withCredentials" in u && (u.withCredentials = !0), this.hasXDR() ? (u.onload = function() {
              k.onLoad();
            }, u.onerror = function() {
              k.onError(u.responseText);
            }) : u.onreadystatechange = function() {
              u.readyState == 4 && (u.status == 200 || u.status == 1223 ? k.onLoad() : setTimeout(function() {
                k.onError(u.status);
              }, 0));
            }, d("xhr data %s", this.data), u.send(this.data);
          } catch (C) {
            return void setTimeout(function() {
              k.onError(C);
            }, 0);
          }
          n.document && (this.index = f.requestsCount++, f.requests[this.index] = this);
        }, f.prototype.onSuccess = function() {
          this.emit("success"), this.cleanup();
        }, f.prototype.onData = function(l) {
          this.emit("data", l), this.onSuccess();
        }, f.prototype.onError = function(l) {
          this.emit("error", l), this.cleanup(!0);
        }, f.prototype.cleanup = function(l) {
          if (typeof this.xhr < "u" && this.xhr !== null) {
            if (this.hasXDR() ? this.xhr.onload = this.xhr.onerror = s : this.xhr.onreadystatechange = s, l)
              try {
                this.xhr.abort();
              } catch (u) {
              }
            n.document && delete f.requests[this.index], this.xhr = null;
          }
        }, f.prototype.onLoad = function() {
          var l;
          try {
            var u;
            try {
              u = this.xhr.getResponseHeader("Content-Type").split(";")[0];
            } catch (k) {
            }
            l = u === "application/octet-stream" ? this.xhr.response : this.supportsBinary ? "ok" : this.xhr.responseText;
          } catch (k) {
            this.onError(k);
          }
          l != null && this.onData(l);
        }, f.prototype.hasXDR = function() {
          return typeof n.XDomainRequest < "u" && !this.xs && this.enablesXDR;
        }, f.prototype.abort = function() {
          this.cleanup();
        }, n.document && (f.requestsCount = 0, f.requests = {}, n.attachEvent ? n.attachEvent("onunload", g) : n.addEventListener && n.addEventListener("beforeunload", g, !1));
      }).call(this, typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, { "./polling": 18, "component-emitter": 9, "component-inherit": 21, debug: 22, xmlhttprequest: 20 }],
    18: [function(r, o) {
      function n(p) {
        var m = p && p.forceBase64;
        (!_ || m) && (this.supportsBinary = !1), s.call(this, p);
      }
      var s = r("../transport"), c = r("parseqs"), f = r("engine.io-parser"), g = r("component-inherit"), y = r("debug")("engine.io-client:polling");
      o.exports = n;
      var _ = function() {
        var p = r("xmlhttprequest"), m = new p({ xdomain: !1 });
        return m.responseType != null;
      }();
      g(n, s), n.prototype.name = "polling", n.prototype.doOpen = function() {
        this.poll();
      }, n.prototype.pause = function(p) {
        function m() {
          y("paused"), d.readyState = "paused", p();
        }
        var d = this;
        if (this.readyState = "pausing", this.polling || !this.writable) {
          var l = 0;
          this.polling && (y("we are currently polling - waiting to pause"), l++, this.once("pollComplete", function() {
            y("pre-pause polling complete"), --l || m();
          })), this.writable || (y("we are currently writing - waiting to pause"), l++, this.once("drain", function() {
            y("pre-pause writing complete"), --l || m();
          }));
        } else
          m();
      }, n.prototype.poll = function() {
        y("polling"), this.polling = !0, this.doPoll(), this.emit("poll");
      }, n.prototype.onData = function(p) {
        var m = this;
        y("polling got data %s", p);
        var d = function(l) {
          return m.readyState == "opening" && m.onOpen(), l.type == "close" ? (m.onClose(), !1) : void m.onPacket(l);
        };
        f.decodePayload(p, this.socket.binaryType, d), this.readyState != "closed" && (this.polling = !1, this.emit("pollComplete"), this.readyState == "open" ? this.poll() : y('ignoring poll - transport state "%s"', this.readyState));
      }, n.prototype.doClose = function() {
        function p() {
          y("writing close packet"), m.write([{ type: "close" }]);
        }
        var m = this;
        this.readyState == "open" ? (y("transport open - closing"), p()) : (y("transport not open - deferring close"), this.once("open", p));
      }, n.prototype.write = function(p) {
        var d = this;
        this.writable = !1;
        var m = function() {
          d.writable = !0, d.emit("drain");
        }, d = this;
        f.encodePayload(p, this.supportsBinary, function(l) {
          d.doWrite(l, m);
        });
      }, n.prototype.uri = function() {
        var p = this.query || {}, m = this.secure ? "https" : "http", d = "";
        return this.timestampRequests !== !1 && (p[this.timestampParam] = +/* @__PURE__ */ new Date() + "-" + s.timestamps++), this.supportsBinary || p.sid || (p.b64 = 1), p = c.encode(p), this.port && (m == "https" && this.port != 443 || m == "http" && this.port != 80) && (d = ":" + this.port), p.length && (p = "?" + p), m + "://" + this.hostname + d + this.path + p;
      };
    }, {
      "../transport": 14,
      "component-inherit": 21,
      debug: 22,
      "engine.io-parser": 25,
      parseqs: 33,
      xmlhttprequest: 20
    }],
    19: [function(r, o) {
      function n(p) {
        var m = p && p.forceBase64;
        m && (this.supportsBinary = !1), s.call(this, p);
      }
      var s = r("../transport"), c = r("engine.io-parser"), f = r("parseqs"), g = r("component-inherit"), y = r("debug")("engine.io-client:websocket"), _ = r("ws");
      o.exports = n, g(n, s), n.prototype.name = "websocket", n.prototype.supportsBinary = !0, n.prototype.doOpen = function() {
        if (this.check()) {
          var p = this.uri(), m = void 0, d = { agent: this.agent };
          d.pfx = this.pfx, d.key = this.key, d.passphrase = this.passphrase, d.cert = this.cert, d.ca = this.ca, d.ciphers = this.ciphers, d.rejectUnauthorized = this.rejectUnauthorized, this.ws = new _(p, m, d), this.ws.binaryType === void 0 && (this.supportsBinary = !1), this.ws.binaryType = "arraybuffer", this.addEventListeners();
        }
      }, n.prototype.addEventListeners = function() {
        var p = this;
        this.ws.onopen = function() {
          p.onOpen();
        }, this.ws.onclose = function() {
          p.onClose();
        }, this.ws.onmessage = function(m) {
          p.onData(m.data);
        }, this.ws.onerror = function(m) {
          p.onError("websocket error", m);
        };
      }, typeof navigator < "u" && /iPad|iPhone|iPod/i.test(navigator.userAgent) && (n.prototype.onData = function(p) {
        var m = this;
        setTimeout(function() {
          s.prototype.onData.call(m, p);
        }, 0);
      }), n.prototype.write = function(p) {
        function m() {
          d.writable = !0, d.emit("drain");
        }
        var d = this;
        this.writable = !1;
        for (var l = 0, u = p.length; u > l; l++)
          c.encodePacket(p[l], this.supportsBinary, function(k) {
            try {
              d.ws.send(k);
            } catch (C) {
              y("websocket closed before onclose event");
            }
          });
        setTimeout(m, 0);
      }, n.prototype.onClose = function() {
        s.prototype.onClose.call(this);
      }, n.prototype.doClose = function() {
        typeof this.ws < "u" && this.ws.close();
      }, n.prototype.uri = function() {
        var p = this.query || {}, m = this.secure ? "wss" : "ws", d = "";
        return this.port && (m == "wss" && this.port != 443 || m == "ws" && this.port != 80) && (d = ":" + this.port), this.timestampRequests && (p[this.timestampParam] = +/* @__PURE__ */ new Date()), this.supportsBinary || (p.b64 = 1), p = f.encode(p), p.length && (p = "?" + p), m + "://" + this.hostname + d + this.path + p;
      }, n.prototype.check = function() {
        return !(!_ || "__initialize" in _ && this.name === n.prototype.name);
      };
    }, { "../transport": 14, "component-inherit": 21, debug: 22, "engine.io-parser": 25, parseqs: 33, ws: 35 }],
    20: [function(r, o) {
      var n = r("has-cors");
      o.exports = function(s) {
        var c = s.xdomain, f = s.xscheme, g = s.enablesXDR;
        try {
          if (typeof XMLHttpRequest < "u" && (!c || n))
            return new XMLHttpRequest();
        } catch (y) {
        }
        try {
          if (typeof XDomainRequest < "u" && !f && g)
            return new XDomainRequest();
        } catch (y) {
        }
        if (!c)
          try {
            return new ActiveXObject("Microsoft.XMLHTTP");
          } catch (y) {
          }
      };
    }, { "has-cors": 38 }],
    21: [function(r, o) {
      o.exports = function(n, s) {
        var c = function() {
        };
        c.prototype = s.prototype, n.prototype = new c(), n.prototype.constructor = n;
      };
    }, {}],
    22: [function(r, o, n) {
      function s() {
        return "WebkitAppearance" in document.documentElement.style || window.console && (console.firebug || console.exception && console.table) || navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31;
      }
      function c() {
        var _ = arguments, p = this.useColors;
        if (_[0] = (p ? "%c" : "") + this.namespace + (p ? " %c" : " ") + _[0] + (p ? "%c " : " ") + "+" + n.humanize(this.diff), !p)
          return _;
        var m = "color: " + this.color;
        _ = [_[0], m, "color: inherit"].concat(Array.prototype.slice.call(_, 1));
        var d = 0, l = 0;
        return _[0].replace(/%[a-z%]/g, function(u) {
          u !== "%%" && (d++, u === "%c" && (l = d));
        }), _.splice(l, 0, m), _;
      }
      function f() {
        return typeof console == "object" && typeof console.log == "function" && Function.prototype.apply.call(console.log, console, arguments);
      }
      function g(_) {
        try {
          _ == null ? localStorage.removeItem("debug") : localStorage.debug = _;
        } catch (p) {
        }
      }
      function y() {
        var _;
        try {
          _ = localStorage.debug;
        } catch (p) {
        }
        return _;
      }
      n = o.exports = r("./debug"), n.log = f, n.formatArgs = c, n.save = g, n.load = y, n.useColors = s, n.colors = ["lightseagreen", "forestgreen", "goldenrod", "dodgerblue", "darkorchid", "crimson"], n.formatters.j = function(_) {
        return JSON.stringify(_);
      }, n.enable(y());
    }, { "./debug": 23 }],
    23: [function(r, o, n) {
      function s() {
        return n.colors[m++ % n.colors.length];
      }
      function c(d) {
        function l() {
        }
        function u() {
          var C = u, S = +/* @__PURE__ */ new Date(), L = S - (p || S);
          C.diff = L, C.prev = p, C.curr = S, p = S, C.useColors == null && (C.useColors = n.useColors()), C.color == null && C.useColors && (C.color = s());
          var Y = Array.prototype.slice.call(arguments);
          Y[0] = n.coerce(Y[0]), typeof Y[0] != "string" && (Y = ["%o"].concat(Y));
          var H = 0;
          Y[0] = Y[0].replace(/%([a-z%])/g, function(U, x) {
            if (U === "%%")
              return U;
            H++;
            var B = n.formatters[x];
            if (typeof B == "function") {
              var D = Y[H];
              U = B.call(C, D), Y.splice(H, 1), H--;
            }
            return U;
          }), typeof n.formatArgs == "function" && (Y = n.formatArgs.apply(C, Y));
          var R = u.log || n.log || console.log.bind(console);
          R.apply(C, Y);
        }
        l.enabled = !1, u.enabled = !0;
        var k = n.enabled(d) ? u : l;
        return k.namespace = d, k;
      }
      function f(d) {
        n.save(d);
        for (var l = (d || "").split(/[\s,]+/), u = l.length, k = 0; u > k; k++)
          l[k] && (d = l[k].replace(/\*/g, ".*?"), d[0] === "-" ? n.skips.push(new RegExp("^" + d.substr(1) + "$")) : n.names.push(new RegExp("^" + d + "$")));
      }
      function g() {
        n.enable("");
      }
      function y(d) {
        var l, u;
        for (l = 0, u = n.skips.length; u > l; l++)
          if (n.skips[l].test(d))
            return !1;
        for (l = 0, u = n.names.length; u > l; l++)
          if (n.names[l].test(d))
            return !0;
        return !1;
      }
      function _(d) {
        return d instanceof Error ? d.stack || d.message : d;
      }
      n = o.exports = c, n.coerce = _, n.disable = g, n.enable = f, n.enabled = y, n.humanize = r("ms"), n.names = [], n.skips = [], n.formatters = {};
      var p, m = 0;
    }, { ms: 24 }],
    24: [function(r, o) {
      function n(d) {
        var l = /^((?:\d+)?\.?\d+) *(ms|seconds?|s|minutes?|m|hours?|h|days?|d|years?|y)?$/i.exec(d);
        if (l) {
          var u = parseFloat(l[1]), k = (l[2] || "ms").toLowerCase();
          switch (k) {
            case "years":
            case "year":
            case "y":
              return u * m;
            case "days":
            case "day":
            case "d":
              return u * p;
            case "hours":
            case "hour":
            case "h":
              return u * _;
            case "minutes":
            case "minute":
            case "m":
              return u * y;
            case "seconds":
            case "second":
            case "s":
              return u * g;
            case "ms":
              return u;
          }
        }
      }
      function s(d) {
        return d >= p ? Math.round(d / p) + "d" : d >= _ ? Math.round(d / _) + "h" : d >= y ? Math.round(d / y) + "m" : d >= g ? Math.round(d / g) + "s" : d + "ms";
      }
      function c(d) {
        return f(d, p, "day") || f(d, _, "hour") || f(d, y, "minute") || f(d, g, "second") || d + " ms";
      }
      function f(d, l, u) {
        return l > d ? void 0 : 1.5 * l > d ? Math.floor(d / l) + " " + u : Math.ceil(d / l) + " " + u + "s";
      }
      var g = 1e3, y = 60 * g, _ = 60 * y, p = 24 * _, m = 365.25 * p;
      o.exports = function(d, l) {
        return l = l || {}, typeof d == "string" ? n(d) : l.long ? c(d) : s(d);
      };
    }, {}],
    25: [function(r, o, n) {
      (function(s) {
        function c(x, B) {
          var D = "b" + n.packets[x.type] + x.data.data;
          return B(D);
        }
        function f(x, B, D) {
          if (!B)
            return n.encodeBase64Packet(x, D);
          var O = x.data, I = new Uint8Array(O), W = new Uint8Array(1 + O.byteLength);
          W[0] = Y[x.type];
          for (var z = 0; z < I.length; z++)
            W[z + 1] = I[z];
          return D(W.buffer);
        }
        function g(x, B, D) {
          if (!B)
            return n.encodeBase64Packet(x, D);
          var O = new FileReader();
          return O.onload = function() {
            x.data = O.result, n.encodePacket(x, B, !0, D);
          }, O.readAsArrayBuffer(x.data);
        }
        function y(x, B, D) {
          if (!B)
            return n.encodeBase64Packet(x, D);
          if (L)
            return g(x, B, D);
          var O = new Uint8Array(1);
          O[0] = Y[x.type];
          var I = new U([O.buffer, x.data]);
          return D(I);
        }
        function _(x, B, D) {
          for (var O = new Array(x.length), I = u(x.length, D), W = function(X, P, pt) {
            B(P, function(ct, At) {
              O[X] = At, pt(ct, O);
            });
          }, z = 0; z < x.length; z++)
            W(z, x[z], I);
        }
        var p = r("./keys"), m = r("has-binary"), d = r("arraybuffer.slice"), l = r("base64-arraybuffer"), u = r("after"), k = r("utf8"), C = navigator.userAgent.match(/Android/i), S = /PhantomJS/i.test(navigator.userAgent), L = C || S;
        n.protocol = 3;
        var Y = n.packets = { open: 0, close: 1, ping: 2, pong: 3, message: 4, upgrade: 5, noop: 6 }, H = p(Y), R = { type: "error", data: "parser error" }, U = r("blob");
        n.encodePacket = function(x, B, D, O) {
          typeof B == "function" && (O = B, B = !1), typeof D == "function" && (O = D, D = null);
          var I = x.data === void 0 ? void 0 : x.data.buffer || x.data;
          if (s.ArrayBuffer && I instanceof ArrayBuffer)
            return f(x, B, O);
          if (U && I instanceof s.Blob)
            return y(x, B, O);
          if (I && I.base64)
            return c(x, O);
          var W = Y[x.type];
          return x.data !== void 0 && (W += D ? k.encode(String(x.data)) : String(x.data)), O("" + W);
        }, n.encodeBase64Packet = function(x, B) {
          var D = "b" + n.packets[x.type];
          if (U && x.data instanceof U) {
            var O = new FileReader();
            return O.onload = function() {
              var P = O.result.split(",")[1];
              B(D + P);
            }, O.readAsDataURL(x.data);
          }
          var I;
          try {
            I = String.fromCharCode.apply(null, new Uint8Array(x.data));
          } catch (P) {
            for (var W = new Uint8Array(x.data), z = new Array(W.length), X = 0; X < W.length; X++)
              z[X] = W[X];
            I = String.fromCharCode.apply(null, z);
          }
          return D += s.btoa(I), B(D);
        }, n.decodePacket = function(x, B, D) {
          if (typeof x == "string" || x === void 0) {
            if (x.charAt(0) == "b")
              return n.decodeBase64Packet(x.substr(1), B);
            if (D)
              try {
                x = k.decode(x);
              } catch (X) {
                return R;
              }
            var I = x.charAt(0);
            return Number(I) == I && H[I] ? x.length > 1 ? {
              type: H[I],
              data: x.substring(1)
            } : { type: H[I] } : R;
          }
          var O = new Uint8Array(x), I = O[0], W = d(x, 1);
          return U && B === "blob" && (W = new U([W])), { type: H[I], data: W };
        }, n.decodeBase64Packet = function(x, B) {
          var D = H[x.charAt(0)];
          if (!s.ArrayBuffer)
            return { type: D, data: { base64: !0, data: x.substr(1) } };
          var O = l.decode(x.substr(1));
          return B === "blob" && U && (O = new U([O])), { type: D, data: O };
        }, n.encodePayload = function(x, B, D) {
          function O(z) {
            return z.length + ":" + z;
          }
          function I(z, X) {
            n.encodePacket(z, W ? B : !1, !0, function(P) {
              X(null, O(P));
            });
          }
          typeof B == "function" && (D = B, B = null);
          var W = m(x);
          return B && W ? U && !L ? n.encodePayloadAsBlob(x, D) : n.encodePayloadAsArrayBuffer(x, D) : x.length ? void _(x, I, function(z, X) {
            return D(X.join(""));
          }) : D("0:");
        }, n.decodePayload = function(x, B, D) {
          if (typeof x != "string")
            return n.decodePayloadAsBinary(x, B, D);
          typeof B == "function" && (D = B, B = null);
          var O;
          if (x == "")
            return D(R, 0, 1);
          for (var I, W, z = "", X = 0, P = x.length; P > X; X++) {
            var pt = x.charAt(X);
            if (pt != ":")
              z += pt;
            else {
              if (z == "" || z != (I = Number(z)) || (W = x.substr(X + 1, I), z != W.length))
                return D(R, 0, 1);
              if (W.length) {
                if (O = n.decodePacket(W, B, !0), R.type == O.type && R.data == O.data)
                  return D(R, 0, 1);
                var ct = D(O, X + I, P);
                if (ct === !1)
                  return;
              }
              X += I, z = "";
            }
          }
          return z != "" ? D(R, 0, 1) : void 0;
        }, n.encodePayloadAsArrayBuffer = function(x, B) {
          function D(O, I) {
            n.encodePacket(O, !0, !0, function(W) {
              return I(null, W);
            });
          }
          return x.length ? void _(x, D, function(O, I) {
            var W = I.reduce(function(P, pt) {
              var ct;
              return ct = typeof pt == "string" ? pt.length : pt.byteLength, P + ct.toString().length + ct + 2;
            }, 0), z = new Uint8Array(W), X = 0;
            return I.forEach(function(P) {
              var pt = typeof P == "string", ct = P;
              if (pt) {
                for (var At = new Uint8Array(P.length), ut = 0; ut < P.length; ut++)
                  At[ut] = P.charCodeAt(ut);
                ct = At.buffer;
              }
              z[X++] = pt ? 0 : 1;
              for (var Ht = ct.byteLength.toString(), ut = 0; ut < Ht.length; ut++)
                z[X++] = parseInt(Ht[ut]);
              z[X++] = 255;
              for (var At = new Uint8Array(ct), ut = 0; ut < At.length; ut++)
                z[X++] = At[ut];
            }), B(z.buffer);
          }) : B(new ArrayBuffer(0));
        }, n.encodePayloadAsBlob = function(x, B) {
          function D(O, I) {
            n.encodePacket(O, !0, !0, function(W) {
              var z = new Uint8Array(1);
              if (z[0] = 1, typeof W == "string") {
                for (var X = new Uint8Array(W.length), P = 0; P < W.length; P++)
                  X[P] = W.charCodeAt(P);
                W = X.buffer, z[0] = 0;
              }
              for (var pt = W instanceof ArrayBuffer ? W.byteLength : W.size, ct = pt.toString(), At = new Uint8Array(ct.length + 1), P = 0; P < ct.length; P++)
                At[P] = parseInt(ct[P]);
              if (At[ct.length] = 255, U) {
                var ut = new U([z.buffer, At.buffer, W]);
                I(null, ut);
              }
            });
          }
          _(x, D, function(O, I) {
            return B(new U(I));
          });
        }, n.decodePayloadAsBinary = function(x, B, D) {
          typeof B == "function" && (D = B, B = null);
          for (var O = x, I = [], W = !1; O.byteLength > 0; ) {
            for (var z = new Uint8Array(O), X = z[0] === 0, P = "", pt = 1; z[pt] != 255; pt++) {
              if (P.length > 310) {
                W = !0;
                break;
              }
              P += z[pt];
            }
            if (W)
              return D(R, 0, 1);
            O = d(O, 2 + P.length), P = parseInt(P);
            var ct = d(O, 0, P);
            if (X)
              try {
                ct = String.fromCharCode.apply(null, new Uint8Array(ct));
              } catch (Ht) {
                var At = new Uint8Array(ct);
                ct = "";
                for (var pt = 0; pt < At.length; pt++)
                  ct += String.fromCharCode(At[pt]);
              }
            I.push(ct), O = d(O, P);
          }
          var ut = I.length;
          I.forEach(function(Ht, Ie) {
            D(n.decodePacket(Ht, B, !0), Ie, ut);
          });
        };
      }).call(this, typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {
      "./keys": 26,
      after: 27,
      "arraybuffer.slice": 28,
      "base64-arraybuffer": 29,
      blob: 30,
      "has-binary": 36,
      utf8: 31
    }],
    26: [function(r, o) {
      o.exports = Object.keys || function(n) {
        var s = [], c = Object.prototype.hasOwnProperty;
        for (var f in n)
          c.call(n, f) && s.push(f);
        return s;
      };
    }, {}],
    27: [function(r, o) {
      function n(c, f, g) {
        function y(p, m) {
          if (y.count <= 0)
            throw new Error("after called too many times");
          --y.count, p ? (_ = !0, f(p), f = g) : y.count !== 0 || _ || f(null, m);
        }
        var _ = !1;
        return g = g || s, y.count = c, c === 0 ? f() : y;
      }
      function s() {
      }
      o.exports = n;
    }, {}],
    28: [function(r, o) {
      o.exports = function(n, s, c) {
        var f = n.byteLength;
        if (s = s || 0, c = c || f, n.slice)
          return n.slice(s, c);
        if (0 > s && (s += f), 0 > c && (c += f), c > f && (c = f), s >= f || s >= c || f === 0)
          return new ArrayBuffer(0);
        for (var g = new Uint8Array(n), y = new Uint8Array(c - s), _ = s, p = 0; c > _; _++, p++)
          y[p] = g[_];
        return y.buffer;
      };
    }, {}],
    29: [function(r, o, n) {
      (function(s) {
        n.encode = function(c) {
          var f, g = new Uint8Array(c), y = g.length, _ = "";
          for (f = 0; y > f; f += 3)
            _ += s[g[f] >> 2], _ += s[(3 & g[f]) << 4 | g[f + 1] >> 4], _ += s[(15 & g[f + 1]) << 2 | g[f + 2] >> 6], _ += s[63 & g[f + 2]];
          return y % 3 === 2 ? _ = _.substring(0, _.length - 1) + "=" : y % 3 === 1 && (_ = _.substring(0, _.length - 2) + "=="), _;
        }, n.decode = function(c) {
          var f, g, y, _, p, m = 0.75 * c.length, d = c.length, l = 0;
          c[c.length - 1] === "=" && (m--, c[c.length - 2] === "=" && m--);
          var u = new ArrayBuffer(m), k = new Uint8Array(u);
          for (f = 0; d > f; f += 4)
            g = s.indexOf(c[f]), y = s.indexOf(c[f + 1]), _ = s.indexOf(c[f + 2]), p = s.indexOf(c[f + 3]), k[l++] = g << 2 | y >> 4, k[l++] = (15 & y) << 4 | _ >> 2, k[l++] = (3 & _) << 6 | 63 & p;
          return u;
        };
      })("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");
    }, {}],
    30: [function(r, o) {
      (function(n) {
        function s(m) {
          for (var d = 0; d < m.length; d++) {
            var l = m[d];
            if (l.buffer instanceof ArrayBuffer) {
              var u = l.buffer;
              if (l.byteLength !== u.byteLength) {
                var k = new Uint8Array(l.byteLength);
                k.set(new Uint8Array(u, l.byteOffset, l.byteLength)), u = k.buffer;
              }
              m[d] = u;
            }
          }
        }
        function c(m, d) {
          d = d || {};
          var l = new g();
          s(m);
          for (var u = 0; u < m.length; u++)
            l.append(m[u]);
          return d.type ? l.getBlob(d.type) : l.getBlob();
        }
        function f(m, d) {
          return s(m), new Blob(m, d || {});
        }
        var g = n.BlobBuilder || n.WebKitBlobBuilder || n.MSBlobBuilder || n.MozBlobBuilder, y = function() {
          try {
            var m = new Blob(["hi"]);
            return m.size === 2;
          } catch (d) {
            return !1;
          }
        }(), _ = y && function() {
          try {
            var m = new Blob([new Uint8Array([1, 2])]);
            return m.size === 2;
          } catch (d) {
            return !1;
          }
        }(), p = g && g.prototype.append && g.prototype.getBlob;
        o.exports = function() {
          return y ? _ ? n.Blob : f : p ? c : void 0;
        }();
      }).call(this, typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}],
    31: [function(r, o, n) {
      (function(s) {
        (function(c) {
          function f(O) {
            for (var I, W, z = [], X = 0, P = O.length; P > X; )
              I = O.charCodeAt(X++), I >= 55296 && 56319 >= I && P > X ? (W = O.charCodeAt(X++), (64512 & W) == 56320 ? z.push(((1023 & I) << 10) + (1023 & W) + 65536) : (z.push(I), X--)) : z.push(I);
            return z;
          }
          function g(O) {
            for (var I, W = O.length, z = -1, X = ""; ++z < W; )
              I = O[z], I > 65535 && (I -= 65536, X += R(I >>> 10 & 1023 | 55296), I = 56320 | 1023 & I), X += R(I);
            return X;
          }
          function y(O) {
            if (O >= 55296 && 57343 >= O)
              throw Error("Lone surrogate U+" + O.toString(16).toUpperCase() + " is not a scalar value");
          }
          function _(O, I) {
            return R(O >> I & 63 | 128);
          }
          function p(O) {
            if (!(4294967168 & O))
              return R(O);
            var I = "";
            return 4294965248 & O ? 4294901760 & O ? !(4292870144 & O) && (I = R(O >> 18 & 7 | 240), I += _(O, 12), I += _(O, 6)) : (y(O), I = R(O >> 12 & 15 | 224), I += _(O, 6)) : I = R(O >> 6 & 31 | 192), I += R(63 & O | 128);
          }
          function m(O) {
            for (var I, W = f(O), z = W.length, X = -1, P = ""; ++X < z; )
              I = W[X], P += p(I);
            return P;
          }
          function d() {
            if (H >= Y)
              throw Error("Invalid byte index");
            var O = 255 & L[H];
            if (H++, (192 & O) == 128)
              return 63 & O;
            throw Error("Invalid continuation byte");
          }
          function l() {
            var O, I, W, z, X;
            if (H > Y)
              throw Error("Invalid byte index");
            if (H == Y)
              return !1;
            if (O = 255 & L[H], H++, (128 & O) == 0)
              return O;
            if ((224 & O) == 192) {
              var I = d();
              if (X = (31 & O) << 6 | I, X >= 128)
                return X;
              throw Error("Invalid continuation byte");
            }
            if ((240 & O) == 224) {
              if (I = d(), W = d(), X = (15 & O) << 12 | I << 6 | W, X >= 2048)
                return y(X), X;
              throw Error("Invalid continuation byte");
            }
            if ((248 & O) == 240 && (I = d(), W = d(), z = d(), X = (15 & O) << 18 | I << 12 | W << 6 | z, X >= 65536 && 1114111 >= X))
              return X;
            throw Error("Invalid UTF-8 detected");
          }
          function u(O) {
            L = f(O), Y = L.length, H = 0;
            for (var I, W = []; (I = l()) !== !1; )
              W.push(I);
            return g(W);
          }
          var k = typeof n == "object" && n, C = typeof o == "object" && o && o.exports == k && o, S = typeof s == "object" && s;
          (S.global === S || S.window === S) && (c = S);
          var L, Y, H, R = String.fromCharCode, U = { version: "2.0.0", encode: m, decode: u };
          if (k && !k.nodeType)
            if (C)
              C.exports = U;
            else {
              var x = {}, B = x.hasOwnProperty;
              for (var D in U)
                B.call(U, D) && (k[D] = U[D]);
            }
          else
            c.utf8 = U;
        })(this);
      }).call(this, typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}],
    32: [function(r, o) {
      (function(n) {
        var s = /^[\],:{}\s]*$/, c = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, f = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, g = /(?:^|:|,)(?:\s*\[)+/g, y = /^\s+/, _ = /\s+$/;
        o.exports = function(p) {
          return typeof p == "string" && p ? (p = p.replace(y, "").replace(_, ""), n.JSON && JSON.parse ? JSON.parse(p) : s.test(p.replace(c, "@").replace(f, "]").replace(g, "")) ? new Function("return " + p)() : void 0) : null;
        };
      }).call(this, typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}],
    33: [function(r, o, n) {
      n.encode = function(s) {
        var c = "";
        for (var f in s)
          s.hasOwnProperty(f) && (c.length && (c += "&"), c += encodeURIComponent(f) + "=" + encodeURIComponent(s[f]));
        return c;
      }, n.decode = function(s) {
        for (var c = {}, f = s.split("&"), g = 0, y = f.length; y > g; g++) {
          var _ = f[g].split("=");
          c[decodeURIComponent(_[0])] = decodeURIComponent(_[1]);
        }
        return c;
      };
    }, {}],
    34: [function(r, o) {
      var n = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, s = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"];
      o.exports = function(c) {
        var f = c, g = c.indexOf("["), y = c.indexOf("]");
        g != -1 && y != -1 && (c = c.substring(0, g) + c.substring(g, y).replace(/:/g, ";") + c.substring(y, c.length));
        for (var _ = n.exec(c || ""), p = {}, m = 14; m--; )
          p[s[m]] = _[m] || "";
        return g != -1 && y != -1 && (p.source = f, p.host = p.host.substring(1, p.host.length - 1).replace(/;/g, ":"), p.authority = p.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), p.ipv6uri = !0), p;
      };
    }, {}],
    35: [function(r, o) {
      function n(f, g) {
        return g ? new c(f, g) : new c(f);
      }
      var s = /* @__PURE__ */ function() {
        return self;
      }(), c = s.WebSocket || s.MozWebSocket;
      o.exports = c ? n : null, c && (n.prototype = c.prototype);
    }, {}],
    36: [function(r, o) {
      (function(n) {
        function s(f) {
          function g(y) {
            if (!y)
              return !1;
            if (n.Buffer && n.Buffer.isBuffer(y) || n.ArrayBuffer && y instanceof ArrayBuffer || n.Blob && y instanceof Blob || n.File && y instanceof File)
              return !0;
            if (c(y)) {
              for (var _ = 0; _ < y.length; _++)
                if (g(y[_]))
                  return !0;
            } else if (y && typeof y == "object") {
              y.toJSON && (y = y.toJSON());
              for (var p in y)
                if (Object.prototype.hasOwnProperty.call(y, p) && g(y[p]))
                  return !0;
            }
            return !1;
          }
          return g(f);
        }
        var c = r("isarray");
        o.exports = s;
      }).call(this, typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, { isarray: 37 }],
    37: [function(r, o) {
      o.exports = Array.isArray || function(n) {
        return Object.prototype.toString.call(n) == "[object Array]";
      };
    }, {}],
    38: [function(r, o) {
      var n = r("global");
      try {
        o.exports = "XMLHttpRequest" in n && "withCredentials" in new n.XMLHttpRequest();
      } catch (s) {
        o.exports = !1;
      }
    }, { global: 39 }],
    39: [function(r, o) {
      o.exports = /* @__PURE__ */ function() {
        return this;
      }();
    }, {}],
    40: [function(r, o) {
      var n = [].indexOf;
      o.exports = function(s, c) {
        if (n)
          return s.indexOf(c);
        for (var f = 0; f < s.length; ++f)
          if (s[f] === c)
            return f;
        return -1;
      };
    }, {}],
    41: [function(r, o, n) {
      var s = Object.prototype.hasOwnProperty;
      n.keys = Object.keys || function(c) {
        var f = [];
        for (var g in c)
          s.call(c, g) && f.push(g);
        return f;
      }, n.values = function(c) {
        var f = [];
        for (var g in c)
          s.call(c, g) && f.push(c[g]);
        return f;
      }, n.merge = function(c, f) {
        for (var g in f)
          s.call(f, g) && (c[g] = f[g]);
        return c;
      }, n.length = function(c) {
        return n.keys(c).length;
      }, n.isEmpty = function(c) {
        return n.length(c) == 0;
      };
    }, {}],
    42: [function(r, o) {
      var n = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, s = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"];
      o.exports = function(c) {
        for (var f = n.exec(c || ""), g = {}, y = 14; y--; )
          g[s[y]] = f[y] || "";
        return g;
      };
    }, {}],
    43: [function(r, o, n) {
      (function(s) {
        var c = r("isarray"), f = r("./is-buffer");
        n.deconstructPacket = function(g) {
          function y(d) {
            if (!d)
              return d;
            if (f(d)) {
              var l = { _placeholder: !0, num: _.length };
              return _.push(d), l;
            }
            if (c(d)) {
              for (var u = new Array(d.length), k = 0; k < d.length; k++)
                u[k] = y(d[k]);
              return u;
            }
            if (typeof d == "object" && !(d instanceof Date)) {
              var u = {};
              for (var C in d)
                u[C] = y(d[C]);
              return u;
            }
            return d;
          }
          var _ = [], p = g.data, m = g;
          return m.data = y(p), m.attachments = _.length, { packet: m, buffers: _ };
        }, n.reconstructPacket = function(g, y) {
          function _(p) {
            if (p && p._placeholder) {
              var m = y[p.num];
              return m;
            }
            if (c(p)) {
              for (var d = 0; d < p.length; d++)
                p[d] = _(p[d]);
              return p;
            }
            if (p && typeof p == "object") {
              for (var l in p)
                p[l] = _(p[l]);
              return p;
            }
            return p;
          }
          return g.data = _(g.data), g.attachments = void 0, g;
        }, n.removeBlobs = function(g, y) {
          function _(d, l, u) {
            if (!d)
              return d;
            if (s.Blob && d instanceof Blob || s.File && d instanceof File) {
              p++;
              var k = new FileReader();
              k.onload = function() {
                u ? u[l] = this.result : m = this.result, --p || y(m);
              }, k.readAsArrayBuffer(d);
            } else if (c(d))
              for (var C = 0; C < d.length; C++)
                _(d[C], C, d);
            else if (d && typeof d == "object" && !f(d))
              for (var S in d)
                _(d[S], S, d);
          }
          var p = 0, m = g;
          _(m), p || y(m);
        };
      }).call(this, typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, { "./is-buffer": 45, isarray: 46 }],
    44: [function(r, o, n) {
      function s() {
      }
      function c(C) {
        var S = "", L = !1;
        return S += C.type, (n.BINARY_EVENT == C.type || n.BINARY_ACK == C.type) && (S += C.attachments, S += "-"), C.nsp && C.nsp != "/" && (L = !0, S += C.nsp), C.id != null && (L && (S += ",", L = !1), S += C.id), C.data != null && (L && (S += ","), S += d.stringify(C.data)), m("encoded %j as %s", C, S), S;
      }
      function f(C, S) {
        function L(Y) {
          var H = u.deconstructPacket(Y), R = c(H.packet), U = H.buffers;
          U.unshift(R), S(U);
        }
        u.removeBlobs(C, L);
      }
      function g() {
        this.reconstructor = null;
      }
      function y(C) {
        var S = {}, L = 0;
        if (S.type = Number(C.charAt(0)), n.types[S.type] == null)
          return p();
        if (n.BINARY_EVENT == S.type || n.BINARY_ACK == S.type) {
          for (var Y = ""; C.charAt(++L) != "-" && (Y += C.charAt(L), L != C.length); )
            ;
          if (Y != Number(Y) || C.charAt(L) != "-")
            throw new Error("Illegal attachments");
          S.attachments = Number(Y);
        }
        if (C.charAt(L + 1) == "/")
          for (S.nsp = ""; ++L; ) {
            var H = C.charAt(L);
            if (H == "," || (S.nsp += H, L == C.length))
              break;
          }
        else
          S.nsp = "/";
        var R = C.charAt(L + 1);
        if (R !== "" && Number(R) == R) {
          for (S.id = ""; ++L; ) {
            var H = C.charAt(L);
            if (H == null || Number(H) != H) {
              --L;
              break;
            }
            if (S.id += C.charAt(L), L == C.length)
              break;
          }
          S.id = Number(S.id);
        }
        if (C.charAt(++L))
          try {
            S.data = d.parse(C.substr(L));
          } catch (U) {
            return p();
          }
        return m("decoded %s as %j", C, S), S;
      }
      function _(C) {
        this.reconPack = C, this.buffers = [];
      }
      function p() {
        return { type: n.ERROR, data: "parser error" };
      }
      var m = r("debug")("socket.io-parser"), d = r("json3"), l = (r("isarray"), r("component-emitter")), u = r("./binary"), k = r("./is-buffer");
      n.protocol = 4, n.types = ["CONNECT", "DISCONNECT", "EVENT", "BINARY_EVENT", "ACK", "BINARY_ACK", "ERROR"], n.CONNECT = 0, n.DISCONNECT = 1, n.EVENT = 2, n.ACK = 3, n.ERROR = 4, n.BINARY_EVENT = 5, n.BINARY_ACK = 6, n.Encoder = s, n.Decoder = g, s.prototype.encode = function(C, S) {
        if (m("encoding packet %j", C), n.BINARY_EVENT == C.type || n.BINARY_ACK == C.type)
          f(C, S);
        else {
          var L = c(C);
          S([L]);
        }
      }, l(g.prototype), g.prototype.add = function(C) {
        var S;
        if (typeof C == "string")
          S = y(C), n.BINARY_EVENT == S.type || n.BINARY_ACK == S.type ? (this.reconstructor = new _(S), this.reconstructor.reconPack.attachments === 0 && this.emit("decoded", S)) : this.emit("decoded", S);
        else {
          if (!k(C) && !C.base64)
            throw new Error("Unknown type: " + C);
          if (!this.reconstructor)
            throw new Error("got binary data when not reconstructing a packet");
          S = this.reconstructor.takeBinaryData(C), S && (this.reconstructor = null, this.emit("decoded", S));
        }
      }, g.prototype.destroy = function() {
        this.reconstructor && this.reconstructor.finishedReconstruction();
      }, _.prototype.takeBinaryData = function(C) {
        if (this.buffers.push(C), this.buffers.length == this.reconPack.attachments) {
          var S = u.reconstructPacket(this.reconPack, this.buffers);
          return this.finishedReconstruction(), S;
        }
        return null;
      }, _.prototype.finishedReconstruction = function() {
        this.reconPack = null, this.buffers = [];
      };
    }, { "./binary": 43, "./is-buffer": 45, "component-emitter": 9, debug: 10, isarray: 46, json3: 47 }],
    45: [function(r, o) {
      (function(n) {
        function s(c) {
          return n.Buffer && n.Buffer.isBuffer(c) || n.ArrayBuffer && c instanceof ArrayBuffer;
        }
        o.exports = s;
      }).call(this, typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}],
    46: [function(r, o) {
      o.exports = r(37);
    }, {}],
    47: [function(r, o, n) {
      (function(s) {
        function c(K) {
          if (c[K] !== y)
            return c[K];
          var Z;
          if (K == "bug-string-char-index")
            Z = !1;
          else if (K == "json")
            Z = c("json-stringify") && c("json-parse");
          else {
            var J, rt = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
            if (K == "json-stringify") {
              var V = m.stringify, et = typeof V == "function" && d;
              if (et) {
                (J = function() {
                  return 1;
                }).toJSON = J;
                try {
                  et = V(0) === "0" && V(new Number()) === "0" && V(new String()) == '""' && V(_) === y && V(y) === y && V() === y && V(J) === "1" && V([J]) == "[1]" && V([y]) == "[null]" && V(null) == "null" && V([y, _, null]) == "[null,null,null]" && V({ a: [J, !0, !1, null, `\0\b
\f\r	`] }) == rt && V(null, J) === "1" && V([1, 2], null, 1) == `[
 1,
 2
]` && V(/* @__PURE__ */ new Date(-864e13)) == '"-271821-04-20T00:00:00.000Z"' && V(/* @__PURE__ */ new Date(864e13)) == '"+275760-09-13T00:00:00.000Z"' && V(/* @__PURE__ */ new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' && V(/* @__PURE__ */ new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
                } catch (at) {
                  et = !1;
                }
              }
              Z = et;
            }
            if (K == "json-parse") {
              var nt = m.parse;
              if (typeof nt == "function")
                try {
                  if (nt("0") === 0 && !nt(!1)) {
                    J = nt(rt);
                    var G = J.a.length == 5 && J.a[0] === 1;
                    if (G) {
                      try {
                        G = !nt('"	"');
                      } catch (at) {
                      }
                      if (G)
                        try {
                          G = nt("01") !== 1;
                        } catch (at) {
                        }
                      if (G)
                        try {
                          G = nt("1.") !== 1;
                        } catch (at) {
                        }
                    }
                  }
                } catch (at) {
                  G = !1;
                }
              Z = G;
            }
          }
          return c[K] = !!Z;
        }
        var f, g, y, _ = {}.toString, p = typeof JSON == "object" && JSON, m = typeof n == "object" && n && !n.nodeType && n;
        m && p ? (m.stringify = p.stringify, m.parse = p.parse) : m = s.JSON = p || {};
        var d = /* @__PURE__ */ new Date(-3509827334573292);
        try {
          d = d.getUTCFullYear() == -109252 && d.getUTCMonth() === 0 && d.getUTCDate() === 1 && d.getUTCHours() == 10 && d.getUTCMinutes() == 37 && d.getUTCSeconds() == 6 && d.getUTCMilliseconds() == 708;
        } catch (K) {
        }
        if (!c("json")) {
          var l = "[object Function]", u = "[object Date]", k = "[object Number]", C = "[object String]", S = "[object Array]", L = "[object Boolean]", Y = c("bug-string-char-index");
          if (!d)
            var H = Math.floor, R = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], U = function(K, Z) {
              return R[Z] + 365 * (K - 1970) + H((K - 1969 + (Z = +(Z > 1))) / 4) - H((K - 1901 + Z) / 100) + H((K - 1601 + Z) / 400);
            };
          (f = {}.hasOwnProperty) || (f = function(K) {
            var Z, J = {};
            return (J.__proto__ = null, J.__proto__ = { toString: 1 }, J).toString != _ ? f = function(rt) {
              var V = this.__proto__, et = rt in (this.__proto__ = null, this);
              return this.__proto__ = V, et;
            } : (Z = J.constructor, f = function(rt) {
              var V = (this.constructor || Z).prototype;
              return rt in this && !(rt in V && this[rt] === V[rt]);
            }), J = null, f.call(this, K);
          });
          var x = { boolean: 1, number: 1, string: 1, undefined: 1 }, B = function(K, Z) {
            var J = typeof K[Z];
            return J == "object" ? !!K[Z] : !x[J];
          };
          if (g = function(K, Z) {
            var J, rt, V, et = 0;
            (J = function() {
              this.valueOf = 0;
            }).prototype.valueOf = 0, rt = new J();
            for (V in rt)
              f.call(rt, V) && et++;
            return J = rt = null, et ? g = et == 2 ? function(nt, G) {
              var at, Et = {}, $t = _.call(nt) == l;
              for (at in nt)
                $t && at == "prototype" || f.call(Et, at) || !(Et[at] = 1) || !f.call(nt, at) || G(at);
            } : function(nt, G) {
              var at, Et, $t = _.call(nt) == l;
              for (at in nt)
                $t && at == "prototype" || !f.call(nt, at) || (Et = at === "constructor") || G(at);
              (Et || f.call(nt, at = "constructor")) && G(at);
            } : (rt = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"], g = function(nt, G) {
              var at, Et, $t = _.call(nt) == l, It = !$t && typeof nt.constructor != "function" && B(nt, "hasOwnProperty") ? nt.hasOwnProperty : f;
              for (at in nt)
                $t && at == "prototype" || !It.call(nt, at) || G(at);
              for (Et = rt.length; at = rt[--Et]; It.call(nt, at) && G(at))
                ;
            }), g(K, Z);
          }, !c("json-stringify")) {
            var D = { 92: "\\\\", 34: '\\"', 8: "\\b", 12: "\\f", 10: "\\n", 13: "\\r", 9: "\\t" }, O = "000000", I = function(K, Z) {
              return (O + (Z || 0)).slice(-K);
            }, W = "\\u00", z = function(K) {
              var Z, J = '"', rt = 0, V = K.length, et = V > 10 && Y;
              for (et && (Z = K.split("")); V > rt; rt++) {
                var nt = K.charCodeAt(rt);
                switch (nt) {
                  case 8:
                  case 9:
                  case 10:
                  case 12:
                  case 13:
                  case 34:
                  case 92:
                    J += D[nt];
                    break;
                  default:
                    if (32 > nt) {
                      J += W + I(2, nt.toString(16));
                      break;
                    }
                    J += et ? Z[rt] : Y ? K.charAt(rt) : K[rt];
                }
              }
              return J + '"';
            }, X = function(K, Z, J, rt, V, et, nt) {
              var G, at, Et, $t, It, Te, Hn, he, En, $n, Zt, te, Le, Ue, Yn, qe;
              try {
                G = Z[K];
              } catch (Qn) {
              }
              if (typeof G == "object" && G)
                if (at = _.call(G), at != u || f.call(G, "toJSON"))
                  typeof G.toJSON == "function" && (at != k && at != C && at != S || f.call(G, "toJSON")) && (G = G.toJSON(K));
                else if (G > -1 / 0 && 1 / 0 > G) {
                  if (U) {
                    for (It = H(G / 864e5), Et = H(It / 365.2425) + 1970 - 1; U(Et + 1, 0) <= It; Et++)
                      ;
                    for ($t = H((It - U(Et, 0)) / 30.42); U(Et, $t + 1) <= It; $t++)
                      ;
                    It = 1 + It - U(Et, $t), Te = (G % 864e5 + 864e5) % 864e5, Hn = H(Te / 36e5) % 24, he = H(Te / 6e4) % 60, En = H(Te / 1e3) % 60, $n = Te % 1e3;
                  } else
                    Et = G.getUTCFullYear(), $t = G.getUTCMonth(), It = G.getUTCDate(), Hn = G.getUTCHours(), he = G.getUTCMinutes(), En = G.getUTCSeconds(), $n = G.getUTCMilliseconds();
                  G = (0 >= Et || Et >= 1e4 ? (0 > Et ? "-" : "+") + I(6, 0 > Et ? -Et : Et) : I(4, Et)) + "-" + I(2, $t + 1) + "-" + I(2, It) + "T" + I(2, Hn) + ":" + I(2, he) + ":" + I(2, En) + "." + I(3, $n) + "Z";
                } else
                  G = null;
              if (J && (G = J.call(Z, K, G)), G === null)
                return "null";
              if (at = _.call(G), at == L)
                return "" + G;
              if (at == k)
                return G > -1 / 0 && 1 / 0 > G ? "" + G : "null";
              if (at == C)
                return z("" + G);
              if (typeof G == "object") {
                for (Ue = nt.length; Ue--; )
                  if (nt[Ue] === G)
                    throw TypeError();
                if (nt.push(G), Zt = [], Yn = et, et += V, at == S) {
                  for (Le = 0, Ue = G.length; Ue > Le; Le++)
                    te = X(Le, G, J, rt, V, et, nt), Zt.push(te === y ? "null" : te);
                  qe = Zt.length ? V ? `[
` + et + Zt.join(`,
` + et) + `
` + Yn + "]" : "[" + Zt.join(",") + "]" : "[]";
                } else
                  g(rt || G, function(Qn) {
                    var Ge = X(Qn, G, J, rt, V, et, nt);
                    Ge !== y && Zt.push(z(Qn) + ":" + (V ? " " : "") + Ge);
                  }), qe = Zt.length ? V ? `{
` + et + Zt.join(`,
` + et) + `
` + Yn + "}" : "{" + Zt.join(",") + "}" : "{}";
                return nt.pop(), qe;
              }
            };
            m.stringify = function(K, Z, J) {
              var rt, V, et, nt;
              if (typeof Z == "function" || typeof Z == "object" && Z) {
                if ((nt = _.call(Z)) == l)
                  V = Z;
                else if (nt == S) {
                  et = {};
                  for (var G, at = 0, Et = Z.length; Et > at; G = Z[at++], nt = _.call(G), (nt == C || nt == k) && (et[G] = 1))
                    ;
                }
              }
              if (J)
                if ((nt = _.call(J)) == k) {
                  if ((J -= J % 1) > 0)
                    for (rt = "", J > 10 && (J = 10); rt.length < J; rt += " ")
                      ;
                } else
                  nt == C && (rt = J.length <= 10 ? J : J.slice(0, 10));
              return X("", (G = {}, G[""] = K, G), V, et, rt, "", []);
            };
          }
          if (!c("json-parse")) {
            var P, pt, ct = String.fromCharCode, At = { 92: "\\", 34: '"', 47: "/", 98: "\b", 116: "	", 110: `
`, 102: "\f", 114: "\r" }, ut = function() {
              throw P = pt = null, SyntaxError();
            }, Ht = function() {
              for (var K, Z, J, rt, V, et = pt, nt = et.length; nt > P; )
                switch (V = et.charCodeAt(P)) {
                  case 9:
                  case 10:
                  case 13:
                  case 32:
                    P++;
                    break;
                  case 123:
                  case 125:
                  case 91:
                  case 93:
                  case 58:
                  case 44:
                    return K = Y ? et.charAt(P) : et[P], P++, K;
                  case 34:
                    for (K = "@", P++; nt > P; )
                      if (V = et.charCodeAt(P), 32 > V)
                        ut();
                      else if (V == 92)
                        switch (V = et.charCodeAt(++P)) {
                          case 92:
                          case 34:
                          case 47:
                          case 98:
                          case 116:
                          case 110:
                          case 102:
                          case 114:
                            K += At[V], P++;
                            break;
                          case 117:
                            for (Z = ++P, J = P + 4; J > P; P++)
                              V = et.charCodeAt(P), V >= 48 && 57 >= V || V >= 97 && 102 >= V || V >= 65 && 70 >= V || ut();
                            K += ct("0x" + et.slice(Z, P));
                            break;
                          default:
                            ut();
                        }
                      else {
                        if (V == 34)
                          break;
                        for (V = et.charCodeAt(P), Z = P; V >= 32 && V != 92 && V != 34; )
                          V = et.charCodeAt(++P);
                        K += et.slice(Z, P);
                      }
                    if (et.charCodeAt(P) == 34)
                      return P++, K;
                    ut();
                  default:
                    if (Z = P, V == 45 && (rt = !0, V = et.charCodeAt(++P)), V >= 48 && 57 >= V) {
                      for (V == 48 && (V = et.charCodeAt(P + 1), V >= 48 && 57 >= V) && ut(), rt = !1; nt > P && (V = et.charCodeAt(P), V >= 48 && 57 >= V); P++)
                        ;
                      if (et.charCodeAt(P) == 46) {
                        for (J = ++P; nt > J && (V = et.charCodeAt(J), V >= 48 && 57 >= V); J++)
                          ;
                        J == P && ut(), P = J;
                      }
                      if (V = et.charCodeAt(P), V == 101 || V == 69) {
                        for (V = et.charCodeAt(++P), (V == 43 || V == 45) && P++, J = P; nt > J && (V = et.charCodeAt(J), V >= 48 && 57 >= V); J++)
                          ;
                        J == P && ut(), P = J;
                      }
                      return +et.slice(Z, P);
                    }
                    if (rt && ut(), et.slice(P, P + 4) == "true")
                      return P += 4, !0;
                    if (et.slice(P, P + 5) == "false")
                      return P += 5, !1;
                    if (et.slice(P, P + 4) == "null")
                      return P += 4, null;
                    ut();
                }
              return "$";
            }, Ie = function(K) {
              var Z, J;
              if (K == "$" && ut(), typeof K == "string") {
                if ((Y ? K.charAt(0) : K[0]) == "@")
                  return K.slice(1);
                if (K == "[") {
                  for (Z = []; K = Ht(), K != "]"; J || (J = !0))
                    J && (K == "," ? (K = Ht(), K == "]" && ut()) : ut()), K == "," && ut(), Z.push(Ie(K));
                  return Z;
                }
                if (K == "{") {
                  for (Z = {}; K = Ht(), K != "}"; J || (J = !0))
                    J && (K == "," ? (K = Ht(), K == "}" && ut()) : ut()), (K == "," || typeof K != "string" || (Y ? K.charAt(0) : K[0]) != "@" || Ht() != ":") && ut(), Z[K.slice(1)] = Ie(Ht());
                  return Z;
                }
                ut();
              }
              return K;
            }, fe = function(K, Z, J) {
              var rt = kr(K, Z, J);
              rt === y ? delete K[Z] : K[Z] = rt;
            }, kr = function(K, Z, J) {
              var rt, V = K[Z];
              if (typeof V == "object" && V)
                if (_.call(V) == S)
                  for (rt = V.length; rt--; )
                    fe(V, rt, J);
                else
                  g(V, function(et) {
                    fe(V, et, J);
                  });
              return J.call(K, Z, V);
            };
            m.parse = function(K, Z) {
              var J, rt;
              return P = 0, pt = "" + K, J = Ie(Ht()), Ht() != "$" && ut(), P = pt = null, Z && _.call(Z) == l ? kr((rt = {}, rt[""] = J, rt), "", Z) : J;
            };
          }
        }
      })(this);
    }, {}],
    48: [function(r, o) {
      function n(s, c) {
        var f = [];
        c = c || 0;
        for (var g = c || 0; g < s.length; g++)
          f[g - c] = s[g];
        return f;
      }
      o.exports = n;
    }, {}]
  }, {}, [1])(1);
}
const qg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mg
}, Symbol.toStringTag, { value: "Module" })), Fg = /* @__PURE__ */ Object.assign({
  "./v1_3_7.js": qg
}), Wg = /v\d+_\d+_\d+/;
function zg(r) {
  return typeof r == "function";
}
const ts = Object.entries(Fg).reduce(
  (r, o) => {
    var n;
    const s = o[1].default, c = (n = o[0].match(Wg)) == null ? void 0 : n[0];
    return zg(s) && c && (r[c] = s()), r;
  },
  {}
), vu = (r) => {
  if (r in ts)
    return ts[r];
  throw new Error(`Socket version ${r} not found`);
}, Vg = (r, ...o) => vu(r)(...o), Jg = ce(kt({}, ts), {
  getSocketVersion: vu,
  makeSocketVersion: Vg
});
var lt = /* @__PURE__ */ ((r) => (r.ALL_DIALER_STATUS = "AllDialersStatus", r.ALL_EXTENSION_STATUS = "AllExtensionsStatus", r.ALL_USERS_STATUS = "AllUsersStatus", r.CONNECT = "connect", r.DISCONNECT = "disconnect", r.CONNECT_ERROR_EVENT = "connect_error", r.EXTENSION_EVENT = "ExtensionEvent", r.KEEP_ALIVE = "keepalive", r.KEEP_ALIVE_RESPONSE = "keepaliveResponse", r.LOGIN_STATUS = "loginStatus", r.LOGIN_SUCCESS = "loginSuccess", r.QUEUE_EVENT = "QueueEvent", r.ONLINE_STATUS_EVENT = "onlineStatusEvent", r.DIALER_EVENT = "DialerEvent", r.EXTENSIONS_UPDATED = "ExtensionsUpdated", r))(lt || {}), gu = /* @__PURE__ */ ((r) => (r.NEWCALL = "NEWCALL", r.ANSWER = "ANSWER", r.HOLD = "HOLD", r.UNHOLD = "UNHOLD", r.HANGUP = "HANGUP", r.USER_STATUS_UPDATE = "userStatusUpdate", r))(gu || {});
class Ki {
  static mapExtensionEvent(o) {
    var _;
    var n, s;
    const c = o.reason;
    let f, g;
    o.data.currentCall && (g = this.mapExtensionCall(o, o.data.currentCall));
    const y = this.mapExtensionData(o, o.data);
    return c === gu.HANGUP ? f = ce(kt({}, o), {
      reason: c,
      data: ce(kt({}, y), {
        currentCall: g ? ce(kt({}, g), {
          duration: Date.now() - ((_ = g == null ? void 0 : g.callAnswered_UTC_CLIENT) != null ? _ : 0)
        }) : void 0,
        calls: (n = o.data.calls) == null ? void 0 : n.map((p) => {
          var d;
          const m = this.mapExtensionCall(o, p);
          return ce(kt({}, m), {
            duration: Date.now() - ((d = m.callAnswered_UTC_CLIENT) != null ? d : 0)
          });
        })
      })
    }) : f = ce(kt({}, o), {
      data: ce(kt({}, y), {
        currentCall: g,
        calls: (s = o.data.calls) == null ? void 0 : s.map((p) => this.mapExtensionCall(o, p))
      }),
      reason: c
    }), f;
  }
  static mapAllExtensionStatus(o) {
    return ce(kt({}, o), {
      extensions: o.extensions.map((n) => {
        var s;
        return ce(kt({}, this.mapExtensionData(o, n)), {
          currentCall: n.currentCall ? this.mapExtensionCall(o, n.currentCall) : void 0,
          calls: (s = n.calls) == null ? void 0 : s.map((c) => this.mapExtensionCall(o, c))
        });
      })
    });
  }
  static mapExtensionData(o, n) {
    return this.configureUTCForObject(
      n,
      [
        {
          key: "lastAnsweredCallEventEpoch",
          format: "sec"
        },
        {
          key: "lastCallEventEpoch",
          format: "sec"
        },
        {
          key: "lastHangupCallEpoch",
          format: "sec"
        },
        {
          key: "representativeUpdated",
          format: "ms"
        }
      ],
      o.servertime,
      o.servertimeoffset
    );
  }
  static mapExtensionCall(o, n) {
    return this.configureUTCForObject(
      n,
      [
        {
          key: "callAnswered",
          format: "sec"
        },
        {
          key: "callStarted",
          format: "sec"
        }
      ],
      o.servertime,
      o.servertimeoffset
    );
  }
  static mapQueueEvent(o) {
    var n;
    return ce(kt({}, o), {
      data: ce(kt({}, o.data), {
        Calls: (n = o.data.Calls) == null ? void 0 : n.map((s) => this.configureUTCForObject(
          s,
          [
            {
              key: "JoinTimeStamp",
              format: "sec"
            }
          ],
          o.servertime,
          o.servertimeoffset
        ))
      })
    });
  }
  static assignProperty(o, n, s) {
    o[n] = s;
  }
  /**
   * Configures UTC for the object
   *
   * @param data - object to configure UTC for
   * @param properties - properties of the object to configure UTC for
   * @param servertime - server time in seconds
   * @param servertimeoffset - server time offset in minutes
   * @private
   */
  static configureUTCForObject(o, n, s, c) {
    const f = (s - c * 60) * 1e3, g = Date.now() - f, y = {};
    return n.forEach((_) => {
      const p = o[_.key], m = _.key;
      if (p !== 0 && typeof p == "number" && !isNaN(p)) {
        let d = p;
        _.format === "ms" && (d = Math.floor(d / 1e3));
        const l = (d - c * 60) * 1e3;
        this.assignProperty(y, `${m}_UTC`, l), this.assignProperty(y, `${m}_UTC_CLIENT`, l + g);
      } else
        this.assignProperty(y, `${m}_UTC`, 0), this.assignProperty(y, `${m}_UTC_CLIENT`, 0);
    }), kt(kt({}, o), y);
  }
}
var mu = /* @__PURE__ */ ((r) => (r.UPDATE_MONITORED_EXTENSIONS = "updateMonitoredExtensions", r.KEEP_ALIVE = "keepAlive", r))(mu || {});
class Xg {
  constructor(o) {
    xt(this, "io"), xt(this, "ioFunction"), xt(this, "lastEventTimestamp", (/* @__PURE__ */ new Date()).getTime()), xt(this, "doReconnect", !0), xt(this, "keepAliveInterval"), xt(this, "keepReconnectInterval"), xt(this, "connected", !1), this.eventsSdkClass = o, this.eventsSdkClass = o;
  }
  getSocketIoFunction(o) {
    const n = o.split("v="), s = "v".concat(n[n.length - 1]).replaceAll(".", "_");
    this.ioFunction = Jg.getSocketVersion(s);
  }
  initSocketConnection() {
    const o = this.eventsSdkClass.authClass.token, n = this.eventsSdkClass.options.protocol, s = this.eventsSdkClass.server;
    try {
      const c = s ? s.Domain : this.eventsSdkClass.URL, f = s ? `${n}://${c}` : this.eventsSdkClass.URL;
      this.eventsSdkClass.eventEmitterClass.emit(
        lt.ONLINE_STATUS_EVENT,
        {
          isSocketConnected: !1,
          attemptToConnect: f,
          doReconnect: this.doReconnect
        }
      );
      const g = {
        reconnection: !1,
        upgrade: !1,
        transports: ["websocket"],
        forceNew: !0,
        query: {
          token: o
        },
        timeout: this.eventsSdkClass.options.timeout
      };
      if (o && (g.query = {
        token: o
      }), this.ioFunction && f)
        this.io = this.ioFunction(f, g);
      else
        throw new Error("Socket server url no defined");
    } catch (c) {
    }
  }
  clearKeepAliveInterval() {
    this.keepAliveInterval && clearInterval(this.keepAliveInterval);
  }
  initKeepAlive() {
    this.clearKeepAliveInterval(), this.keepAliveInterval = setInterval(() => Nt(this, null, function* () {
      if ((/* @__PURE__ */ new Date()).getTime() > this.lastEventTimestamp + this.eventsSdkClass.options.keepAliveTimeout && this.io && this.eventsSdkClass.authClass.token) {
        this.eventsSdkClass.emit(mu.KEEP_ALIVE, this.eventsSdkClass.authClass.token);
        return;
      }
    }), this.eventsSdkClass.options.keepAliveTimeout);
  }
  closeAllConnections() {
    var o;
    this.io && (this.io.close(), (o = this.io) == null || o.disconnect(), this.io = void 0), yr.clearSessionStorage();
  }
  initSocketEvents() {
    this.io && this.io.on(lt.LOGIN_SUCCESS, (o) => this.onLoginSuccessEvent(o)).on(lt.QUEUE_EVENT, (o) => this.onQueueEvent(o)).on(lt.EXTENSION_EVENT, (o) => this.onExtensionEvent(o)).on(lt.DIALER_EVENT, (o) => this.onDialerEvent(o)).on(lt.LOGIN_STATUS, (o) => this.onLoginStatusEvent(o)).on(lt.ALL_EXTENSION_STATUS, (o) => this.onAllExtensionStatus(o)).on(lt.ALL_DIALER_STATUS, (o) => this.onAllDialerStatus(o)).on(lt.KEEP_ALIVE_RESPONSE, (o) => this.onKeepAliveResponse(o)).on(lt.EXTENSIONS_UPDATED, (o) => this.onExtensionsUpdatedEvent(o)).on(lt.CONNECT, () => this.onConnect()).on(lt.DISCONNECT, (o) => this.onDisconnect(o)).on(lt.CONNECT_ERROR_EVENT, (o) => this.onConnectError(o));
  }
  onLoginSuccessEvent(o) {
    this.eventsSdkClass.eventEmitterClass.emit(lt.LOGIN_SUCCESS, o);
  }
  onQueueEvent(o) {
    this.eventsSdkClass.eventEmitterClass.emit(lt.QUEUE_EVENT, Ki.mapQueueEvent(o));
  }
  onExtensionEvent(o) {
    const n = Ki.mapExtensionEvent(o);
    n && this.eventsSdkClass.eventEmitterClass.emit(lt.EXTENSION_EVENT, n);
  }
  onDialerEvent(o) {
    this.eventsSdkClass.eventEmitterClass.emit(lt.DIALER_EVENT, o);
  }
  onLoginStatusEvent(o) {
    this.eventsSdkClass.eventEmitterClass.emit(lt.LOGIN_STATUS, o);
  }
  onAllExtensionStatus(o) {
    const n = Ki.mapAllExtensionStatus(o);
    this.eventsSdkClass.eventEmitterClass.emit(lt.ALL_EXTENSION_STATUS, n);
  }
  onAllDialerStatus(o) {
    this.eventsSdkClass.eventEmitterClass.emit(lt.ALL_DIALER_STATUS, o);
  }
  onKeepAliveResponse(o) {
    if (o.errorCode) {
      this.initSocketConnection();
      return;
    }
    this.connected ? this.lastEventTimestamp = (/* @__PURE__ */ new Date()).getTime() : this.initSocketConnection();
  }
  onExtensionsUpdatedEvent(o) {
    this.eventsSdkClass.eventEmitterClass.emit(lt.EXTENSIONS_UPDATED, o);
  }
  onConnect() {
    this.keepReconnectInterval && clearInterval(this.keepReconnectInterval), this.connected = !0, this.eventsSdkClass.eventEmitterClass.emit(lt.ONLINE_STATUS_EVENT, {
      isSocketConnected: !0,
      doReconnect: this.doReconnect
    });
  }
  onDisconnect(o) {
    this.connected = !1, this.closeAllConnections(), this.eventsSdkClass.eventEmitterClass.emit(lt.ONLINE_STATUS_EVENT, {
      isSocketConnected: !1,
      doReconnect: this.doReconnect
    }), this.doReconnect && this.eventsSdkClass.connect(wn.NEXT);
  }
  onConnectError(o) {
    this.eventsSdkClass.eventEmitterClass.emit(lt.ONLINE_STATUS_EVENT, {
      isSocketConnected: !1,
      doReconnect: this.doReconnect
    }), setTimeout(
      () => {
        this.eventsSdkClass.connect(wn.NEXT);
      },
      this.eventsSdkClass.options.reconnectionDelay
    );
  }
}
var vr = /* @__PURE__ */ ((r) => (r.INFO = "INFO", r.WARN = "WARN", r.ERROR = "ERROR", r))(vr || {}), Kg = Object.defineProperty, Hg = (r, o, n) => o in r ? Kg(r, o, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[o] = n, Mt = (r, o, n) => (Hg(r, typeof o != "symbol" ? o + "" : o, n), n);
function $g(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function Yg(r) {
  if (r.__esModule)
    return r;
  var o = r.default;
  if (typeof o == "function") {
    var n = function s() {
      return this instanceof s ? Reflect.construct(o, arguments, this.constructor) : o.apply(this, arguments);
    };
    n.prototype = o.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(r).forEach(function(s) {
    var c = Object.getOwnPropertyDescriptor(r, s);
    Object.defineProperty(n, s, c.get ? c : {
      enumerable: !0,
      get: function() {
        return r[s];
      }
    });
  }), n;
}
var es = { exports: {} }, Qg = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, Gg = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
], bu = function(r) {
  var o = r, n = r.indexOf("["), s = r.indexOf("]");
  n != -1 && s != -1 && (r = r.substring(0, n) + r.substring(n, s).replace(/:/g, ";") + r.substring(s, r.length));
  for (var c = Qg.exec(r || ""), f = {}, g = 14; g--; )
    f[Gg[g]] = c[g] || "";
  return n != -1 && s != -1 && (f.source = o, f.host = f.host.substring(1, f.host.length - 1).replace(/;/g, ":"), f.authority = f.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), f.ipv6uri = !0), f.pathNames = Zg(f, f.path), f.queryKey = tm(f, f.query), f;
};
function Zg(r, o) {
  var n = /\/{2,9}/g, s = o.replace(n, "/").split("/");
  return (o.substr(0, 1) == "/" || o.length === 0) && s.splice(0, 1), o.substr(o.length - 1, 1) == "/" && s.splice(s.length - 1, 1), s;
}
function tm(r, o) {
  var n = {};
  return o.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(s, c, f) {
    c && (n[c] = f);
  }), n;
}
var ns = { exports: {} }, rs = { exports: {} }, gr = 1e3, mr = gr * 60, br = mr * 60, _r = br * 24, em = _r * 365.25, nm = function(r, o) {
  o = o || {};
  var n = typeof r;
  if (n === "string" && r.length > 0)
    return rm(r);
  if (n === "number" && isNaN(r) === !1)
    return o.long ? im(r) : om(r);
  throw new Error(
    "val is not a non-empty string or a valid number. val=" + JSON.stringify(r)
  );
};
function rm(r) {
  if (r = String(r), !(r.length > 100)) {
    var o = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
      r
    );
    if (o) {
      var n = parseFloat(o[1]), s = (o[2] || "ms").toLowerCase();
      switch (s) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return n * em;
        case "days":
        case "day":
        case "d":
          return n * _r;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return n * br;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return n * mr;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return n * gr;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return n;
        default:
          return;
      }
    }
  }
}
function om(r) {
  return r >= _r ? Math.round(r / _r) + "d" : r >= br ? Math.round(r / br) + "h" : r >= mr ? Math.round(r / mr) + "m" : r >= gr ? Math.round(r / gr) + "s" : r + "ms";
}
function im(r) {
  return fo(r, _r, "day") || fo(r, br, "hour") || fo(r, mr, "minute") || fo(r, gr, "second") || r + " ms";
}
function fo(r, o, n) {
  if (!(r < o))
    return r < o * 1.5 ? Math.floor(r / o) + " " + n : Math.ceil(r / o) + " " + n + "s";
}
(function(r, o) {
  o = r.exports = s.debug = s.default = s, o.coerce = _, o.disable = g, o.enable = f, o.enabled = y, o.humanize = nm, o.instances = [], o.names = [], o.skips = [], o.formatters = {};
  function n(p) {
    var m = 0, d;
    for (d in p)
      m = (m << 5) - m + p.charCodeAt(d), m |= 0;
    return o.colors[Math.abs(m) % o.colors.length];
  }
  function s(p) {
    var m;
    function d() {
      if (d.enabled) {
        var l = d, u = +/* @__PURE__ */ new Date(), k = u - (m || u);
        l.diff = k, l.prev = m, l.curr = u, m = u;
        for (var C = new Array(arguments.length), S = 0; S < C.length; S++)
          C[S] = arguments[S];
        C[0] = o.coerce(C[0]), typeof C[0] != "string" && C.unshift("%O");
        var L = 0;
        C[0] = C[0].replace(/%([a-zA-Z%])/g, function(H, R) {
          if (H === "%%")
            return H;
          L++;
          var U = o.formatters[R];
          if (typeof U == "function") {
            var x = C[L];
            H = U.call(l, x), C.splice(L, 1), L--;
          }
          return H;
        }), o.formatArgs.call(l, C);
        var Y = d.log || o.log || console.log.bind(console);
        Y.apply(l, C);
      }
    }
    return d.namespace = p, d.enabled = o.enabled(p), d.useColors = o.useColors(), d.color = n(p), d.destroy = c, typeof o.init == "function" && o.init(d), o.instances.push(d), d;
  }
  function c() {
    var p = o.instances.indexOf(this);
    return p !== -1 ? (o.instances.splice(p, 1), !0) : !1;
  }
  function f(p) {
    o.save(p), o.names = [], o.skips = [];
    var m, d = (typeof p == "string" ? p : "").split(/[\s,]+/), l = d.length;
    for (m = 0; m < l; m++)
      d[m] && (p = d[m].replace(/\*/g, ".*?"), p[0] === "-" ? o.skips.push(new RegExp("^" + p.substr(1) + "$")) : o.names.push(new RegExp("^" + p + "$")));
    for (m = 0; m < o.instances.length; m++) {
      var u = o.instances[m];
      u.enabled = o.enabled(u.namespace);
    }
  }
  function g() {
    o.enable("");
  }
  function y(p) {
    if (p[p.length - 1] === "*")
      return !0;
    var m, d;
    for (m = 0, d = o.skips.length; m < d; m++)
      if (o.skips[m].test(p))
        return !1;
    for (m = 0, d = o.names.length; m < d; m++)
      if (o.names[m].test(p))
        return !0;
    return !1;
  }
  function _(p) {
    return p instanceof Error ? p.stack || p.message : p;
  }
})(rs, rs.exports);
var sm = rs.exports;
(function(r, o) {
  o = r.exports = sm, o.log = c, o.formatArgs = s, o.save = f, o.load = g, o.useColors = n, o.storage = typeof chrome < "u" && typeof chrome.storage < "u" ? chrome.storage.local : y(), o.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function n() {
    return typeof window < "u" && window.process && window.process.type === "renderer" ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  o.formatters.j = function(_) {
    try {
      return JSON.stringify(_);
    } catch (p) {
      return "[UnexpectedJSONParseError]: " + p.message;
    }
  };
  function s(_) {
    var p = this.useColors;
    if (_[0] = (p ? "%c" : "") + this.namespace + (p ? " %c" : " ") + _[0] + (p ? "%c " : " ") + "+" + o.humanize(this.diff), !!p) {
      var m = "color: " + this.color;
      _.splice(1, 0, m, "color: inherit");
      var d = 0, l = 0;
      _[0].replace(/%[a-zA-Z%]/g, function(u) {
        u !== "%%" && (d++, u === "%c" && (l = d));
      }), _.splice(l, 0, m);
    }
  }
  function c() {
    return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
  }
  function f(_) {
    try {
      _ == null ? o.storage.removeItem("debug") : o.storage.debug = _;
    } catch (p) {
    }
  }
  function g() {
    var _;
    try {
      _ = o.storage.debug;
    } catch (p) {
    }
    return !_ && typeof process < "u" && "env" in process && (_ = process.env.DEBUG), _;
  }
  o.enable(g());
  function y() {
    try {
      return window.localStorage;
    } catch (_) {
    }
  }
})(ns, ns.exports);
var Qe = ns.exports, am = bu, Gc = Qe("socket.io-client:url"), cm = um;
function um(r, o) {
  var n = r;
  o = o || typeof location < "u" && location, r == null && (r = o.protocol + "//" + o.host), typeof r == "string" && (r.charAt(0) === "/" && (r.charAt(1) === "/" ? r = o.protocol + r : r = o.host + r), /^(https?|wss?):\/\//.test(r) || (Gc("protocol-less url %s", r), typeof o < "u" ? r = o.protocol + "//" + r : r = "https://" + r), Gc("parse %s", r), n = am(r)), n.port || (/^(http|ws)$/.test(n.protocol) ? n.port = "80" : /^(http|ws)s$/.test(n.protocol) && (n.port = "443")), n.path = n.path || "/";
  var s = n.host.indexOf(":") !== -1, c = s ? "[" + n.host + "]" : n.host;
  return n.id = n.protocol + "://" + c + ":" + n.port, n.href = n.protocol + "://" + c + (o && o.port === n.port ? "" : ":" + n.port), n;
}
var wo = {}, _u = { exports: {} };
(function(r) {
  r.exports = o;
  function o(s) {
    if (s)
      return n(s);
  }
  function n(s) {
    for (var c in o.prototype)
      s[c] = o.prototype[c];
    return s;
  }
  o.prototype.on = o.prototype.addEventListener = function(s, c) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + s] = this._callbacks["$" + s] || []).push(c), this;
  }, o.prototype.once = function(s, c) {
    function f() {
      this.off(s, f), c.apply(this, arguments);
    }
    return f.fn = c, this.on(s, f), this;
  }, o.prototype.off = o.prototype.removeListener = o.prototype.removeAllListeners = o.prototype.removeEventListener = function(s, c) {
    if (this._callbacks = this._callbacks || {}, arguments.length == 0)
      return this._callbacks = {}, this;
    var f = this._callbacks["$" + s];
    if (!f)
      return this;
    if (arguments.length == 1)
      return delete this._callbacks["$" + s], this;
    for (var g, y = 0; y < f.length; y++)
      if (g = f[y], g === c || g.fn === c) {
        f.splice(y, 1);
        break;
      }
    return f.length === 0 && delete this._callbacks["$" + s], this;
  }, o.prototype.emit = function(s) {
    this._callbacks = this._callbacks || {};
    for (var c = new Array(arguments.length - 1), f = this._callbacks["$" + s], g = 1; g < arguments.length; g++)
      c[g - 1] = arguments[g];
    if (f) {
      f = f.slice(0);
      for (var g = 0, y = f.length; g < y; ++g)
        f[g].apply(this, c);
    }
    return this;
  }, o.prototype.listeners = function(s) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + s] || [];
  }, o.prototype.hasListeners = function(s) {
    return !!this.listeners(s).length;
  };
})(_u);
var zn = _u.exports, So = {}, fm = {}.toString, us = Array.isArray || function(r) {
  return fm.call(r) == "[object Array]";
}, ku = dm, hm = typeof Buffer == "function" && typeof Buffer.isBuffer == "function", lm = typeof ArrayBuffer == "function", pm = function(r) {
  return typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(r) : r.buffer instanceof ArrayBuffer;
};
function dm(r) {
  return hm && Buffer.isBuffer(r) || lm && (r instanceof ArrayBuffer || pm(r));
}
var fs = us, wu = ku, Su = Object.prototype.toString, ym = typeof Blob == "function" || typeof Blob < "u" && Su.call(Blob) === "[object BlobConstructor]", vm = typeof File == "function" || typeof File < "u" && Su.call(File) === "[object FileConstructor]";
So.deconstructPacket = function(r) {
  var o = [], n = r.data, s = r;
  return s.data = os(n, o), s.attachments = o.length, { packet: s, buffers: o };
};
function os(r, o) {
  if (!r)
    return r;
  if (wu(r)) {
    var n = { _placeholder: !0, num: o.length };
    return o.push(r), n;
  } else if (fs(r)) {
    for (var s = new Array(r.length), c = 0; c < r.length; c++)
      s[c] = os(r[c], o);
    return s;
  } else if (typeof r == "object" && !(r instanceof Date)) {
    var s = {};
    for (var f in r)
      s[f] = os(r[f], o);
    return s;
  }
  return r;
}
So.reconstructPacket = function(r, o) {
  return r.data = is(r.data, o), r.attachments = void 0, r;
};
function is(r, o) {
  if (!r)
    return r;
  if (r && r._placeholder === !0) {
    var n = typeof r.num == "number" && r.num >= 0 && r.num < o.length;
    if (n)
      return o[r.num];
    throw new Error("illegal attachments");
  } else if (fs(r))
    for (var s = 0; s < r.length; s++)
      r[s] = is(r[s], o);
  else if (typeof r == "object")
    for (var c in r)
      r[c] = is(r[c], o);
  return r;
}
So.removeBlobs = function(r, o) {
  function n(f, g, y) {
    if (!f)
      return f;
    if (ym && f instanceof Blob || vm && f instanceof File) {
      s++;
      var _ = new FileReader();
      _.onload = function() {
        y ? y[g] = this.result : c = this.result, --s || o(c);
      }, _.readAsArrayBuffer(f);
    } else if (fs(f))
      for (var p = 0; p < f.length; p++)
        n(f[p], p, f);
    else if (typeof f == "object" && !wu(f))
      for (var m in f)
        n(f[m], m, f);
  }
  var s = 0, c = r;
  n(c), s || o(c);
};
(function(r) {
  var o = Qe("socket.io-parser"), n = zn, s = So, c = us, f = ku;
  r.protocol = 4, r.types = [
    "CONNECT",
    "DISCONNECT",
    "EVENT",
    "ACK",
    "ERROR",
    "BINARY_EVENT",
    "BINARY_ACK"
  ], r.CONNECT = 0, r.DISCONNECT = 1, r.EVENT = 2, r.ACK = 3, r.ERROR = 4, r.BINARY_EVENT = 5, r.BINARY_ACK = 6, r.Encoder = g, r.Decoder = d;
  function g() {
  }
  var y = r.ERROR + '"encode error"';
  g.prototype.encode = function(S, L) {
    if (o("encoding packet %j", S), r.BINARY_EVENT === S.type || r.BINARY_ACK === S.type)
      m(S, L);
    else {
      var Y = _(S);
      L([Y]);
    }
  };
  function _(S) {
    var L = "" + S.type;
    if ((r.BINARY_EVENT === S.type || r.BINARY_ACK === S.type) && (L += S.attachments + "-"), S.nsp && S.nsp !== "/" && (L += S.nsp + ","), S.id != null && (L += S.id), S.data != null) {
      var Y = p(S.data);
      if (Y !== !1)
        L += Y;
      else
        return y;
    }
    return o("encoded %j as %s", S, L), L;
  }
  function p(S) {
    try {
      return JSON.stringify(S);
    } catch (L) {
      return !1;
    }
  }
  function m(S, L) {
    function Y(H) {
      var R = s.deconstructPacket(H), U = _(R.packet), x = R.buffers;
      x.unshift(U), L(x);
    }
    s.removeBlobs(S, Y);
  }
  function d() {
    this.reconstructor = null;
  }
  n(d.prototype), d.prototype.add = function(S) {
    var L;
    if (typeof S == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      L = l(S), r.BINARY_EVENT === L.type || r.BINARY_ACK === L.type ? (this.reconstructor = new k(L), this.reconstructor.reconPack.attachments === 0 && this.emit("decoded", L)) : this.emit("decoded", L);
    } else if (f(S) || S.base64)
      if (this.reconstructor)
        L = this.reconstructor.takeBinaryData(S), L && (this.reconstructor = null, this.emit("decoded", L));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + S);
  };
  function l(S) {
    var L = 0, Y = {
      type: Number(S.charAt(0))
    };
    if (r.types[Y.type] == null)
      return C("unknown packet type " + Y.type);
    if (r.BINARY_EVENT === Y.type || r.BINARY_ACK === Y.type) {
      for (var H = L + 1; S.charAt(++L) !== "-" && L != S.length; )
        ;
      var R = S.substring(H, L);
      if (R != Number(R) || S.charAt(L) !== "-")
        throw new Error("Illegal attachments");
      Y.attachments = Number(R);
    }
    if (S.charAt(L + 1) === "/") {
      for (var H = L + 1; ++L; ) {
        var U = S.charAt(L);
        if (U === "," || L === S.length)
          break;
      }
      Y.nsp = S.substring(H, L);
    } else
      Y.nsp = "/";
    var x = S.charAt(L + 1);
    if (x !== "" && Number(x) == x) {
      for (var H = L + 1; ++L; ) {
        var U = S.charAt(L);
        if (U == null || Number(U) != U) {
          --L;
          break;
        }
        if (L === S.length)
          break;
      }
      Y.id = Number(S.substring(H, L + 1));
    }
    if (S.charAt(++L)) {
      var B = u(S.substr(L)), D = B !== !1 && (Y.type === r.ERROR || c(B));
      if (D)
        Y.data = B;
      else
        return C("invalid payload");
    }
    return o("decoded %s as %j", S, Y), Y;
  }
  function u(S) {
    try {
      return JSON.parse(S);
    } catch (L) {
      return !1;
    }
  }
  d.prototype.destroy = function() {
    this.reconstructor && this.reconstructor.finishedReconstruction();
  };
  function k(S) {
    this.reconPack = S, this.buffers = [];
  }
  k.prototype.takeBinaryData = function(S) {
    if (this.buffers.push(S), this.buffers.length === this.reconPack.attachments) {
      var L = s.reconstructPacket(this.reconPack, this.buffers);
      return this.finishedReconstruction(), L;
    }
    return null;
  }, k.prototype.finishedReconstruction = function() {
    this.reconPack = null, this.buffers = [];
  };
  function C(S) {
    return {
      type: r.ERROR,
      data: "parser error: " + S
    };
  }
})(wo);
var hs = { exports: {} }, Eo = {}, ss = { exports: {} };
try {
  ss.exports = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch (r) {
  ss.exports = !1;
}
var gm = ss.exports, ls = function() {
  return typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")();
}(), mm = gm, bm = ls, ps = function(r) {
  var o = r.xdomain, n = r.xscheme, s = r.enablesXDR;
  try {
    if (typeof XMLHttpRequest < "u" && (!o || mm))
      return new XMLHttpRequest();
  } catch (c) {
  }
  try {
    if (typeof XDomainRequest < "u" && !n && s)
      return new XDomainRequest();
  } catch (c) {
  }
  if (!o)
    try {
      return new bm[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (c) {
    }
}, ds = { exports: {} }, Sn = {}, _m = Object.keys || function(r) {
  var o = [], n = Object.prototype.hasOwnProperty;
  for (var s in r)
    n.call(r, s) && o.push(s);
  return o;
}, km = us, Eu = Object.prototype.toString, wm = typeof Blob == "function" || typeof Blob < "u" && Eu.call(Blob) === "[object BlobConstructor]", Sm = typeof File == "function" || typeof File < "u" && Eu.call(File) === "[object FileConstructor]", Cu = vo;
function vo(r) {
  if (!r || typeof r != "object")
    return !1;
  if (km(r)) {
    for (var o = 0, n = r.length; o < n; o++)
      if (vo(r[o]))
        return !0;
    return !1;
  }
  if (typeof Buffer == "function" && Buffer.isBuffer && Buffer.isBuffer(r) || typeof ArrayBuffer == "function" && r instanceof ArrayBuffer || wm && r instanceof Blob || Sm && r instanceof File)
    return !0;
  if (r.toJSON && typeof r.toJSON == "function" && arguments.length === 1)
    return vo(r.toJSON(), !0);
  for (var s in r)
    if (Object.prototype.hasOwnProperty.call(r, s) && vo(r[s]))
      return !0;
  return !1;
}
var Em = function(r, o, n) {
  var s = r.byteLength;
  if (o = o || 0, n = n || s, r.slice)
    return r.slice(o, n);
  if (o < 0 && (o += s), n < 0 && (n += s), n > s && (n = s), o >= s || o >= n || s === 0)
    return new ArrayBuffer(0);
  for (var c = new Uint8Array(r), f = new Uint8Array(n - o), g = o, y = 0; g < n; g++, y++)
    f[y] = c[g];
  return f.buffer;
}, Cm = Am;
function Am(r, o, n) {
  var s = !1;
  return n = n || Tm, c.count = r, r === 0 ? o() : c;
  function c(f, g) {
    if (c.count <= 0)
      throw new Error("after called too many times");
    --c.count, f ? (s = !0, o(f), o = n) : c.count === 0 && !s && o(null, g);
  }
}
function Tm() {
}
/*! https://mths.be/utf8js v2.1.2 by @mathias */
var fn = String.fromCharCode;
function Au(r) {
  for (var o = [], n = 0, s = r.length, c, f; n < s; )
    c = r.charCodeAt(n++), c >= 55296 && c <= 56319 && n < s ? (f = r.charCodeAt(n++), (f & 64512) == 56320 ? o.push(((c & 1023) << 10) + (f & 1023) + 65536) : (o.push(c), n--)) : o.push(c);
  return o;
}
function xm(r) {
  for (var o = r.length, n = -1, s, c = ""; ++n < o; )
    s = r[n], s > 65535 && (s -= 65536, c += fn(s >>> 10 & 1023 | 55296), s = 56320 | s & 1023), c += fn(s);
  return c;
}
function Tu(r, o) {
  if (r >= 55296 && r <= 57343) {
    if (o)
      throw Error(
        "Lone surrogate U+" + r.toString(16).toUpperCase() + " is not a scalar value"
      );
    return !1;
  }
  return !0;
}
function Hi(r, o) {
  return fn(r >> o & 63 | 128);
}
function Om(r, o) {
  if (!(r & 4294967168))
    return fn(r);
  var n = "";
  return r & 4294965248 ? r & 4294901760 ? r & 4292870144 || (n = fn(r >> 18 & 7 | 240), n += Hi(r, 12), n += Hi(r, 6)) : (Tu(r, o) || (r = 65533), n = fn(r >> 12 & 15 | 224), n += Hi(r, 6)) : n = fn(r >> 6 & 31 | 192), n += fn(r & 63 | 128), n;
}
function Nm(r, o) {
  o = o || {};
  for (var n = o.strict !== !1, s = Au(r), c = s.length, f = -1, g, y = ""; ++f < c; )
    g = s[f], y += Om(g, n);
  return y;
}
function qn() {
  if (hn >= bo)
    throw Error("Invalid byte index");
  var r = mo[hn] & 255;
  if (hn++, (r & 192) == 128)
    return r & 63;
  throw Error("Invalid continuation byte");
}
function Bm(r) {
  var o, n, s, c, f;
  if (hn > bo)
    throw Error("Invalid byte index");
  if (hn == bo)
    return !1;
  if (o = mo[hn] & 255, hn++, !(o & 128))
    return o;
  if ((o & 224) == 192) {
    if (n = qn(), f = (o & 31) << 6 | n, f >= 128)
      return f;
    throw Error("Invalid continuation byte");
  }
  if ((o & 240) == 224) {
    if (n = qn(), s = qn(), f = (o & 15) << 12 | n << 6 | s, f >= 2048)
      return Tu(f, r) ? f : 65533;
    throw Error("Invalid continuation byte");
  }
  if ((o & 248) == 240 && (n = qn(), s = qn(), c = qn(), f = (o & 7) << 18 | n << 12 | s << 6 | c, f >= 65536 && f <= 1114111))
    return f;
  throw Error("Invalid UTF-8 detected");
}
var mo, bo, hn;
function Rm(r, o) {
  o = o || {};
  var n = o.strict !== !1;
  mo = Au(r), bo = mo.length, hn = 0;
  for (var s = [], c; (c = Bm(n)) !== !1; )
    s.push(c);
  return xm(s);
}
var Im = {
  version: "2.1.2",
  encode: Nm,
  decode: Rm
}, $i = {}, Zc;
function Lm() {
  return Zc || (Zc = 1, function(r) {
    $i.encode = function(o) {
      var n = new Uint8Array(o), s, c = n.length, f = "";
      for (s = 0; s < c; s += 3)
        f += r[n[s] >> 2], f += r[(n[s] & 3) << 4 | n[s + 1] >> 4], f += r[(n[s + 1] & 15) << 2 | n[s + 2] >> 6], f += r[n[s + 2] & 63];
      return c % 3 === 2 ? f = f.substring(0, f.length - 1) + "=" : c % 3 === 1 && (f = f.substring(0, f.length - 2) + "=="), f;
    }, $i.decode = function(o) {
      var n = o.length * 0.75, s = o.length, c, f = 0, g, y, _, p;
      o[o.length - 1] === "=" && (n--, o[o.length - 2] === "=" && n--);
      var m = new ArrayBuffer(n), d = new Uint8Array(m);
      for (c = 0; c < s; c += 4)
        g = r.indexOf(o[c]), y = r.indexOf(o[c + 1]), _ = r.indexOf(o[c + 2]), p = r.indexOf(o[c + 3]), d[f++] = g << 2 | y >> 4, d[f++] = (y & 15) << 4 | _ >> 2, d[f++] = (_ & 3) << 6 | p & 63;
      return m;
    };
  }("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/")), $i;
}
var Yi, tu;
function Um() {
  if (tu)
    return Yi;
  tu = 1;
  var r = typeof r < "u" ? r : typeof WebKitBlobBuilder < "u" ? WebKitBlobBuilder : typeof MSBlobBuilder < "u" ? MSBlobBuilder : typeof MozBlobBuilder < "u" ? MozBlobBuilder : !1, o = function() {
    try {
      var y = new Blob(["hi"]);
      return y.size === 2;
    } catch (_) {
      return !1;
    }
  }(), n = o && function() {
    try {
      var y = new Blob([new Uint8Array([1, 2])]);
      return y.size === 2;
    } catch (_) {
      return !1;
    }
  }(), s = r && r.prototype.append && r.prototype.getBlob;
  function c(y) {
    return y.map(function(_) {
      if (_.buffer instanceof ArrayBuffer) {
        var p = _.buffer;
        if (_.byteLength !== p.byteLength) {
          var m = new Uint8Array(_.byteLength);
          m.set(new Uint8Array(p, _.byteOffset, _.byteLength)), p = m.buffer;
        }
        return p;
      }
      return _;
    });
  }
  function f(y, _) {
    _ = _ || {};
    var p = new r();
    return c(y).forEach(function(m) {
      p.append(m);
    }), _.type ? p.getBlob(_.type) : p.getBlob();
  }
  function g(y, _) {
    return new Blob(c(y), _ || {});
  }
  return typeof Blob < "u" && (f.prototype = Blob.prototype, g.prototype = Blob.prototype), Yi = /* @__PURE__ */ function() {
    return o ? n ? Blob : g : s ? f : void 0;
  }(), Yi;
}
(function(r) {
  var o = _m, n = Cu, s = Em, c = Cm, f = Im, g;
  typeof ArrayBuffer < "u" && (g = Lm());
  var y = typeof navigator < "u" && /Android/i.test(navigator.userAgent), _ = typeof navigator < "u" && /PhantomJS/i.test(navigator.userAgent), p = y || _;
  r.protocol = 3;
  var m = r.packets = {
    open: 0,
    close: 1,
    ping: 2,
    pong: 3,
    message: 4,
    upgrade: 5,
    noop: 6
  }, d = o(m), l = { type: "error", data: "parser error" }, u = Um();
  r.encodePacket = function(R, U, x, B) {
    typeof U == "function" && (B = U, U = !1), typeof x == "function" && (B = x, x = null);
    var D = R.data === void 0 ? void 0 : R.data.buffer || R.data;
    if (typeof ArrayBuffer < "u" && D instanceof ArrayBuffer)
      return C(R, U, B);
    if (typeof u < "u" && D instanceof u)
      return L(R, U, B);
    if (D && D.base64)
      return k(R, B);
    var O = m[R.type];
    return R.data !== void 0 && (O += x ? f.encode(String(R.data), { strict: !1 }) : String(R.data)), B("" + O);
  };
  function k(R, U) {
    var x = "b" + r.packets[R.type] + R.data.data;
    return U(x);
  }
  function C(R, U, x) {
    if (!U)
      return r.encodeBase64Packet(R, x);
    var B = R.data, D = new Uint8Array(B), O = new Uint8Array(1 + B.byteLength);
    O[0] = m[R.type];
    for (var I = 0; I < D.length; I++)
      O[I + 1] = D[I];
    return x(O.buffer);
  }
  function S(R, U, x) {
    if (!U)
      return r.encodeBase64Packet(R, x);
    var B = new FileReader();
    return B.onload = function() {
      r.encodePacket({ type: R.type, data: B.result }, U, !0, x);
    }, B.readAsArrayBuffer(R.data);
  }
  function L(R, U, x) {
    if (!U)
      return r.encodeBase64Packet(R, x);
    if (p)
      return S(R, U, x);
    var B = new Uint8Array(1);
    B[0] = m[R.type];
    var D = new u([B.buffer, R.data]);
    return x(D);
  }
  r.encodeBase64Packet = function(R, U) {
    var x = "b" + r.packets[R.type];
    if (typeof u < "u" && R.data instanceof u) {
      var B = new FileReader();
      return B.onload = function() {
        var z = B.result.split(",")[1];
        U(x + z);
      }, B.readAsDataURL(R.data);
    }
    var D;
    try {
      D = String.fromCharCode.apply(null, new Uint8Array(R.data));
    } catch (z) {
      for (var O = new Uint8Array(R.data), I = new Array(O.length), W = 0; W < O.length; W++)
        I[W] = O[W];
      D = String.fromCharCode.apply(null, I);
    }
    return x += btoa(D), U(x);
  }, r.decodePacket = function(R, U, x) {
    if (R === void 0)
      return l;
    if (typeof R == "string") {
      if (R.charAt(0) === "b")
        return r.decodeBase64Packet(R.substr(1), U);
      if (x && (R = Y(R), R === !1))
        return l;
      var D = R.charAt(0);
      return Number(D) != D || !d[D] ? l : R.length > 1 ? { type: d[D], data: R.substring(1) } : { type: d[D] };
    }
    var B = new Uint8Array(R), D = B[0], O = s(R, 1);
    return u && U === "blob" && (O = new u([O])), { type: d[D], data: O };
  };
  function Y(R) {
    try {
      R = f.decode(R, { strict: !1 });
    } catch (U) {
      return !1;
    }
    return R;
  }
  r.decodeBase64Packet = function(R, U) {
    var x = d[R.charAt(0)];
    if (!g)
      return { type: x, data: { base64: !0, data: R.substr(1) } };
    var B = g.decode(R.substr(1));
    return U === "blob" && u && (B = new u([B])), { type: x, data: B };
  }, r.encodePayload = function(R, U, x) {
    typeof U == "function" && (x = U, U = null);
    var B = n(R);
    if (U && B)
      return u && !p ? r.encodePayloadAsBlob(R, x) : r.encodePayloadAsArrayBuffer(R, x);
    if (!R.length)
      return x("0:");
    function D(I) {
      return I.length + ":" + I;
    }
    function O(I, W) {
      r.encodePacket(I, B ? U : !1, !1, function(z) {
        W(null, D(z));
      });
    }
    H(R, O, function(I, W) {
      return x(W.join(""));
    });
  };
  function H(R, U, x) {
    for (var B = new Array(R.length), D = c(R.length, x), O = function(W, z, X) {
      U(z, function(P, pt) {
        B[W] = pt, X(P, B);
      });
    }, I = 0; I < R.length; I++)
      O(I, R[I], D);
  }
  r.decodePayload = function(R, U, x) {
    if (typeof R != "string")
      return r.decodePayloadAsBinary(R, U, x);
    typeof U == "function" && (x = U, U = null);
    var B;
    if (R === "")
      return x(l, 0, 1);
    for (var D = "", O, I, W = 0, z = R.length; W < z; W++) {
      var X = R.charAt(W);
      if (X !== ":") {
        D += X;
        continue;
      }
      if (D === "" || D != (O = Number(D)) || (I = R.substr(W + 1, O), D != I.length))
        return x(l, 0, 1);
      if (I.length) {
        if (B = r.decodePacket(I, U, !1), l.type === B.type && l.data === B.data)
          return x(l, 0, 1);
        var P = x(B, W + O, z);
        if (P === !1)
          return;
      }
      W += O, D = "";
    }
    if (D !== "")
      return x(l, 0, 1);
  }, r.encodePayloadAsArrayBuffer = function(R, U) {
    if (!R.length)
      return U(new ArrayBuffer(0));
    function x(B, D) {
      r.encodePacket(B, !0, !0, function(O) {
        return D(null, O);
      });
    }
    H(R, x, function(B, D) {
      var O = D.reduce(function(z, X) {
        var P;
        return typeof X == "string" ? P = X.length : P = X.byteLength, z + P.toString().length + P + 2;
      }, 0), I = new Uint8Array(O), W = 0;
      return D.forEach(function(z) {
        var X = typeof z == "string", P = z;
        if (X) {
          for (var pt = new Uint8Array(z.length), ct = 0; ct < z.length; ct++)
            pt[ct] = z.charCodeAt(ct);
          P = pt.buffer;
        }
        X ? I[W++] = 0 : I[W++] = 1;
        for (var At = P.byteLength.toString(), ct = 0; ct < At.length; ct++)
          I[W++] = parseInt(At[ct]);
        I[W++] = 255;
        for (var pt = new Uint8Array(P), ct = 0; ct < pt.length; ct++)
          I[W++] = pt[ct];
      }), U(I.buffer);
    });
  }, r.encodePayloadAsBlob = function(R, U) {
    function x(B, D) {
      r.encodePacket(B, !0, !0, function(O) {
        var I = new Uint8Array(1);
        if (I[0] = 1, typeof O == "string") {
          for (var W = new Uint8Array(O.length), z = 0; z < O.length; z++)
            W[z] = O.charCodeAt(z);
          O = W.buffer, I[0] = 0;
        }
        for (var X = O instanceof ArrayBuffer ? O.byteLength : O.size, P = X.toString(), pt = new Uint8Array(P.length + 1), z = 0; z < P.length; z++)
          pt[z] = parseInt(P[z]);
        if (pt[P.length] = 255, u) {
          var ct = new u([I.buffer, pt.buffer, O]);
          D(null, ct);
        }
      });
    }
    H(R, x, function(B, D) {
      return U(new u(D));
    });
  }, r.decodePayloadAsBinary = function(R, U, x) {
    typeof U == "function" && (x = U, U = null);
    for (var B = R, D = []; B.byteLength > 0; ) {
      for (var O = new Uint8Array(B), I = O[0] === 0, W = "", z = 1; O[z] !== 255; z++) {
        if (W.length > 310)
          return x(l, 0, 1);
        W += O[z];
      }
      B = s(B, 2 + W.length), W = parseInt(W);
      var X = s(B, 0, W);
      if (I)
        try {
          X = String.fromCharCode.apply(null, new Uint8Array(X));
        } catch (ct) {
          var P = new Uint8Array(X);
          X = "";
          for (var z = 0; z < P.length; z++)
            X += String.fromCharCode(P[z]);
        }
      D.push(X), B = s(B, W);
    }
    var pt = D.length;
    D.forEach(function(ct, At) {
      x(r.decodePacket(ct, U, !0), At, pt);
    });
  };
})(Sn);
var Qi, eu;
function ys() {
  if (eu)
    return Qi;
  eu = 1;
  var r = Sn, o = zn;
  Qi = n;
  function n(s) {
    this.path = s.path, this.hostname = s.hostname, this.port = s.port, this.secure = s.secure, this.query = s.query, this.timestampParam = s.timestampParam, this.timestampRequests = s.timestampRequests, this.readyState = "", this.agent = s.agent || !1, this.socket = s.socket, this.enablesXDR = s.enablesXDR, this.withCredentials = s.withCredentials, this.pfx = s.pfx, this.key = s.key, this.passphrase = s.passphrase, this.cert = s.cert, this.ca = s.ca, this.ciphers = s.ciphers, this.rejectUnauthorized = s.rejectUnauthorized, this.forceNode = s.forceNode, this.isReactNative = s.isReactNative, this.extraHeaders = s.extraHeaders, this.localAddress = s.localAddress;
  }
  return o(n.prototype), n.prototype.onError = function(s, c) {
    var f = new Error(s);
    return f.type = "TransportError", f.description = c, this.emit("error", f), this;
  }, n.prototype.open = function() {
    return (this.readyState === "closed" || this.readyState === "") && (this.readyState = "opening", this.doOpen()), this;
  }, n.prototype.close = function() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }, n.prototype.send = function(s) {
    if (this.readyState === "open")
      this.write(s);
    else
      throw new Error("Transport not open");
  }, n.prototype.onOpen = function() {
    this.readyState = "open", this.writable = !0, this.emit("open");
  }, n.prototype.onData = function(s) {
    var c = r.decodePacket(s, this.socket.binaryType);
    this.onPacket(c);
  }, n.prototype.onPacket = function(s) {
    this.emit("packet", s);
  }, n.prototype.onClose = function() {
    this.readyState = "closed", this.emit("close");
  }, Qi;
}
var Vn = {};
Vn.encode = function(r) {
  var o = "";
  for (var n in r)
    r.hasOwnProperty(n) && (o.length && (o += "&"), o += encodeURIComponent(n) + "=" + encodeURIComponent(r[n]));
  return o;
};
Vn.decode = function(r) {
  for (var o = {}, n = r.split("&"), s = 0, c = n.length; s < c; s++) {
    var f = n[s].split("=");
    o[decodeURIComponent(f[0])] = decodeURIComponent(f[1]);
  }
  return o;
};
var Co = function(r, o) {
  var n = function() {
  };
  n.prototype = o.prototype, r.prototype = new n(), r.prototype.constructor = r;
}, xu = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), _o = 64, Ou = {}, nu = 0, ln = 0, ru;
function as(r) {
  var o = "";
  do
    o = xu[r % _o] + o, r = Math.floor(r / _o);
  while (r > 0);
  return o;
}
function jm(r) {
  var o = 0;
  for (ln = 0; ln < r.length; ln++)
    o = o * _o + Ou[r.charAt(ln)];
  return o;
}
function vs() {
  var r = as(+/* @__PURE__ */ new Date());
  return r !== ru ? (nu = 0, ru = r) : r + "." + as(nu++);
}
for (; ln < _o; ln++)
  Ou[xu[ln]] = ln;
vs.encode = as;
vs.decode = jm;
var Nu = vs, Bu = ys(), Dm = Vn, Ru = Sn, Pm = Co, Mm = Nu, Re = Qe("engine.io-client:polling"), Iu = Me, qm = function() {
  var r = ps, o = new r({ xdomain: !1 });
  return o.responseType != null;
}();
function Me(r) {
  var o = r && r.forceBase64;
  (!qm || o) && (this.supportsBinary = !1), Bu.call(this, r);
}
Pm(Me, Bu);
Me.prototype.name = "polling";
Me.prototype.doOpen = function() {
  this.poll();
};
Me.prototype.pause = function(r) {
  var o = this;
  this.readyState = "pausing";
  function n() {
    Re("paused"), o.readyState = "paused", r();
  }
  if (this.polling || !this.writable) {
    var s = 0;
    this.polling && (Re("we are currently polling - waiting to pause"), s++, this.once("pollComplete", function() {
      Re("pre-pause polling complete"), --s || n();
    })), this.writable || (Re("we are currently writing - waiting to pause"), s++, this.once("drain", function() {
      Re("pre-pause writing complete"), --s || n();
    }));
  } else
    n();
};
Me.prototype.poll = function() {
  Re("polling"), this.polling = !0, this.doPoll(), this.emit("poll");
};
Me.prototype.onData = function(r) {
  var o = this;
  Re("polling got data %s", r);
  var n = function(s, c, f) {
    if (o.readyState === "opening" && s.type === "open" && o.onOpen(), s.type === "close")
      return o.onClose(), !1;
    o.onPacket(s);
  };
  Ru.decodePayload(r, this.socket.binaryType, n), this.readyState !== "closed" && (this.polling = !1, this.emit("pollComplete"), this.readyState === "open" ? this.poll() : Re('ignoring poll - transport state "%s"', this.readyState));
};
Me.prototype.doClose = function() {
  var r = this;
  function o() {
    Re("writing close packet"), r.write([{ type: "close" }]);
  }
  this.readyState === "open" ? (Re("transport open - closing"), o()) : (Re("transport not open - deferring close"), this.once("open", o));
};
Me.prototype.write = function(r) {
  var o = this;
  this.writable = !1;
  var n = function() {
    o.writable = !0, o.emit("drain");
  };
  Ru.encodePayload(r, this.supportsBinary, function(s) {
    o.doWrite(s, n);
  });
};
Me.prototype.uri = function() {
  var r = this.query || {}, o = this.secure ? "https" : "http", n = "";
  this.timestampRequests !== !1 && (r[this.timestampParam] = Mm()), !this.supportsBinary && !r.sid && (r.b64 = 1), r = Dm.encode(r), this.port && (o === "https" && Number(this.port) !== 443 || o === "http" && Number(this.port) !== 80) && (n = ":" + this.port), r.length && (r = "?" + r);
  var s = this.hostname.indexOf(":") !== -1;
  return o + "://" + (s ? "[" + this.hostname + "]" : this.hostname) + n + this.path + r;
};
var Fm = ps, Lu = Iu, Wm = zn, zm = Co, cs = Qe("engine.io-client:polling-xhr"), Vm = ls;
ds.exports = Jn;
ds.exports.Request = zt;
function ou() {
}
function Jn(r) {
  if (Lu.call(this, r), this.requestTimeout = r.requestTimeout, this.extraHeaders = r.extraHeaders, typeof location < "u") {
    var o = location.protocol === "https:", n = location.port;
    n || (n = o ? 443 : 80), this.xd = typeof location < "u" && r.hostname !== location.hostname || n !== r.port, this.xs = r.secure !== o;
  }
}
zm(Jn, Lu);
Jn.prototype.supportsBinary = !0;
Jn.prototype.request = function(r) {
  return r = r || {}, r.uri = this.uri(), r.xd = this.xd, r.xs = this.xs, r.agent = this.agent || !1, r.supportsBinary = this.supportsBinary, r.enablesXDR = this.enablesXDR, r.withCredentials = this.withCredentials, r.pfx = this.pfx, r.key = this.key, r.passphrase = this.passphrase, r.cert = this.cert, r.ca = this.ca, r.ciphers = this.ciphers, r.rejectUnauthorized = this.rejectUnauthorized, r.requestTimeout = this.requestTimeout, r.extraHeaders = this.extraHeaders, new zt(r);
};
Jn.prototype.doWrite = function(r, o) {
  var n = typeof r != "string" && r !== void 0, s = this.request({ method: "POST", data: r, isBinary: n }), c = this;
  s.on("success", o), s.on("error", function(f) {
    c.onError("xhr post error", f);
  }), this.sendXhr = s;
};
Jn.prototype.doPoll = function() {
  cs("xhr poll");
  var r = this.request(), o = this;
  r.on("data", function(n) {
    o.onData(n);
  }), r.on("error", function(n) {
    o.onError("xhr poll error", n);
  }), this.pollXhr = r;
};
function zt(r) {
  this.method = r.method || "GET", this.uri = r.uri, this.xd = !!r.xd, this.xs = !!r.xs, this.async = r.async !== !1, this.data = r.data !== void 0 ? r.data : null, this.agent = r.agent, this.isBinary = r.isBinary, this.supportsBinary = r.supportsBinary, this.enablesXDR = r.enablesXDR, this.withCredentials = r.withCredentials, this.requestTimeout = r.requestTimeout, this.pfx = r.pfx, this.key = r.key, this.passphrase = r.passphrase, this.cert = r.cert, this.ca = r.ca, this.ciphers = r.ciphers, this.rejectUnauthorized = r.rejectUnauthorized, this.extraHeaders = r.extraHeaders, this.create();
}
Wm(zt.prototype);
zt.prototype.create = function() {
  var r = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
  r.pfx = this.pfx, r.key = this.key, r.passphrase = this.passphrase, r.cert = this.cert, r.ca = this.ca, r.ciphers = this.ciphers, r.rejectUnauthorized = this.rejectUnauthorized;
  var o = this.xhr = new Fm(r), n = this;
  try {
    cs("xhr open %s: %s", this.method, this.uri), o.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        o.setDisableHeaderCheck && o.setDisableHeaderCheck(!0);
        for (var s in this.extraHeaders)
          this.extraHeaders.hasOwnProperty(s) && o.setRequestHeader(s, this.extraHeaders[s]);
      }
    } catch (c) {
    }
    if (this.method === "POST")
      try {
        this.isBinary ? o.setRequestHeader("Content-type", "application/octet-stream") : o.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
      } catch (c) {
      }
    try {
      o.setRequestHeader("Accept", "*/*");
    } catch (c) {
    }
    "withCredentials" in o && (o.withCredentials = this.withCredentials), this.requestTimeout && (o.timeout = this.requestTimeout), this.hasXDR() ? (o.onload = function() {
      n.onLoad();
    }, o.onerror = function() {
      n.onError(o.responseText);
    }) : o.onreadystatechange = function() {
      if (o.readyState === 2)
        try {
          var c = o.getResponseHeader("Content-Type");
          (n.supportsBinary && c === "application/octet-stream" || c === "application/octet-stream; charset=UTF-8") && (o.responseType = "arraybuffer");
        } catch (f) {
        }
      o.readyState === 4 && (o.status === 200 || o.status === 1223 ? n.onLoad() : setTimeout(function() {
        n.onError(typeof o.status == "number" ? o.status : 0);
      }, 0));
    }, cs("xhr data %s", this.data), o.send(this.data);
  } catch (c) {
    setTimeout(function() {
      n.onError(c);
    }, 0);
    return;
  }
  typeof document < "u" && (this.index = zt.requestsCount++, zt.requests[this.index] = this);
};
zt.prototype.onSuccess = function() {
  this.emit("success"), this.cleanup();
};
zt.prototype.onData = function(r) {
  this.emit("data", r), this.onSuccess();
};
zt.prototype.onError = function(r) {
  this.emit("error", r), this.cleanup(!0);
};
zt.prototype.cleanup = function(r) {
  if (!(typeof this.xhr > "u" || this.xhr === null)) {
    if (this.hasXDR() ? this.xhr.onload = this.xhr.onerror = ou : this.xhr.onreadystatechange = ou, r)
      try {
        this.xhr.abort();
      } catch (o) {
      }
    typeof document < "u" && delete zt.requests[this.index], this.xhr = null;
  }
};
zt.prototype.onLoad = function() {
  var r;
  try {
    var o;
    try {
      o = this.xhr.getResponseHeader("Content-Type");
    } catch (n) {
    }
    o === "application/octet-stream" || o === "application/octet-stream; charset=UTF-8" ? r = this.xhr.response || this.xhr.responseText : r = this.xhr.responseText;
  } catch (n) {
    this.onError(n);
  }
  r != null && this.onData(r);
};
zt.prototype.hasXDR = function() {
  return typeof XDomainRequest < "u" && !this.xs && this.enablesXDR;
};
zt.prototype.abort = function() {
  this.cleanup();
};
zt.requestsCount = 0;
zt.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", iu);
  else if (typeof addEventListener == "function") {
    var Jm = "onpagehide" in Vm ? "pagehide" : "unload";
    addEventListener(Jm, iu, !1);
  }
}
function iu() {
  for (var r in zt.requests)
    zt.requests.hasOwnProperty(r) && zt.requests[r].abort();
}
var Xm = ds.exports, gs = Iu, Km = Co, su = ls, Hm = Xn, $m = /\n/g, Ym = /\\n/g, ho;
function Qm() {
}
function Xn(r) {
  gs.call(this, r), this.query = this.query || {}, ho || (ho = su.___eio = su.___eio || []), this.index = ho.length;
  var o = this;
  ho.push(function(n) {
    o.onData(n);
  }), this.query.j = this.index, typeof addEventListener == "function" && addEventListener("beforeunload", function() {
    o.script && (o.script.onerror = Qm);
  }, !1);
}
Km(Xn, gs);
Xn.prototype.supportsBinary = !1;
Xn.prototype.doClose = function() {
  this.script && (this.script.parentNode.removeChild(this.script), this.script = null), this.form && (this.form.parentNode.removeChild(this.form), this.form = null, this.iframe = null), gs.prototype.doClose.call(this);
};
Xn.prototype.doPoll = function() {
  var r = this, o = document.createElement("script");
  this.script && (this.script.parentNode.removeChild(this.script), this.script = null), o.async = !0, o.src = this.uri(), o.onerror = function(c) {
    r.onError("jsonp poll error", c);
  };
  var n = document.getElementsByTagName("script")[0];
  n ? n.parentNode.insertBefore(o, n) : (document.head || document.body).appendChild(o), this.script = o;
  var s = typeof navigator < "u" && /gecko/i.test(navigator.userAgent);
  s && setTimeout(function() {
    var c = document.createElement("iframe");
    document.body.appendChild(c), document.body.removeChild(c);
  }, 100);
};
Xn.prototype.doWrite = function(r, o) {
  var n = this;
  if (!this.form) {
    var s = document.createElement("form"), c = document.createElement("textarea"), f = this.iframeId = "eio_iframe_" + this.index, g;
    s.className = "socketio", s.style.position = "absolute", s.style.top = "-1000px", s.style.left = "-1000px", s.target = f, s.method = "POST", s.setAttribute("accept-charset", "utf-8"), c.name = "d", s.appendChild(c), document.body.appendChild(s), this.form = s, this.area = c;
  }
  this.form.action = this.uri();
  function y() {
    _(), o();
  }
  function _() {
    if (n.iframe)
      try {
        n.form.removeChild(n.iframe);
      } catch (m) {
        n.onError("jsonp polling iframe removal error", m);
      }
    try {
      var p = '<iframe src="javascript:0" name="' + n.iframeId + '">';
      g = document.createElement(p);
    } catch (m) {
      g = document.createElement("iframe"), g.name = n.iframeId, g.src = "javascript:0";
    }
    g.id = n.iframeId, n.form.appendChild(g), n.iframe = g;
  }
  _(), r = r.replace(Ym, `\\
`), this.area.value = r.replace($m, "\\n");
  try {
    this.form.submit();
  } catch (p) {
  }
  this.iframe.attachEvent ? this.iframe.onreadystatechange = function() {
    n.iframe.readyState === "complete" && y();
  } : this.iframe.onload = y;
};
const Gm = {}, Zm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gm
}, Symbol.toStringTag, { value: "Module" })), t0 = /* @__PURE__ */ Yg(Zm);
var ms = ys(), e0 = Sn, n0 = Vn, r0 = Co, o0 = Nu, i0 = Qe("engine.io-client:websocket"), ko, bs;
typeof WebSocket < "u" ? ko = WebSocket : typeof self < "u" && (ko = self.WebSocket || self.MozWebSocket);
if (typeof window > "u")
  try {
    bs = t0;
  } catch (r) {
  }
var Wn = ko || bs, s0 = Ae;
function Ae(r) {
  var o = r && r.forceBase64;
  o && (this.supportsBinary = !1), this.perMessageDeflate = r.perMessageDeflate, this.usingBrowserWebSocket = ko && !r.forceNode, this.protocols = r.protocols, this.usingBrowserWebSocket || (Wn = bs), ms.call(this, r);
}
r0(Ae, ms);
Ae.prototype.name = "websocket";
Ae.prototype.supportsBinary = !0;
Ae.prototype.doOpen = function() {
  if (this.check()) {
    var r = this.uri(), o = this.protocols, n = {};
    this.isReactNative || (n.agent = this.agent, n.perMessageDeflate = this.perMessageDeflate, n.pfx = this.pfx, n.key = this.key, n.passphrase = this.passphrase, n.cert = this.cert, n.ca = this.ca, n.ciphers = this.ciphers, n.rejectUnauthorized = this.rejectUnauthorized), this.extraHeaders && (n.headers = this.extraHeaders), this.localAddress && (n.localAddress = this.localAddress);
    try {
      this.ws = this.usingBrowserWebSocket && !this.isReactNative ? o ? new Wn(r, o) : new Wn(r) : new Wn(r, o, n);
    } catch (s) {
      return this.emit("error", s);
    }
    this.ws.binaryType === void 0 && (this.supportsBinary = !1), this.ws.supports && this.ws.supports.binary ? (this.supportsBinary = !0, this.ws.binaryType = "nodebuffer") : this.ws.binaryType = "arraybuffer", this.addEventListeners();
  }
};
Ae.prototype.addEventListeners = function() {
  var r = this;
  this.ws.onopen = function() {
    r.onOpen();
  }, this.ws.onclose = function() {
    r.onClose();
  }, this.ws.onmessage = function(o) {
    r.onData(o.data);
  }, this.ws.onerror = function(o) {
    r.onError("websocket error", o);
  };
};
Ae.prototype.write = function(r) {
  var o = this;
  this.writable = !1;
  for (var n = r.length, s = 0, c = n; s < c; s++)
    (function(g) {
      e0.encodePacket(g, o.supportsBinary, function(y) {
        if (!o.usingBrowserWebSocket) {
          var _ = {};
          if (g.options && (_.compress = g.options.compress), o.perMessageDeflate) {
            var p = typeof y == "string" ? Buffer.byteLength(y) : y.length;
            p < o.perMessageDeflate.threshold && (_.compress = !1);
          }
        }
        try {
          o.usingBrowserWebSocket ? o.ws.send(y) : o.ws.send(y, _);
        } catch (m) {
          i0("websocket closed before onclose event");
        }
        --n || f();
      });
    })(r[s]);
  function f() {
    o.emit("flush"), setTimeout(function() {
      o.writable = !0, o.emit("drain");
    }, 0);
  }
};
Ae.prototype.onClose = function() {
  ms.prototype.onClose.call(this);
};
Ae.prototype.doClose = function() {
  typeof this.ws < "u" && this.ws.close();
};
Ae.prototype.uri = function() {
  var r = this.query || {}, o = this.secure ? "wss" : "ws", n = "";
  this.port && (o === "wss" && Number(this.port) !== 443 || o === "ws" && Number(this.port) !== 80) && (n = ":" + this.port), this.timestampRequests && (r[this.timestampParam] = o0()), this.supportsBinary || (r.b64 = 1), r = n0.encode(r), r.length && (r = "?" + r);
  var s = this.hostname.indexOf(":") !== -1;
  return o + "://" + (s ? "[" + this.hostname + "]" : this.hostname) + n + this.path + r;
};
Ae.prototype.check = function() {
  return !!Wn && !("__initialize" in Wn && this.name === Ae.prototype.name);
};
var a0 = ps, c0 = Xm, u0 = Hm, f0 = s0;
Eo.polling = h0;
Eo.websocket = f0;
function h0(r) {
  var o, n = !1, s = !1, c = r.jsonp !== !1;
  if (typeof location < "u") {
    var f = location.protocol === "https:", g = location.port;
    g || (g = f ? 443 : 80), n = r.hostname !== location.hostname || g !== r.port, s = r.secure !== f;
  }
  if (r.xdomain = n, r.xscheme = s, o = new a0(r), "open" in o && !r.forceJSONP)
    return new c0(r);
  if (!c)
    throw new Error("JSONP disabled");
  return new u0(r);
}
var l0 = [].indexOf, Uu = function(r, o) {
  if (l0)
    return r.indexOf(o);
  for (var n = 0; n < r.length; ++n)
    if (r[n] === o)
      return n;
  return -1;
}, p0 = Eo, d0 = zn, qt = Qe("engine.io-client:socket"), y0 = Uu, ju = Sn, au = bu, v0 = Vn, g0 = _t;
function _t(r, o) {
  if (!(this instanceof _t))
    return new _t(r, o);
  o = o || {}, r && typeof r == "object" && (o = r, r = null), r ? (r = au(r), o.hostname = r.host, o.secure = r.protocol === "https" || r.protocol === "wss", o.port = r.port, r.query && (o.query = r.query)) : o.host && (o.hostname = au(o.host).host), this.secure = o.secure != null ? o.secure : typeof location < "u" && location.protocol === "https:", o.hostname && !o.port && (o.port = this.secure ? "443" : "80"), this.agent = o.agent || !1, this.hostname = o.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = o.port || (typeof location < "u" && location.port ? location.port : this.secure ? 443 : 80), this.query = o.query || {}, typeof this.query == "string" && (this.query = v0.decode(this.query)), this.upgrade = o.upgrade !== !1, this.path = (o.path || "/engine.io").replace(/\/$/, "") + "/", this.forceJSONP = !!o.forceJSONP, this.jsonp = o.jsonp !== !1, this.forceBase64 = !!o.forceBase64, this.enablesXDR = !!o.enablesXDR, this.withCredentials = o.withCredentials !== !1, this.timestampParam = o.timestampParam || "t", this.timestampRequests = o.timestampRequests, this.transports = o.transports || ["polling", "websocket"], this.transportOptions = o.transportOptions || {}, this.readyState = "", this.writeBuffer = [], this.prevBufferLen = 0, this.policyPort = o.policyPort || 843, this.rememberUpgrade = o.rememberUpgrade || !1, this.binaryType = null, this.onlyBinaryUpgrades = o.onlyBinaryUpgrades, this.perMessageDeflate = o.perMessageDeflate !== !1 ? o.perMessageDeflate || {} : !1, this.perMessageDeflate === !0 && (this.perMessageDeflate = {}), this.perMessageDeflate && this.perMessageDeflate.threshold == null && (this.perMessageDeflate.threshold = 1024), this.pfx = o.pfx || void 0, this.key = o.key || void 0, this.passphrase = o.passphrase || void 0, this.cert = o.cert || void 0, this.ca = o.ca || void 0, this.ciphers = o.ciphers || void 0, this.rejectUnauthorized = o.rejectUnauthorized === void 0 ? !0 : o.rejectUnauthorized, this.forceNode = !!o.forceNode, this.isReactNative = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative", (typeof self > "u" || this.isReactNative) && (o.extraHeaders && Object.keys(o.extraHeaders).length > 0 && (this.extraHeaders = o.extraHeaders), o.localAddress && (this.localAddress = o.localAddress)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingIntervalTimer = null, this.pingTimeoutTimer = null, this.open();
}
_t.priorWebsocketSuccess = !1;
d0(_t.prototype);
_t.protocol = ju.protocol;
_t.Socket = _t;
_t.Transport = ys();
_t.transports = Eo;
_t.parser = Sn;
_t.prototype.createTransport = function(r) {
  qt('creating transport "%s"', r);
  var o = m0(this.query);
  o.EIO = ju.protocol, o.transport = r;
  var n = this.transportOptions[r] || {};
  this.id && (o.sid = this.id);
  var s = new p0[r]({
    query: o,
    socket: this,
    agent: n.agent || this.agent,
    hostname: n.hostname || this.hostname,
    port: n.port || this.port,
    secure: n.secure || this.secure,
    path: n.path || this.path,
    forceJSONP: n.forceJSONP || this.forceJSONP,
    jsonp: n.jsonp || this.jsonp,
    forceBase64: n.forceBase64 || this.forceBase64,
    enablesXDR: n.enablesXDR || this.enablesXDR,
    withCredentials: n.withCredentials || this.withCredentials,
    timestampRequests: n.timestampRequests || this.timestampRequests,
    timestampParam: n.timestampParam || this.timestampParam,
    policyPort: n.policyPort || this.policyPort,
    pfx: n.pfx || this.pfx,
    key: n.key || this.key,
    passphrase: n.passphrase || this.passphrase,
    cert: n.cert || this.cert,
    ca: n.ca || this.ca,
    ciphers: n.ciphers || this.ciphers,
    rejectUnauthorized: n.rejectUnauthorized || this.rejectUnauthorized,
    perMessageDeflate: n.perMessageDeflate || this.perMessageDeflate,
    extraHeaders: n.extraHeaders || this.extraHeaders,
    forceNode: n.forceNode || this.forceNode,
    localAddress: n.localAddress || this.localAddress,
    requestTimeout: n.requestTimeout || this.requestTimeout,
    protocols: n.protocols || void 0,
    isReactNative: this.isReactNative
  });
  return s;
};
function m0(r) {
  var o = {};
  for (var n in r)
    r.hasOwnProperty(n) && (o[n] = r[n]);
  return o;
}
_t.prototype.open = function() {
  var r;
  if (this.rememberUpgrade && _t.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1)
    r = "websocket";
  else if (this.transports.length === 0) {
    var o = this;
    setTimeout(function() {
      o.emit("error", "No transports available");
    }, 0);
    return;
  } else
    r = this.transports[0];
  this.readyState = "opening";
  try {
    r = this.createTransport(r);
  } catch (n) {
    this.transports.shift(), this.open();
    return;
  }
  r.open(), this.setTransport(r);
};
_t.prototype.setTransport = function(r) {
  qt("setting transport %s", r.name);
  var o = this;
  this.transport && (qt("clearing existing transport %s", this.transport.name), this.transport.removeAllListeners()), this.transport = r, r.on("drain", function() {
    o.onDrain();
  }).on("packet", function(n) {
    o.onPacket(n);
  }).on("error", function(n) {
    o.onError(n);
  }).on("close", function() {
    o.onClose("transport close");
  });
};
_t.prototype.probe = function(r) {
  qt('probing transport "%s"', r);
  var o = this.createTransport(r, { probe: 1 }), n = !1, s = this;
  _t.priorWebsocketSuccess = !1;
  function c() {
    if (s.onlyBinaryUpgrades) {
      var d = !this.supportsBinary && s.transport.supportsBinary;
      n = n || d;
    }
    n || (qt('probe transport "%s" opened', r), o.send([{ type: "ping", data: "probe" }]), o.once("packet", function(l) {
      if (!n)
        if (l.type === "pong" && l.data === "probe") {
          if (qt('probe transport "%s" pong', r), s.upgrading = !0, s.emit("upgrading", o), !o)
            return;
          _t.priorWebsocketSuccess = o.name === "websocket", qt('pausing current transport "%s"', s.transport.name), s.transport.pause(function() {
            n || s.readyState !== "closed" && (qt("changing transport and sending upgrade packet"), m(), s.setTransport(o), o.send([{ type: "upgrade" }]), s.emit("upgrade", o), o = null, s.upgrading = !1, s.flush());
          });
        } else {
          qt('probe transport "%s" failed', r);
          var u = new Error("probe error");
          u.transport = o.name, s.emit("upgradeError", u);
        }
    }));
  }
  function f() {
    n || (n = !0, m(), o.close(), o = null);
  }
  function g(d) {
    var l = new Error("probe error: " + d);
    l.transport = o.name, f(), qt('probe transport "%s" failed because of error: %s', r, d), s.emit("upgradeError", l);
  }
  function y() {
    g("transport closed");
  }
  function _() {
    g("socket closed");
  }
  function p(d) {
    o && d.name !== o.name && (qt('"%s" works - aborting "%s"', d.name, o.name), f());
  }
  function m() {
    o.removeListener("open", c), o.removeListener("error", g), o.removeListener("close", y), s.removeListener("close", _), s.removeListener("upgrading", p);
  }
  o.once("open", c), o.once("error", g), o.once("close", y), this.once("close", _), this.once("upgrading", p), o.open();
};
_t.prototype.onOpen = function() {
  if (qt("socket open"), this.readyState = "open", _t.priorWebsocketSuccess = this.transport.name === "websocket", this.emit("open"), this.flush(), this.readyState === "open" && this.upgrade && this.transport.pause) {
    qt("starting upgrade probes");
    for (var r = 0, o = this.upgrades.length; r < o; r++)
      this.probe(this.upgrades[r]);
  }
};
_t.prototype.onPacket = function(r) {
  if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
    switch (qt('socket receive: type "%s", data "%s"', r.type, r.data), this.emit("packet", r), this.emit("heartbeat"), r.type) {
      case "open":
        this.onHandshake(JSON.parse(r.data));
        break;
      case "pong":
        this.setPing(), this.emit("pong");
        break;
      case "error":
        var o = new Error("server error");
        o.code = r.data, this.onError(o);
        break;
      case "message":
        this.emit("data", r.data), this.emit("message", r.data);
        break;
    }
  else
    qt('packet received with socket readyState "%s"', this.readyState);
};
_t.prototype.onHandshake = function(r) {
  this.emit("handshake", r), this.id = r.sid, this.transport.query.sid = r.sid, this.upgrades = this.filterUpgrades(r.upgrades), this.pingInterval = r.pingInterval, this.pingTimeout = r.pingTimeout, this.onOpen(), this.readyState !== "closed" && (this.setPing(), this.removeListener("heartbeat", this.onHeartbeat), this.on("heartbeat", this.onHeartbeat));
};
_t.prototype.onHeartbeat = function(r) {
  clearTimeout(this.pingTimeoutTimer);
  var o = this;
  o.pingTimeoutTimer = setTimeout(function() {
    o.readyState !== "closed" && o.onClose("ping timeout");
  }, r || o.pingInterval + o.pingTimeout);
};
_t.prototype.setPing = function() {
  var r = this;
  clearTimeout(r.pingIntervalTimer), r.pingIntervalTimer = setTimeout(function() {
    qt("writing ping packet - expecting pong within %sms", r.pingTimeout), r.ping(), r.onHeartbeat(r.pingTimeout);
  }, r.pingInterval);
};
_t.prototype.ping = function() {
  var r = this;
  this.sendPacket("ping", function() {
    r.emit("ping");
  });
};
_t.prototype.onDrain = function() {
  this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emit("drain") : this.flush();
};
_t.prototype.flush = function() {
  this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length && (qt("flushing %d packets in socket", this.writeBuffer.length), this.transport.send(this.writeBuffer), this.prevBufferLen = this.writeBuffer.length, this.emit("flush"));
};
_t.prototype.write = _t.prototype.send = function(r, o, n) {
  return this.sendPacket("message", r, o, n), this;
};
_t.prototype.sendPacket = function(r, o, n, s) {
  if (typeof o == "function" && (s = o, o = void 0), typeof n == "function" && (s = n, n = null), !(this.readyState === "closing" || this.readyState === "closed")) {
    n = n || {}, n.compress = n.compress !== !1;
    var c = {
      type: r,
      data: o,
      options: n
    };
    this.emit("packetCreate", c), this.writeBuffer.push(c), s && this.once("flush", s), this.flush();
  }
};
_t.prototype.close = function() {
  if (this.readyState === "opening" || this.readyState === "open") {
    this.readyState = "closing";
    var r = this;
    this.writeBuffer.length ? this.once("drain", function() {
      this.upgrading ? s() : o();
    }) : this.upgrading ? s() : o();
  }
  function o() {
    r.onClose("forced close"), qt("socket closing - telling transport to close"), r.transport.close();
  }
  function n() {
    r.removeListener("upgrade", n), r.removeListener("upgradeError", n), o();
  }
  function s() {
    r.once("upgrade", n), r.once("upgradeError", n);
  }
  return this;
};
_t.prototype.onError = function(r) {
  qt("socket error %j", r), _t.priorWebsocketSuccess = !1, this.emit("error", r), this.onClose("transport error", r);
};
_t.prototype.onClose = function(r, o) {
  if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
    qt('socket close with reason: "%s"', r);
    var n = this;
    clearTimeout(this.pingIntervalTimer), clearTimeout(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), this.readyState = "closed", this.id = null, this.emit("close", r, o), n.writeBuffer = [], n.prevBufferLen = 0;
  }
};
_t.prototype.filterUpgrades = function(r) {
  for (var o = [], n = 0, s = r.length; n < s; n++)
    ~y0(this.transports, r[n]) && o.push(r[n]);
  return o;
};
hs.exports = g0;
hs.exports.parser = Sn;
var b0 = hs.exports, Du = { exports: {} }, _0 = k0;
function k0(r, o) {
  var n = [];
  o = o || 0;
  for (var s = o || 0; s < r.length; s++)
    n[s - o] = r[s];
  return n;
}
var Pu = w0;
function w0(r, o, n) {
  return r.on(o, n), {
    destroy: function() {
      r.removeListener(o, n);
    }
  };
}
var cu = [].slice, Mu = function(r, o) {
  if (typeof o == "string" && (o = r[o]), typeof o != "function")
    throw new Error("bind() requires a function");
  var n = cu.call(arguments, 2);
  return function() {
    return o.apply(r, n.concat(cu.call(arguments)));
  };
};
(function(r, o) {
  var n = wo, s = zn, c = _0, f = Pu, g = Mu, y = Qe("socket.io-client:socket"), _ = Vn, p = Cu;
  r.exports = l;
  var m = {
    connect: 1,
    connect_error: 1,
    connect_timeout: 1,
    connecting: 1,
    disconnect: 1,
    error: 1,
    reconnect: 1,
    reconnect_attempt: 1,
    reconnect_failed: 1,
    reconnect_error: 1,
    reconnecting: 1,
    ping: 1,
    pong: 1
  }, d = s.prototype.emit;
  function l(u, k, C) {
    this.io = u, this.nsp = k, this.json = this, this.ids = 0, this.acks = {}, this.receiveBuffer = [], this.sendBuffer = [], this.connected = !1, this.disconnected = !0, this.flags = {}, C && C.query && (this.query = C.query), this.io.autoConnect && this.open();
  }
  s(l.prototype), l.prototype.subEvents = function() {
    if (!this.subs) {
      var u = this.io;
      this.subs = [
        f(u, "open", g(this, "onopen")),
        f(u, "packet", g(this, "onpacket")),
        f(u, "close", g(this, "onclose"))
      ];
    }
  }, l.prototype.open = l.prototype.connect = function() {
    return this.connected ? this : (this.subEvents(), this.io.reconnecting || this.io.open(), this.io.readyState === "open" && this.onopen(), this.emit("connecting"), this);
  }, l.prototype.send = function() {
    var u = c(arguments);
    return u.unshift("message"), this.emit.apply(this, u), this;
  }, l.prototype.emit = function(u) {
    if (m.hasOwnProperty(u))
      return d.apply(this, arguments), this;
    var k = c(arguments), C = {
      type: (this.flags.binary !== void 0 ? this.flags.binary : p(k)) ? n.BINARY_EVENT : n.EVENT,
      data: k
    };
    return C.options = {}, C.options.compress = !this.flags || this.flags.compress !== !1, typeof k[k.length - 1] == "function" && (y("emitting packet with ack id %d", this.ids), this.acks[this.ids] = k.pop(), C.id = this.ids++), this.connected ? this.packet(C) : this.sendBuffer.push(C), this.flags = {}, this;
  }, l.prototype.packet = function(u) {
    u.nsp = this.nsp, this.io.packet(u);
  }, l.prototype.onopen = function() {
    if (y("transport is open - connecting"), this.nsp !== "/")
      if (this.query) {
        var u = typeof this.query == "object" ? _.encode(this.query) : this.query;
        y("sending connect packet with query %s", u), this.packet({ type: n.CONNECT, query: u });
      } else
        this.packet({ type: n.CONNECT });
  }, l.prototype.onclose = function(u) {
    y("close (%s)", u), this.connected = !1, this.disconnected = !0, delete this.id, this.emit("disconnect", u);
  }, l.prototype.onpacket = function(u) {
    var k = u.nsp === this.nsp, C = u.type === n.ERROR && u.nsp === "/";
    if (!(!k && !C))
      switch (u.type) {
        case n.CONNECT:
          this.onconnect();
          break;
        case n.EVENT:
          this.onevent(u);
          break;
        case n.BINARY_EVENT:
          this.onevent(u);
          break;
        case n.ACK:
          this.onack(u);
          break;
        case n.BINARY_ACK:
          this.onack(u);
          break;
        case n.DISCONNECT:
          this.ondisconnect();
          break;
        case n.ERROR:
          this.emit("error", u.data);
          break;
      }
  }, l.prototype.onevent = function(u) {
    var k = u.data || [];
    y("emitting event %j", k), u.id != null && (y("attaching ack callback to event"), k.push(this.ack(u.id))), this.connected ? d.apply(this, k) : this.receiveBuffer.push(k);
  }, l.prototype.ack = function(u) {
    var k = this, C = !1;
    return function() {
      if (!C) {
        C = !0;
        var S = c(arguments);
        y("sending ack %j", S), k.packet({
          type: p(S) ? n.BINARY_ACK : n.ACK,
          id: u,
          data: S
        });
      }
    };
  }, l.prototype.onack = function(u) {
    var k = this.acks[u.id];
    typeof k == "function" ? (y("calling ack %s with %j", u.id, u.data), k.apply(this, u.data), delete this.acks[u.id]) : y("bad ack %s", u.id);
  }, l.prototype.onconnect = function() {
    this.connected = !0, this.disconnected = !1, this.emitBuffered(), this.emit("connect");
  }, l.prototype.emitBuffered = function() {
    var u;
    for (u = 0; u < this.receiveBuffer.length; u++)
      d.apply(this, this.receiveBuffer[u]);
    for (this.receiveBuffer = [], u = 0; u < this.sendBuffer.length; u++)
      this.packet(this.sendBuffer[u]);
    this.sendBuffer = [];
  }, l.prototype.ondisconnect = function() {
    y("server disconnect (%s)", this.nsp), this.destroy(), this.onclose("io server disconnect");
  }, l.prototype.destroy = function() {
    if (this.subs) {
      for (var u = 0; u < this.subs.length; u++)
        this.subs[u].destroy();
      this.subs = null;
    }
    this.io.destroy(this);
  }, l.prototype.close = l.prototype.disconnect = function() {
    return this.connected && (y("performing disconnect (%s)", this.nsp), this.packet({ type: n.DISCONNECT })), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }, l.prototype.compress = function(u) {
    return this.flags.compress = u, this;
  }, l.prototype.binary = function(u) {
    return this.flags.binary = u, this;
  };
})(Du);
var qu = Du.exports, S0 = Kn;
function Kn(r) {
  r = r || {}, this.ms = r.min || 100, this.max = r.max || 1e4, this.factor = r.factor || 2, this.jitter = r.jitter > 0 && r.jitter <= 1 ? r.jitter : 0, this.attempts = 0;
}
Kn.prototype.duration = function() {
  var r = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var o = Math.random(), n = Math.floor(o * this.jitter * r);
    r = Math.floor(o * 10) & 1 ? r + n : r - n;
  }
  return Math.min(r, this.max) | 0;
};
Kn.prototype.reset = function() {
  this.attempts = 0;
};
Kn.prototype.setMin = function(r) {
  this.ms = r;
};
Kn.prototype.setMax = function(r) {
  this.max = r;
};
Kn.prototype.setJitter = function(r) {
  this.jitter = r;
};
var E0 = b0, C0 = qu, A0 = zn, T0 = wo, un = Pu, Fn = Mu, Gt = Qe("socket.io-client:manager"), Fu = Uu, x0 = S0, Wu = Object.prototype.hasOwnProperty, uu = wt;
function wt(r, o) {
  if (!(this instanceof wt))
    return new wt(r, o);
  r && typeof r == "object" && (o = r, r = void 0), o = o || {}, o.path = o.path || "/socket.io", this.nsps = {}, this.subs = [], this.opts = o, this.reconnection(o.reconnection !== !1), this.reconnectionAttempts(o.reconnectionAttempts || 1 / 0), this.reconnectionDelay(o.reconnectionDelay || 1e3), this.reconnectionDelayMax(o.reconnectionDelayMax || 5e3), this.randomizationFactor(o.randomizationFactor || 0.5), this.backoff = new x0({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  }), this.timeout(o.timeout == null ? 2e4 : o.timeout), this.readyState = "closed", this.uri = r, this.connecting = [], this.lastPing = null, this.encoding = !1, this.packetBuffer = [];
  var n = o.parser || T0;
  this.encoder = new n.Encoder(), this.decoder = new n.Decoder(), this.autoConnect = o.autoConnect !== !1, this.autoConnect && this.open();
}
wt.prototype.emitAll = function() {
  this.emit.apply(this, arguments);
  for (var r in this.nsps)
    Wu.call(this.nsps, r) && this.nsps[r].emit.apply(this.nsps[r], arguments);
};
wt.prototype.updateSocketIds = function() {
  for (var r in this.nsps)
    Wu.call(this.nsps, r) && (this.nsps[r].id = this.generateId(r));
};
wt.prototype.generateId = function(r) {
  return (r === "/" ? "" : r + "#") + this.engine.id;
};
A0(wt.prototype);
wt.prototype.reconnection = function(r) {
  return arguments.length ? (this._reconnection = !!r, this) : this._reconnection;
};
wt.prototype.reconnectionAttempts = function(r) {
  return arguments.length ? (this._reconnectionAttempts = r, this) : this._reconnectionAttempts;
};
wt.prototype.reconnectionDelay = function(r) {
  return arguments.length ? (this._reconnectionDelay = r, this.backoff && this.backoff.setMin(r), this) : this._reconnectionDelay;
};
wt.prototype.randomizationFactor = function(r) {
  return arguments.length ? (this._randomizationFactor = r, this.backoff && this.backoff.setJitter(r), this) : this._randomizationFactor;
};
wt.prototype.reconnectionDelayMax = function(r) {
  return arguments.length ? (this._reconnectionDelayMax = r, this.backoff && this.backoff.setMax(r), this) : this._reconnectionDelayMax;
};
wt.prototype.timeout = function(r) {
  return arguments.length ? (this._timeout = r, this) : this._timeout;
};
wt.prototype.maybeReconnectOnOpen = function() {
  !this.reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
};
wt.prototype.open = wt.prototype.connect = function(r, o) {
  if (Gt("readyState %s", this.readyState), ~this.readyState.indexOf("open"))
    return this;
  Gt("opening %s", this.uri), this.engine = E0(this.uri, this.opts);
  var n = this.engine, s = this;
  this.readyState = "opening", this.skipReconnect = !1;
  var c = un(n, "open", function() {
    s.onopen(), r && r();
  }), f = un(n, "error", function(_) {
    if (Gt("connect_error"), s.cleanup(), s.readyState = "closed", s.emitAll("connect_error", _), r) {
      var p = new Error("Connection error");
      p.data = _, r(p);
    } else
      s.maybeReconnectOnOpen();
  });
  if (this._timeout !== !1) {
    var g = this._timeout;
    Gt("connect attempt will timeout after %d", g), g === 0 && c.destroy();
    var y = setTimeout(function() {
      Gt("connect attempt timed out after %d", g), c.destroy(), n.close(), n.emit("error", "timeout"), s.emitAll("connect_timeout", g);
    }, g);
    this.subs.push({
      destroy: function() {
        clearTimeout(y);
      }
    });
  }
  return this.subs.push(c), this.subs.push(f), this;
};
wt.prototype.onopen = function() {
  Gt("open"), this.cleanup(), this.readyState = "open", this.emit("open");
  var r = this.engine;
  this.subs.push(un(r, "data", Fn(this, "ondata"))), this.subs.push(un(r, "ping", Fn(this, "onping"))), this.subs.push(un(r, "pong", Fn(this, "onpong"))), this.subs.push(un(r, "error", Fn(this, "onerror"))), this.subs.push(un(r, "close", Fn(this, "onclose"))), this.subs.push(un(this.decoder, "decoded", Fn(this, "ondecoded")));
};
wt.prototype.onping = function() {
  this.lastPing = /* @__PURE__ */ new Date(), this.emitAll("ping");
};
wt.prototype.onpong = function() {
  this.emitAll("pong", /* @__PURE__ */ new Date() - this.lastPing);
};
wt.prototype.ondata = function(r) {
  this.decoder.add(r);
};
wt.prototype.ondecoded = function(r) {
  this.emit("packet", r);
};
wt.prototype.onerror = function(r) {
  Gt("error", r), this.emitAll("error", r);
};
wt.prototype.socket = function(r, o) {
  var n = this.nsps[r];
  if (!n) {
    n = new C0(this, r, o), this.nsps[r] = n;
    var s = this;
    n.on("connecting", c), n.on("connect", function() {
      n.id = s.generateId(r);
    }), this.autoConnect && c();
  }
  function c() {
    ~Fu(s.connecting, n) || s.connecting.push(n);
  }
  return n;
};
wt.prototype.destroy = function(r) {
  var o = Fu(this.connecting, r);
  ~o && this.connecting.splice(o, 1), !this.connecting.length && this.close();
};
wt.prototype.packet = function(r) {
  Gt("writing packet %j", r);
  var o = this;
  r.query && r.type === 0 && (r.nsp += "?" + r.query), o.encoding ? o.packetBuffer.push(r) : (o.encoding = !0, this.encoder.encode(r, function(n) {
    for (var s = 0; s < n.length; s++)
      o.engine.write(n[s], r.options);
    o.encoding = !1, o.processPacketQueue();
  }));
};
wt.prototype.processPacketQueue = function() {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var r = this.packetBuffer.shift();
    this.packet(r);
  }
};
wt.prototype.cleanup = function() {
  Gt("cleanup");
  for (var r = this.subs.length, o = 0; o < r; o++) {
    var n = this.subs.shift();
    n.destroy();
  }
  this.packetBuffer = [], this.encoding = !1, this.lastPing = null, this.decoder.destroy();
};
wt.prototype.close = wt.prototype.disconnect = function() {
  Gt("disconnect"), this.skipReconnect = !0, this.reconnecting = !1, this.readyState === "opening" && this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.engine && this.engine.close();
};
wt.prototype.onclose = function(r) {
  Gt("onclose"), this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.emit("close", r), this._reconnection && !this.skipReconnect && this.reconnect();
};
wt.prototype.reconnect = function() {
  if (this.reconnecting || this.skipReconnect)
    return this;
  var r = this;
  if (this.backoff.attempts >= this._reconnectionAttempts)
    Gt("reconnect failed"), this.backoff.reset(), this.emitAll("reconnect_failed"), this.reconnecting = !1;
  else {
    var o = this.backoff.duration();
    Gt("will wait %dms before reconnect attempt", o), this.reconnecting = !0;
    var n = setTimeout(function() {
      r.skipReconnect || (Gt("attempting reconnect"), r.emitAll("reconnect_attempt", r.backoff.attempts), r.emitAll("reconnecting", r.backoff.attempts), !r.skipReconnect && r.open(function(s) {
        s ? (Gt("reconnect attempt error"), r.reconnecting = !1, r.reconnect(), r.emitAll("reconnect_error", s.data)) : (Gt("reconnect success"), r.onreconnect());
      }));
    }, o);
    this.subs.push({
      destroy: function() {
        clearTimeout(n);
      }
    });
  }
};
wt.prototype.onreconnect = function() {
  var r = this.backoff.attempts;
  this.reconnecting = !1, this.backoff.reset(), this.updateSocketIds(), this.emitAll("reconnect", r);
};
(function(r, o) {
  var n = cm, s = wo, c = uu, f = Qe("socket.io-client");
  r.exports = o = y;
  var g = o.managers = {};
  function y(_, p) {
    typeof _ == "object" && (p = _, _ = void 0), p = p || {};
    var m = n(_), d = m.source, l = m.id, u = m.path, k = g[l] && u in g[l].nsps, C = p.forceNew || p["force new connection"] || p.multiplex === !1 || k, S;
    return C ? (f("ignoring socket cache for %s", d), S = c(d, p)) : (g[l] || (f("new io instance for %s", d), g[l] = c(d, p)), S = g[l]), m.query && !p.query && (p.query = m.query), S.socket(m.path, p);
  }
  o.protocol = s.protocol, o.connect = y, o.Manager = uu, o.Socket = qu;
})(es, es.exports);
var O0 = es.exports;
const N0 = /* @__PURE__ */ $g(O0);
let lo;
const B0 = new Uint8Array(16);
function R0() {
  if (!lo && (lo = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !lo))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return lo(B0);
}
const Kt = [];
for (let r = 0; r < 256; ++r)
  Kt.push((r + 256).toString(16).slice(1));
function I0(r, o = 0) {
  return Kt[r[o + 0]] + Kt[r[o + 1]] + Kt[r[o + 2]] + Kt[r[o + 3]] + "-" + Kt[r[o + 4]] + Kt[r[o + 5]] + "-" + Kt[r[o + 6]] + Kt[r[o + 7]] + "-" + Kt[r[o + 8]] + Kt[r[o + 9]] + "-" + Kt[r[o + 10]] + Kt[r[o + 11]] + Kt[r[o + 12]] + Kt[r[o + 13]] + Kt[r[o + 14]] + Kt[r[o + 15]];
}
const L0 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), fu = {
  randomUUID: L0
};
function U0(r, o, n) {
  if (fu.randomUUID && !o && !r)
    return fu.randomUUID();
  r = r || {};
  const s = r.random || (r.rng || R0)();
  if (s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, o) {
    n = n || 0;
    for (let c = 0; c < 16; ++c)
      o[n + c] = s[c];
    return o;
  }
  return I0(s);
}
function j0(r, o) {
  const n = o.map((c) => JSON.stringify(c)).join(" "), s = (/* @__PURE__ */ new Date()).toISOString();
  return JSON.stringify({
    level: r,
    time: s,
    message: n
  });
}
function D0(r) {
  const o = String(r[0]), n = r.slice(1);
  return {
    level: o,
    logs: n
  };
}
function P0(r, o) {
  const n = JSON.parse(r);
  return o.forEach((s) => delete n[s]), n;
}
function M0(r) {
  if (typeof r == "object" && r !== null)
    return r;
  try {
    return JSON.parse(r);
  } catch (o) {
    return { extraData: r };
  }
}
function q0(r) {
  const o = /\(([^)]+)\)/, n = r.match(o);
  if (n && n[1]) {
    const s = n[1].split(";");
    for (let c of s)
      if (c = c.trim(), c.startsWith("Windows") || c.startsWith("Macintosh") || c.startsWith("Linux"))
        return c;
  }
  return "Unknown";
}
function hu(r) {
  return (...o) => new Promise((n, s) => {
    try {
      const c = r(...o);
      n(c);
    } catch (c) {
      s(c);
    }
  });
}
const F0 = {
  reconnection: !0,
  reconnectionDelay: 5e3,
  reconnectionAttempts: 10,
  //perMessageDeflate: false,
  upgrade: !1,
  transports: ["websocket"],
  debug: !1
}, Gi = {
  logToConsole: !0,
  overloadGlobalConsole: !1,
  socketEmitInterval: 6e4
};
let ue = console;
class W0 {
  /**
   * Initialize storage logger
   * @param options The configuration of the logger.
   */
  constructor(o) {
    Mt(this, "logToConsole"), Mt(this, "overloadGlobalConsole"), Mt(this, "system"), Mt(this, "socketEmitInterval"), Mt(this, "storageId"), Mt(this, "emitInProgress"), Mt(this, "queue"), Mt(this, "processing"), Mt(this, "interval"), Mt(this, "logIndex"), Mt(this, "socket"), Mt(this, "staticObject", {}), Mt(this, "isGetItemAsync"), Mt(this, "isSetItemAsync"), Mt(this, "getItem"), Mt(this, "setItem"), Mt(this, "parseLog"), Mt(this, "_logMethod"), Mt(this, "_warnMethod"), Mt(this, "_errorMethod"), Mt(this, "_debugMethod");
    const { loggerOptions: n } = o;
    if (!n.system)
      throw new Error("Config property 'system' should be provided!");
    this.isGetItemAsync = n.isGetItemAsync || !1, this.isSetItemAsync = n.isSetItemAsync || !1, this.setupStorageFunctions(n.getItem, n.setItem, n.parseLog), this.system = n.system, this.socketEmitInterval = n.socketEmitInterval || Gi.socketEmitInterval, this.logToConsole = n.logToConsole !== void 0 ? n.logToConsole : Gi.logToConsole, this.overloadGlobalConsole = n.overloadGlobalConsole !== void 0 ? n.overloadGlobalConsole : Gi.overloadGlobalConsole, this.storageId = this.getStorageName(), this.queue = [], this.processing = !1, this.emitInProgress = !1, this.logIndex = 0, this.init(o);
  }
  /**
   * Used to setup storage functions and logs parser function.
   * @param getItemFunction Function for getting item from storage.
   * @param setItemFunction Function for setting item to storage.
   * @param parseLogFunction Function for parsing logs.
   * @return void
   */
  setupStorageFunctions(o, n, s) {
    this.getItem = o && typeof o == "function" ? this.isGetItemAsync ? o : hu(o) : this.defaultGetItemFunction, this.setItem = n && typeof n == "function" ? this.isSetItemAsync ? n : hu(n) : this.defaultSetItemFunction, this.parseLog = s && typeof s == "function" ? s : j0;
  }
  /**
   * Used to initialize logger. Initializes storage, establishes socket connection and overloads console if needed
   * @param options The logger config.
   * @return void
   */
  init(o) {
    const { socket: n, url: s, socketOptions: c = {} } = o;
    this._logMethod = ue.log.bind(ue), this._warnMethod = ue.warn.bind(ue), this._errorMethod = ue.error.bind(ue), this._debugMethod = ue.debug.bind(ue), this.initStorage().then(() => {
      if (n)
        this.socket = n;
      else if (s)
        this.socket = this.createConnection(s, c);
      else
        throw new Error("Must provide either a 'socket' or a 'url' for socket connection");
      this.interval = setInterval(() => Nt(this, null, function* () {
        yield this.emitLogs();
      }), this.socketEmitInterval), this.overloadGlobalConsole && this._overloadConsole();
    });
  }
  /**
   * Used to initialize new socket connection
   * @param url The url used for the socket connection.
   * @param options The options used for the socket connection.
   * @return void
   */
  createConnection(o, n = {}) {
    const s = kt(kt({}, F0), n);
    return N0(o, s);
  }
  /**
   * Emits stored logs to the server and clears the log storage in case the emit operation was successful
   * @return {Promise<void>}
   */
  emitLogs() {
    return Nt(this, null, function* () {
      if (!this.emitInProgress)
        try {
          const o = yield this.getItem(this.storageId);
          if (!o)
            return;
          const n = [];
          this.emitInProgress = !0;
          const s = JSON.parse(o), c = Object.keys(s);
          if (!c.length)
            return;
          if (!this.socket || !this.socket.connected)
            throw new Error("Socket is disconnected");
          for (const y of c) {
            const _ = M0(s[y]), p = kt(kt(kt({}, this.populateMetaData()), this.staticObject), _);
            yield this.socket.emit("Log", JSON.stringify(p)), n.push(y);
          }
          const f = yield this.getItem(this.storageId);
          if (!f)
            return;
          const g = P0(f, n);
          yield this.setItem(this.storageId, JSON.stringify(g));
        } catch (o) {
          this._errorMethod(o);
        } finally {
          this.emitInProgress = !1;
        }
    });
  }
  /**
   /**
   * Used to set a static object which will be send in every message
   * @return void
   */
  setupStaticFields(o) {
    this.staticObject = kt({}, o);
  }
  /**
   * Used to populate sending message object with static client parameters
   * @return object
   */
  populateMetaData() {
    const o = /* @__PURE__ */ new Date();
    let n;
    typeof window < "u" && typeof window.document < "u" ? n = window == null ? void 0 : window.navigator.userAgent : typeof self < "u" && self.navigator && (n = self.navigator.userAgent);
    let s;
    return n && (s = q0(n)), {
      System: this.system,
      DateTime: o,
      UserAgent: n,
      OSVersion: s
    };
  }
  /**
   * Used to interrupt socket connection
   * @return void
   */
  disconnectSocket() {
    !this.socket || !this.interval || (this.socket.disconnect(), clearInterval(this.interval));
  }
  /**
   * Used to overload the global console object by logger methods.
   * @return void
   */
  _overloadConsole() {
    ue = Object.assign(
      ue,
      {
        log: (o) => {
          this.log(o);
        },
        warn: (o) => {
          this.warn(o);
        },
        error: (o) => {
          this.error(o);
        },
        debug: (o) => {
          this.debug(o);
        }
      }
    );
  }
  /**
   * Used to initialize the storage if it wasn't created before.
   * @return void
   */
  initStorage() {
    return Nt(this, null, function* () {
      const o = yield this.getItem(this.storageId);
      (!o || typeof o != "string") && (yield this.setItem(this.storageId, JSON.stringify({})));
    });
  }
  /**
   * Reset log storage
   * @return void
   */
  resetStorage() {
    return Nt(this, null, function* () {
      yield this.setItem(this.storageId, JSON.stringify({}));
    });
  }
  /**
   * Get storage name which is used to access the logs storage
   * @return string
   */
  getStorageName() {
    const o = U0();
    return this.system.toString().toUpperCase() + o + Date.now();
  }
  /**
   * Does common logic for logging data.
   * @param args The arguments of the log where the first argument contains the log level and other
   * arguments are logs to be stored
   * @return void
   */
  processLog(...o) {
    return Nt(this, null, function* () {
      try {
        if (o.length < 2)
          return;
        const n = yield this.getItem(this.storageId);
        if (!n)
          return;
        const { level: s, logs: c } = D0(o), f = JSON.parse(n), g = this.formItemKey(s);
        f[g] = this.parseLog(s, c), yield this.setItem(this.storageId, JSON.stringify(f));
      } catch (n) {
        this._errorMethod(n);
      }
    });
  }
  /**
   * Used to process logs queue.
   * @return Promise<void>
   */
  processQueue() {
    return Nt(this, null, function* () {
      if (this.processing || this.queue.length === 0)
        return;
      const o = this.queue.shift();
      o && (this.processing = !0, yield this.processLog(...o).finally(() => {
        this.processing = !1, this.processQueue();
      }));
    });
  }
  /**
   * Logs info data into the storage
   * @param args The arguments to be logged.
   * @return void
   */
  log(o) {
    const n = ["INFO", o];
    this.queue.push(n), this.logToConsole && this._logMethod.apply(ue, [o]), this.processQueue();
  }
  /**
   * Logs warn data into the storage
   * @param args The arguments to be logged.
   * @return void
   */
  warn(o) {
    const n = ["WARN", o];
    this.queue.push(n), this.logToConsole && this._warnMethod.apply(ue, [o]), this.processQueue();
  }
  /**
   * Logs error data into the storage
   * @param args The arguments to be logged.
   * @return void
   */
  error(o) {
    const n = ["ERROR", o];
    this.queue.push(n), this.logToConsole && this._errorMethod.apply(ue, [o]), this.processQueue();
  }
  /**
   * Logs debug data into the storage
   * @param args The arguments to be logged.
   * @return void
   */
  debug(o) {
    const n = ["DEBUG", o];
    this.queue.push(n), this.logToConsole && this._debugMethod.apply(ue, [o]), this.processQueue();
  }
  /**
   * The default method for getting logs from storage
   * @param storageId The identifier of storage where logs are stored.
   * @return string || null
   */
  defaultGetItemFunction(o) {
    return Nt(this, null, function* () {
      return localStorage.getItem(o);
    });
  }
  /**
   * The default method for setting logs into the storage
   * @param storageId The identifier of storage where to store the logs.
   * @param logs The logs to be stored.
   * @return void
   */
  defaultSetItemFunction(o, n) {
    return Nt(this, null, function* () {
      try {
        localStorage.setItem(o, n);
      } catch (s) {
        this._errorMethod(s);
      }
    });
  }
  /**
   * Used to form a key which will be used to store a log in the storage
   * @param level The log level. For example: Info, Warn, Error etc..
   * @return string
   */
  formItemKey(o) {
    const n = (/* @__PURE__ */ new Date()).toISOString();
    return this.logIndex++, `${o}-${this.system}-${n}-${this.logIndex}`;
  }
}
class z0 {
  constructor(o) {
    xt(this, "storageLogger"), this.eventsSdkClass = o, this.eventsSdkClass = o;
  }
  init() {
    if (!this.eventsSdkClass.options.useLogger)
      return;
    if (this.eventsSdkClass.options.storageLoggerInstance) {
      this.storageLogger = this.eventsSdkClass.options.storageLoggerInstance;
      return;
    }
    let o;
    this.eventsSdkClass.options.loggerSocketConnection && (o = this.eventsSdkClass.options.loggerSocketConnection), this.eventsSdkClass.socketIoClass.ioFunction && !o && (o = this.eventsSdkClass.socketIoClass.ioFunction(
      this.eventsSdkClass.options.loggerServer,
      this.eventsSdkClass.options.loggerConnectOptions
    )), o && (this.storageLogger = new W0({
      socket: o,
      loggerOptions: this.eventsSdkClass.options.loggerConfig
    }));
  }
  log(o) {
    this.storageLogger ? o.Level === vr.INFO ? this.storageLogger.log(o) : o.Level === vr.ERROR && this.storageLogger.error(o) : o.Level === vr.INFO ? console.log(o) : o.Level === vr.ERROR && console.error(o);
  }
}
class V0 {
  constructor(o) {
    xt(this, "listeners", {
      [lt.ALL_EXTENSION_STATUS]: [],
      [lt.ALL_DIALER_STATUS]: [],
      [lt.ALL_USERS_STATUS]: [],
      [lt.QUEUE_EVENT]: [],
      [lt.EXTENSION_EVENT]: [],
      [lt.DIALER_EVENT]: [],
      [lt.LOGIN_SUCCESS]: [],
      [lt.LOGIN_STATUS]: [],
      [lt.KEEP_ALIVE_RESPONSE]: [],
      [lt.ONLINE_STATUS_EVENT]: [],
      [lt.EXTENSIONS_UPDATED]: []
    }), xt(this, "allListeners", []), this.eventsSdkClass = o, this.eventsSdkClass = o;
  }
  on(o, n) {
    o === "*" ? this.allListeners.push(n) : this.listeners[o].push(n);
  }
  off(o, n) {
    if (o === "*")
      this.allListeners = this.allListeners.filter((s) => s !== n);
    else {
      const s = this.listeners[o].filter((c) => c !== n);
      this.listeners = ce(kt({}, this.listeners), {
        [o]: s
      });
    }
  }
  emit(o, n) {
    this.eventsSdkClass.socketIoClass.lastEventTimestamp = (/* @__PURE__ */ new Date()).getTime(), this.listeners[o].forEach((c) => c({
      name: o,
      data: n
    }));
    const s = {
      name: o,
      data: n
    };
    this.allListeners.forEach((c) => c(s));
  }
}
class J0 {
  constructor(o) {
    xt(this, "argumentOptions"), xt(this, "options"), xt(this, "servers", []), xt(this, "URLList", []), xt(this, "server"), xt(this, "URL"), xt(this, "socket"), xt(this, "mainServer"), xt(this, "alreadyAttemptedOtherServers", []), xt(this, "authClass", new jg(this)), xt(this, "socketIoClass", new Xg(this)), xt(this, "loggerClass", new z0(this)), xt(this, "eventEmitterClass", new V0(this)), xt(this, "reconnectOptions"), xt(this, "retryConnection"), this.options = kt(kt({}, Pg), o), this.reconnectOptions = {
      retryCount: 1,
      maxReconnectAttempts: this.options.maxReconnectAttempts,
      reconnectionDelay: this.options.reconnectionDelay,
      // 10 seconds. After each re-connection attempt this number will increase (minReconnectionDelay * attempts) => 10, 20, 30, 40 seconds ... up to 5min
      minReconnectionDelay: this.options.reconnectionDelay,
      // 10 seconds
      maxReconnectionDelay: 6e4 * 5
      // 5 minutes
    }, this.server = this.options.fallbackServer, this.retryConnection = Dg.debounce(this.connect.bind(this), this.reconnectOptions.reconnectionDelay, {
      leading: !0,
      trailing: !1
    }), this.argumentOptions = kt({}, o);
  }
  on(o, n) {
    this.eventEmitterClass.on(o, n);
  }
  emit(o, ...n) {
    this.socketIoClass.io && this.socketIoClass.io.emit(o, ...n);
  }
  connect(o) {
    o === wn.MAIN && this.findMainServer(), o === wn.NEXT && this.findNextServer(), this.socketIoClass.doReconnect = !0, this.socketIoClass.initSocketConnection(), this.socketIoClass.initSocketEvents(), this.socketIoClass.initKeepAlive(), this.loggerClass.init();
  }
  disconnect() {
    this.socketIoClass.doReconnect = !1, this.socketIoClass.closeAllConnections();
  }
  clearKeepAliveInterval() {
    this.socketIoClass.clearKeepAliveInterval();
  }
  findMainServer() {
    this.servers.length ? (this.mainServer = this.servers.reduce((o, n) => n.Priority > o.Priority ? n : o), this.server = this.mainServer) : this.URLList.length && (this.URL = this.URLList[0]);
  }
  findNextServer() {
    if (this.servers.length)
      if (this.server.Priority === this.mainServer.Priority) {
        let o = this.servers.filter(
          (n) => n.Priority !== this.mainServer.Priority && this.alreadyAttemptedOtherServers.indexOf(n.Priority) + 1 === 0
        );
        o.length || (this.alreadyAttemptedOtherServers = [], o = this.servers.filter(
          (n) => n.Priority !== this.mainServer.Priority && this.alreadyAttemptedOtherServers.indexOf(n.Priority) + 1 === 0
        )), o.length && (this.server = o.reduce((n, s) => s.Priority > n.Priority ? s : n), this.alreadyAttemptedOtherServers.push(this.server.Priority));
      } else
        this.server = this.mainServer;
    else if (this.URLList.length)
      if (this.URL === this.URLList[0]) {
        let o = this.URLList.filter(
          (n) => n !== this.URLList[0] && this.alreadyAttemptedOtherServers.indexOf(n) + 1 === 0
        );
        o.length || (this.alreadyAttemptedOtherServers = [], o = this.URLList.filter(
          (n) => n !== this.URLList[0] && this.alreadyAttemptedOtherServers.indexOf(n) + 1 === 0
        )), o.length && (this.URL = o[0], this.alreadyAttemptedOtherServers.push(this.URL));
      } else
        this.URL = this.URLList[0];
  }
  init() {
    return Nt(this, null, function* () {
      return this.socket, yield this.authClass.login(this.options), this.getServers(), !0;
    });
  }
  getServers() {
    this.options.serverFetchStrategy === "static" && this.argumentOptions.servers && Array.isArray(this.argumentOptions.servers) && this.argumentOptions.servers.length > 1 && (this.servers = this.argumentOptions.servers);
  }
}
const lu = {
  CALLING: 100,
  HOLD: 101
}, X0 = 180 * 60 * 1e3, K0 = 2, H0 = "hold", dr = {
  SET_EXTENSIONS: "SET_EXTENSIONS",
  UPDATE_EXTENSIONS: "UPDATE_EXTENSIONS",
  SET_SERVER_TIME: "SET_SERVER_TIME"
};
function $0(r) {
  const o = (r.callstatus || "").toLowerCase();
  return r.answered && o === H0;
}
const Y0 = {
  namespaced: !0,
  state: {
    extensions: [],
    serverTime: null,
    serverDelta: 0,
    serverOffset: 0
  },
  mutations: {
    [dr.SET_EXTENSIONS]: (r, o) => {
      r.extensions = o;
    },
    [dr.UPDATE_EXTENSIONS]: (r, { index: o, extension: n }) => {
      r.extensions.splice(o, 1, n);
    },
    [dr.SET_SERVER_TIME]: (r, o) => {
      r.serverOffset = o.servertimeoffset * 60 * 1e3 || X0, r.serverTime = o.servertime * 1e3 - r.serverOffset, r.serverDelta = (/* @__PURE__ */ new Date()).getTime() - r.serverTime;
    }
  },
  actions: {
    setExtensions(n, s) {
      return Nt(this, arguments, function* ({ commit: r }, o) {
        r(dr.SET_EXTENSIONS, o);
      });
    },
    updateExtension(n, s) {
      return Nt(this, arguments, function* ({ commit: r }, o) {
        r(dr.UPDATE_EXTENSIONS, o);
      });
    }
  },
  getters: {
    extensionsWithCalls: (r) => (o) => {
      const n = [];
      return r.extensions.forEach((s) => {
        s.calls && s.calls.length > 0 && (s.calls.filter($0).length ? s.representativeStatus = lu.HOLD : s.representativeStatus = lu.CALLING), n.push(s);
      }), o ? n.filter((s) => s.representativeStatus !== K0) : n;
    },
    extensionCountByStatus: (r, o) => (n) => o.extensionsWithCalls.filter((s) => s.representativeStatus === n).length || 0
  }
}, po = {
  SET_QUEUES: "SET_QUEUES",
  UPDATE_QUEUES: "UPDATE_QUEUES"
}, Q0 = {
  namespaced: !0,
  state: {
    all: []
  },
  mutations: {
    [po.SET_QUEUES]: (r, o) => {
      r.all = o;
    },
    [po.UPDATE_QUEUES]: (r, { index: o, queue: n }) => {
      r.all.splice(o, 1, n);
    }
  },
  actions: {
    setQueues(n, s) {
      return Nt(this, arguments, function* ({ commit: r }, o) {
        r(po.SET_QUEUES, o);
      });
    },
    updateQueue(n, s) {
      return Nt(this, arguments, function* ({ commit: r }, o) {
        r(po.UPDATE_QUEUES, o);
      });
    }
  },
  getters: {
    queueWithActiveCalls: (r) => r.all.filter((o) => o.Calls.length),
    allQueueCalls: (r, o) => {
      const n = [];
      return o.queueWithActiveCalls.forEach((s) => {
        const c = s.Calls || [];
        n.push(...c);
      }), n;
    },
    filterQueuesByIds: (r) => (o) => !o || !Array.isArray(o) ? r.all : r.all.filter((n) => o.includes(n.QueueID))
  }
}, yo = {
  SET_DIALERS: "SET_DIALERS",
  UPDATE_DIALERS: "UPDATE_DIALERS"
}, G0 = {
  namespaced: !0,
  state: {
    all: []
  },
  mutations: {
    [yo.SET_DIALERS]: (r, o) => {
      r.all = o;
    },
    [yo.UPDATE_DIALERS]: (r, { index: o, dialer: n }) => {
      r.all.splice(o, 1, n);
    }
  },
  actions: {
    setDialers(n, s) {
      return Nt(this, arguments, function* ({ commit: r }, o) {
        r(yo.SET_DIALERS, o);
      });
    },
    updateDialers(n, s) {
      return Nt(this, arguments, function* ({ commit: r }, o) {
        r(yo.UPDATE_DIALERS, o);
      });
    }
  },
  getters: {
    getAllDialers: (r) => r.all,
    getAllDialersWithTypeIVR: (r) => r.all.filter((o) => o.type === "IVR"),
    getAllDialersWithTypeAUTOMATIC: (r) => r.all.filter((o) => o.type === "Automatic")
  }
}, Z0 = {
  SET_IS_SOCKET_OFFLINE: "SET_IS_SOCKET_OFFLINE"
}, t1 = {
  namespaced: !0,
  state: {
    isSocketOffline: !1,
    offlineSocketTimestamp: null
  },
  mutations: {
    [Z0.SET_IS_SOCKET_OFFLINE]: (r, o) => {
      r.isSocketOffline = o, o ? r.offlineSocketTimestamp = (/* @__PURE__ */ new Date()).getTime() : r.offlineSocketTimestamp = null;
    }
  },
  getters: {
    isSocketOffline: (r) => r.isSocketOffline,
    offlineSocketTimestamp: (r) => r.offlineSocketTimestamp
  }
}, e1 = {
  extensionsModuleName: "sdkExtensions",
  queuesModuleName: "sdkQueues",
  dialersModuleName: "sdkDialers",
  globalStateModuleName: "sdkGlobalState"
};
class r1 {
  constructor(o, n) {
    if (this.handleLocalEvents = !1, !o.store)
      throw new Error("'store' options was not provided!");
    const s = kt(kt({}, e1), o);
    this.store = s.store, this.extensionsModuleName = s.extensionsModuleName, this.queuesModuleName = s.queuesModuleName, this.dialersModuleName = s.dialersModuleName, this.globalStateModuleName = s.globalStateModuleName, this.sdkOptions = kt({}, n), this.registerExtensionsModule(), this.registerQueueModule(), this.registerDialerModule(), this.registerGlobalStateModule();
  }
  getStoreModule(o) {
    return this.store.state[o];
  }
  onEvent(o) {
    const n = this.store, s = this.extensionsModuleName, c = this.queuesModuleName, f = this.dialersModuleName, g = this.globalStateModuleName;
    switch (o.name) {
      case lt.ONLINE_STATUS_EVENT:
        n.commit(`${g}/SET_IS_SOCKET_OFFLINE`, !o.data.isSocketConnected);
        break;
      case lt.ALL_EXTENSION_STATUS:
        n.dispatch(`${s}/setExtensions`, o.data.extensions);
        break;
      case lt.EXTENSION_EVENT:
        const y = o.data.data, p = this.getStoreModule(s).extensions.findIndex((S) => S.number === y.number);
        p !== -1 && n.dispatch(`${s}/updateExtension`, {
          index: p,
          extension: y
        });
        break;
      case lt.LOGIN_STATUS:
        n.commit(`${s}/SET_SERVER_TIME`, o.data), n.dispatch(`${c}/setQueues`, o.data.queues);
        break;
      case lt.QUEUE_EVENT:
        const m = o.data.data, l = (this.getStoreModule(c).all || []).findIndex((S) => S.QueueID === m.QueueID);
        l !== -1 && n.dispatch(`${c}/updateQueue`, {
          index: l,
          queue: m
        });
        break;
      case lt.ALL_DIALER_STATUS:
        n.dispatch(`${f}/setDialers`, o.data.dialers);
        break;
      case lt.DIALER_EVENT:
        const u = o.data.data, C = (this.getStoreModule(f).all || []).findIndex((S) => S.campaignID === u.campaignID);
        C !== -1 && n.dispatch(`${f}/updateDialers`, {
          index: C,
          dialer: u
        });
        break;
    }
  }
  init() {
    return Nt(this, null, function* () {
      const o = new J0(this.sdkOptions);
      return yield o.init(), o.on("*", (n) => {
        this.onEvent(n);
      }), o;
    });
  }
  validateStoreModule(o) {
    return this.store ? (this.store.state[o] && this.store.unregisterModule(o), !0) : !1;
  }
  registerExtensionsModule() {
    this.validateStoreModule(this.extensionsModuleName) && (this.store.registerModule(this.extensionsModuleName, Y0), this.handleLocalEvents = !0);
  }
  registerQueueModule() {
    this.validateStoreModule(this.queuesModuleName) && (this.store.registerModule(this.queuesModuleName, Q0), this.handleLocalEvents = !0);
  }
  registerDialerModule() {
    this.validateStoreModule(this.dialersModuleName) && (this.store.registerModule(this.dialersModuleName, G0), this.handleLocalEvents = !0);
  }
  registerGlobalStateModule() {
    this.validateStoreModule(this.globalStateModuleName) && (this.store.registerModule(this.globalStateModuleName, t1), this.handleLocalEvents = !0);
  }
}
export {
  r1 as default
};
